var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _g, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _g2, _path388, _path389, _path390, _path391, _g3, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProdred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 632,
    height: 531,
    viewBox: "0 0 632 531",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M622.671 130.525L597.935 116.256L564.576 111.1L531.2 116.256L506.464 130.525L497.135 150.607L506.448 170.689L531.2 184.975L564.576 190.114L597.951 184.975L622.671 170.689L632 150.607L622.671 130.525Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M564.576 188.522L597.409 183.431V174.614L579.588 176.321L564.576 179.687V188.522Z",
    fill: "#ABA59E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M564.576 179.687L545.44 174.942L531.742 174.614L529.344 176.354L531.742 183.431L564.576 188.522V179.687Z",
    fill: "#B5AFA7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M507.696 169.556L531.742 183.431V174.614L516.664 161.97L507.696 160.755V169.556Z",
    fill: "#C7C0B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M507.696 160.755L505.511 150.098L498.892 141.806V150.607L507.696 169.556V160.755Z",
    fill: "#D8D1C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M621.439 169.556L597.409 183.431V174.614L609.695 164.302L621.439 160.755V169.556Z",
    fill: "#A39C95"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M621.439 160.755L623.311 150.492L630.226 141.806V150.607L621.439 169.556V160.755Z",
    fill: "#948E87"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M531.742 174.614L507.696 160.738L498.892 141.789L507.696 122.84L531.742 108.965L564.576 103.891L597.393 108.965L621.439 122.84L630.243 141.789L621.439 160.738L597.409 174.614L564.576 179.688L531.742 174.614Z",
    fill: "#F4EFE9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M534.666 169.868L533.516 170.525V171.445L534.666 172.085H536.259L537.376 171.445V170.525L536.259 169.868H534.666Z",
    fill: "#948E87"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M593.615 169.868L592.482 170.525V171.445L593.615 172.085H595.208L596.358 171.445V170.525L595.208 169.868H593.615Z",
    fill: "#948E87"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M624.707 139.934H623.098L621.964 140.574V141.51L623.098 142.167H624.707L625.841 141.51V140.574L624.707 139.934Z",
    fill: "#948E87"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M594.321 113.284L595.471 112.643V111.707L594.321 111.051H592.728L591.611 111.707V112.643L592.728 113.284H594.321Z",
    fill: "#948E87"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M534.666 111.051L533.516 111.707V112.643L534.666 113.284H536.259L537.376 112.643V111.707L536.259 111.051H534.666Z",
    fill: "#948E87"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M504.427 141.051L503.31 141.707V142.627L504.427 143.284H506.037L507.17 142.627V141.707L506.037 141.051H504.427Z",
    fill: "#948E87"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M516.976 148.998L515.843 149.655V150.591L516.976 151.247H518.602L519.719 150.591V149.655L518.602 148.998H516.976Z",
    fill: "#948E87"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M535.454 151.083V150.164L534.321 149.507H532.727L531.594 150.164V151.083L532.727 151.724H534.321L535.454 151.083Z",
    fill: "#948E87"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M534.584 123.448L535.717 122.791V121.855L534.584 121.198H532.99L531.857 121.855V122.791L532.99 123.448H534.584Z",
    fill: "#948E87"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M582.068 115.681L580.935 116.338V117.241L582.068 117.898H583.661L584.795 117.241V116.338L583.661 115.681H582.068Z",
    fill: "#948E87"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M610.106 131.74L608.972 132.397V133.317L610.106 133.973H611.715L612.832 133.317V132.397L611.715 131.74H610.106Z",
    fill: "#948E87"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M593.533 132.824V133.76L594.666 134.417H596.276L597.409 133.76V132.824L596.276 132.167H594.666L593.533 132.824Z",
    fill: "#948E87"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M598.542 159.638L597.409 160.279V161.215L598.542 161.871H600.152L601.269 161.215V160.279L600.152 159.638H598.542Z",
    fill: "#948E87"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M594.338 150.624L593.221 151.28V152.2L594.338 152.857H595.947L597.081 152.2V151.28L595.947 150.624H594.338Z",
    fill: "#948E87"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M548.479 166.633L547.346 167.29V168.21L548.479 168.866H550.089L551.206 168.21V167.29L550.089 166.633H548.479Z",
    fill: "#948E87"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M555.098 159.638L553.981 160.279V161.215L555.098 161.871H556.708L557.841 161.215V160.279L556.708 159.638H555.098Z",
    fill: "#948E87"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M553.981 121.905H548.66V131.001H553.981V121.905Z",
    fill: "#948E87"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M558.088 120.673L559.944 125.714L556.921 134.138L551.321 137.372L553.324 123.415L555 120.673H558.088Z",
    fill: "#A39C95"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M579.095 122.397H575.498V130.492H579.095V122.397Z",
    fill: "#D8D1C7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M571.063 120.673L569.01 126.831L572.213 134.138L577.83 137.372L575.81 123.415L573.609 120.459L571.063 120.673Z",
    fill: "#C7C0B8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M564.576 119.671L563.032 124.909L564.576 135.763L572.213 134.138L571.063 120.673L567.647 118.538L564.576 119.671Z",
    fill: "#B5AFA7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M564.576 119.671V135.763L556.921 134.138L558.088 120.673L561.488 118.538L564.576 119.671Z",
    fill: "#ABA59E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M580.475 118.538H549.924V136.272H580.475V118.538Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M591.053 150.624L579.867 157.093L572.624 137.192L587.078 134.663L591.053 150.624Z",
    fill: "#A39C95"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M587.078 134.663L588.375 128.505L590.56 127.175L595.142 141.806L591.053 150.624L587.078 134.663Z",
    fill: "#948E87"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M564.576 159.441L579.867 157.093L577.568 140.147L577.173 136.962L564.576 142.167V159.441Z",
    fill: "#ABA59E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M538.082 150.624L549.284 157.093L554.835 138.128L542.057 134.663L538.082 150.624Z",
    fill: "#C7C0B8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M542.057 134.663L538.575 127.175L533.992 141.806L538.082 150.624L542.057 134.663Z",
    fill: "#D8D1C7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M564.576 142.167L551.386 136.256L551.567 140.147L549.284 157.093L564.576 159.441V142.167Z",
    fill: "#B5AFA7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M587.078 119.671L577.568 114.171L564.576 112.167L551.567 114.171L542.057 119.671L538.575 127.175L542.04 134.663L551.567 140.147L564.576 142.151L577.568 140.147L587.078 134.663L590.56 127.175L587.078 119.671ZM575.827 130.936L571.08 133.678L564.576 134.679L558.088 133.678L553.324 130.936L551.583 127.192L553.324 123.432L558.088 120.689L564.576 119.688L571.063 120.689L575.81 123.432L577.551 127.192L575.81 130.952L575.827 130.936Z",
    fill: "#F4EFE9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M566.924 115.55V116.666L566.711 116.798L565.545 116.108H563.59L562.424 116.798L562.227 116.666V115.55L563.59 114.762H565.545L566.924 115.55Z",
    fill: "#948E87"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M566.711 116.798L565.545 117.471H563.59L562.424 116.798L563.59 116.108H565.545L566.711 116.798Z",
    fill: "#362C29"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M583.776 121.264V122.397L583.579 122.512L582.413 121.806H580.475L579.259 122.512L579.079 122.397V121.264L580.475 120.459H582.413L583.776 121.264Z",
    fill: "#948E87"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M583.579 122.512L582.413 123.202H580.475L579.259 122.512L580.475 121.806H582.413L583.579 122.512Z",
    fill: "#362C29"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M549.924 121.264V122.397L549.744 122.512L548.545 121.806H546.607L545.408 122.512L545.227 122.397V121.264L546.607 120.459H548.545L549.924 121.264Z",
    fill: "#948E87"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M549.744 122.512L548.545 123.202H546.607L545.408 122.512L546.607 121.806H548.545L549.744 122.512Z",
    fill: "#362C29"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M583.776 132.052V133.185L583.579 133.3L582.413 132.627H580.475L579.259 133.3L579.079 133.185V132.052L580.475 131.248H582.413L583.776 132.052Z",
    fill: "#948E87"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M583.579 133.3L582.413 133.973H580.475L579.259 133.3L580.475 132.627H582.413L583.579 133.3Z",
    fill: "#362C29"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M549.924 132.052V133.185L549.744 133.3L548.545 132.627H546.607L545.408 133.3L545.227 133.185V132.052L546.607 131.248H548.545L549.924 132.052Z",
    fill: "#948E87"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M549.744 133.3L548.545 133.973H546.607L545.408 133.3L546.607 132.627H548.545L549.744 133.3Z",
    fill: "#362C29"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M566.924 137.767V138.883L566.711 139.014L565.545 138.325H563.59L562.424 139.014L562.227 138.883V137.767L563.59 136.962H565.545L566.924 137.767Z",
    fill: "#948E87"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M566.711 139.014L565.545 139.671H563.59L562.424 139.014L563.59 138.325H565.545L566.711 139.014Z",
    fill: "#362C29"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M254.833 53.7929L232.857 41.1165L202.027 58.8996L179.032 45.632L38.533 126.732L61.5279 140L0.903381 174.991L22.88 187.684L83.5046 152.692L107.501 166.535L248.001 85.4349L224.004 71.5925L254.833 53.7929Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M188.444 79.7206L177.11 73.1689L169.095 59.2937V46.2067L177.11 41.5762L188.444 48.1279L196.459 62.003V75.09L188.444 79.7206Z",
    fill: "#362C29"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M249.394 12.9421L188.45 48.1038L196.463 61.9843L257.407 26.8226L249.394 12.9421Z",
    fill: "#B5AFA7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M257.379 39.8848V26.7979L196.459 62.003V75.09L257.379 39.8848Z",
    fill: "#A39C95"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M238.031 6.37109L249.364 12.9228L188.444 48.1279L177.11 41.5762L238.031 6.37109Z",
    fill: "#E6E1DD"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4276 78.1279L34.9031 83.054V106.831L43.4276 121.592L74.6022 145.714L105.777 157.586L114.301 152.66V128.883L105.777 114.121L74.6022 89.9998L43.4276 78.1279Z",
    fill: "#D8D1C7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M209.977 11.8718L241.151 35.9768L105.777 114.121L74.6022 89.9997L209.977 11.8718Z",
    fill: "#C7C0B8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M241.168 36.0136L105.78 114.126L114.31 128.902L249.698 50.79L241.168 36.0136Z",
    fill: "#B5AFA7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M249.676 50.7388V74.5154L114.301 152.66V128.883L249.676 50.7388Z",
    fill: "#A39C95"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M178.802 0L209.977 11.8719L74.6022 89.9997L43.4276 78.1278L178.802 0Z",
    fill: "#E6E1DD"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1261 132.922L62.612 108.768L0.903381 144.433L1.69178 157.06L57.1261 132.922Z",
    fill: "#A39C95"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6419 134.023L62.612 121.855L1.69177 157.06L8.72166 170.18L69.6419 134.023Z",
    fill: "#B5AFA7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6419 134.022L80.9751 140.558L18.6916 176.075L8.72165 169.228L69.6419 134.022Z",
    fill: "#E6E1DD"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.34389 140.492L0.952656 144.811L0.903381 157.06L8.34389 169.458L18.9544 175.829L26.2307 172.052L26.5592 159.359L19.053 146.453L8.34389 140.492Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3486 145.73L8.01539 139.178L0 143.809V156.896L8.01539 170.771L19.3486 177.306L27.364 172.692V159.605L19.3486 145.73ZM25.6722 170.903L18.6423 174.958L8.70523 169.228L1.69177 157.077V145.615L8.70523 141.559L18.6423 147.29L25.6722 159.441V170.903Z",
    fill: "#D8D1C7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2819 110.532L19.3383 145.694L27.3512 159.574L88.2949 124.413L80.2819 110.532Z",
    fill: "#B5AFA7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2842 137.487V124.4L27.364 159.605V172.692L88.2842 137.487Z",
    fill: "#A39C95"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9356 103.973L80.2688 110.525L19.3486 145.73L8.01538 139.179L68.9356 103.973Z",
    fill: "#E6E1DD"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M376.887 76.8963L372.026 74.0884L348.965 87.4053L338.157 81.182L141.764 194.548L168.011 209.687L364.421 96.3215L353.81 90.2131L376.887 76.8963Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M349.54 67.0275L347.076 65.6154L345.335 62.5941V59.7533L347.076 58.7517L349.54 60.1639L351.281 63.1852V66.0259L349.54 67.0275Z",
    fill: "#574943"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M376.411 48.6697L374.67 45.6648L350.755 57.7666L349.54 60.1639L351.281 63.1853L353.794 63.1524L376.411 48.6697Z",
    fill: "#B5AFA7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M376.411 51.5104V48.6697L351.281 63.1852V66.0259L376.411 51.5104Z",
    fill: "#A39C95"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M372.19 44.2527L374.67 45.6648L349.54 60.164L347.076 58.7518L372.19 44.2527Z",
    fill: "#D8D1C7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M334.38 86.5841L326.43 82.0029L320.813 72.2656V63.0867L326.43 59.8354L334.38 64.4331L340.013 74.1704V83.3329L334.38 86.5841Z",
    fill: "#574943"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M356.373 64.7287L350.755 54.9915L338.272 56.6992L334.38 64.4331L340.013 74.1704L348.127 74.0719L356.373 64.7287Z",
    fill: "#B5AFA7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M356.373 73.8913V64.7288L340.013 74.1704V83.333L356.373 73.8913Z",
    fill: "#A39C95"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M342.806 50.3774L350.755 54.9916L334.38 64.4332L326.43 59.8355L342.806 50.3774Z",
    fill: "#D8D1C7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M309.578 100.903L301.628 96.3215L296.011 86.5842V77.3889L301.628 74.1541L309.578 78.7353L315.212 88.489V97.6515L309.578 100.903Z",
    fill: "#574943"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M339.997 74.1703L334.38 64.4331L320.287 67.0768L309.578 78.7352L315.212 88.4889L330.125 84.4659L339.997 74.1703Z",
    fill: "#211A1A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M340.013 83.3329L339.997 74.1704L315.212 88.4889V97.6515L340.013 83.3329Z",
    fill: "#0A0808"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M326.43 59.8354L334.38 64.4331L309.578 78.7352L301.628 74.154L326.43 59.8354Z",
    fill: "#574943"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M311.73 121.724L292.578 110.673L279.044 87.2247V65.123L292.578 57.3069L311.73 68.3742L325.28 91.8224L325.264 113.908L311.73 121.724Z",
    fill: "#362C29"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M328.598 89.9012L315.047 66.453L303.813 61.8882L311.73 68.3742L325.28 91.8224L326.923 101.904L328.598 89.9012Z",
    fill: "#211A1A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M328.598 112.003V89.9011L325.28 91.8223L325.264 113.908L328.598 112.003Z",
    fill: "#0A0808"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M295.912 55.3857L315.047 66.453L311.73 68.3742L292.578 57.3069L295.912 55.3857Z",
    fill: "#574943"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M183.352 173.76L175.402 169.178L169.785 159.441V150.262L175.402 147.011L183.352 151.609L188.986 161.329V170.525L183.352 173.76Z",
    fill: "#362C29"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M311.746 90.4758L306.112 80.7385L215.873 127.356L183.352 151.609L188.986 161.329L225.712 144.728L311.746 90.4758Z",
    fill: "#211A1A"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M311.746 99.6548V90.4758L188.986 161.329V170.525L311.746 99.6548Z",
    fill: "#0A0808"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M298.179 76.1409L306.112 80.7386L183.352 151.609L175.402 147.011L298.179 76.1409Z",
    fill: "#574943"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M184.748 158.292L173.136 151.576H156.694L145.082 158.292V167.766L156.694 174.482H173.136L184.748 167.766V158.292Z",
    fill: "#574943"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M173.136 174.482H156.694V185.911H173.136V174.482Z",
    fill: "#211A1A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M184.748 179.195L173.136 185.894V174.482L184.748 167.766V179.195Z",
    fill: "#0A0808"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M145.082 179.195L156.694 185.894V174.482L145.082 167.766V179.195Z",
    fill: "#362C29"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M501.52 69.9998L523.792 57.1427L519.111 54.4333L496.839 67.2904L486.425 61.297L423.452 97.6352L404.81 86.8799L400.326 89.4579L418.968 100.213L296.881 170.706L322.209 185.303L444.295 114.844L463.595 125.977L468.079 123.399L448.779 112.266L511.753 75.9111L501.52 69.9998Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M521.148 41.609L518.536 40.0984L516.697 36.9128V33.9079L518.536 32.8406L521.148 34.3512L522.987 37.5368V40.5417L521.148 41.609Z",
    fill: "#D8D1C7"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M526.371 35.5828L524.531 32.3972L521.148 34.3512L522.987 37.5368L526.371 35.5828Z",
    fill: "#B5AFA7"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M526.371 38.5877V35.5828L522.987 37.5368V40.5417L526.371 38.5877Z",
    fill: "#A39C95"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M521.936 30.8865L524.531 32.3971L521.148 34.3512L518.536 32.8405L521.936 30.8865Z",
    fill: "#E6E1DD"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M507.663 47.6022L505.955 46.6334L504.739 44.5316V42.5776L505.955 41.8879L507.663 42.8567L508.878 44.9421V46.929L507.663 47.6022Z",
    fill: "#E6E1DD"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M520.621 35.3754L507.702 42.9226L508.92 45.0067L521.839 37.4595L520.621 35.3754Z",
    fill: "#B5AFA7"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M521.838 39.4414V37.4709L508.878 44.9422V46.929L521.838 39.4414Z",
    fill: "#A39C95"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M518.914 34.4004L520.622 35.3856L507.663 42.8568L505.955 41.8881L518.914 34.4004Z",
    fill: "#E6E1DD"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M483.584 63.6779L480.775 62.0688L478.804 58.6369V55.3857L480.775 54.2527L483.584 55.8619L485.555 59.3101V62.5449L483.584 63.6779Z",
    fill: "#E6E1DD"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M509.519 40.9359L483.594 55.9121L485.582 59.3528L511.508 44.3766L509.519 40.9359Z",
    fill: "#B5AFA7"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M511.506 47.5695V44.3347L485.555 59.31V62.5448L511.506 47.5695Z",
    fill: "#A39C95"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M506.71 39.2773L509.519 40.8865L483.584 55.8619L480.775 54.2527L506.71 39.2773Z",
    fill: "#E6E1DD"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M471.774 81.5761L463.348 76.7157L457.37 66.4037V56.6665L463.348 53.2346L471.774 58.095L477.737 68.407V78.1442L471.774 81.5761Z",
    fill: "#D8D1C7"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M482.699 51.7822L471.774 58.0857L477.734 68.4107L488.66 62.1073L482.699 51.7822Z",
    fill: "#B5AFA7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M488.659 71.8224V62.1016L477.737 68.407V78.1442L488.659 71.8224Z",
    fill: "#A39C95"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M474.271 46.9292L482.697 51.7896L471.774 58.095L463.348 53.2346L474.271 46.9292Z",
    fill: "#E6E1DD"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M445.757 94.2033L438.563 90.0325L433.455 81.1984V72.8733L438.563 69.9341L445.757 74.1048L450.849 82.9225V91.2476L445.757 94.2033Z",
    fill: "#574943"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M476.045 68.3905L470.937 59.5564L453.116 64.8602L445.757 74.1048L450.849 82.9225L462.675 81.9537L476.045 68.3905Z",
    fill: "#211A1A"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M476.045 76.7157V68.3906L450.849 82.9226V91.2477L476.045 76.7157Z",
    fill: "#0A0808"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M463.743 55.3857L470.937 59.5565L445.757 74.1049L438.563 69.9341L463.743 55.3857Z",
    fill: "#574943"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M452.557 116.83L426.047 101.527L407.306 69.0473V38.4399L426.047 27.6189L452.574 42.9226L471.315 75.3856V106.009L452.557 116.83Z",
    fill: "#574943"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M439.122 100.41L430.696 95.5662L424.75 85.2379V75.5171L430.696 72.0852L439.122 76.9456L445.084 87.2576V96.9784L439.122 100.41Z",
    fill: "#362C29"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M471.315 106.009L445.084 96.9783L439.122 100.41L452.557 116.83L471.315 106.009Z",
    fill: "#0A0808"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M445.084 96.9782V87.2574L471.315 75.3855V106.009L445.084 96.9782Z",
    fill: "#211A1A"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M445.084 87.2574L439.122 76.9455L452.574 42.9226L471.315 75.3856L445.084 87.2574Z",
    fill: "#362C29"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M426.047 101.527L430.696 95.5662L424.75 85.2378L407.306 69.0474L426.047 101.527Z",
    fill: "#0A0808"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M407.306 69.0474L424.75 85.2378V75.517L419.543 55.6648L407.306 38.4399V69.0474Z",
    fill: "#211A1A"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M424.75 75.5169L407.306 38.4399L426.047 27.6189L430.696 72.0851L424.75 75.5169Z",
    fill: "#362C29"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M439.122 76.9455L430.696 72.0851L426.047 27.6189L452.574 42.9226L439.122 76.9455Z",
    fill: "#574943"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M426.047 101.527L452.557 116.83L439.122 100.41L430.696 95.5662L426.047 101.527Z",
    fill: "#211A1A"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M454.761 41.6894L452.571 42.9541L471.326 75.416L473.516 74.1513L454.761 41.6894Z",
    fill: "#211A1A"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M473.532 104.729L473.515 74.1213L471.315 75.3857V106.01L473.532 104.729Z",
    fill: "#0A0808"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M428.265 26.3381L454.758 41.6583L452.574 42.9226L426.047 27.6189L428.265 26.3381Z",
    fill: "#362C29"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M428.183 106.732L419.773 101.872L413.811 91.5597V81.8225L419.757 78.3906L428.183 83.251L434.161 93.5794V103.3L428.183 106.732Z",
    fill: "#362C29"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M439.117 76.8969L428.179 83.2124L434.143 93.5354L445.081 87.2199L439.117 76.8969Z",
    fill: "#211A1A"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M445.084 96.9784V87.2576L434.161 93.5794V103.3L445.084 96.9784Z",
    fill: "#0A0808"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M430.696 72.0852L439.122 76.9456L428.183 83.251L419.757 78.3906L430.696 72.0852Z",
    fill: "#574943"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M346.961 151.231L339.751 147.06L334.642 138.226V129.901L339.751 126.962L346.961 131.133L352.053 139.95V148.275L346.961 151.231Z",
    fill: "#574943"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M431.993 93.8256L426.885 84.9915L369.693 113.021L346.961 131.133L352.053 139.95L379.253 130.098L431.993 93.8256Z",
    fill: "#211A1A"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M431.993 102.151V93.8257L352.053 139.95V148.275L431.993 102.151Z",
    fill: "#0A0808"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M419.691 80.8208L426.885 84.9916L346.961 131.133L339.751 126.962L419.691 80.8208Z",
    fill: "#574943"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M351.774 141.116L345.828 130.788L339.471 127.126L344.432 124.269L350.772 127.931L356.734 138.259V145.583L351.774 148.44V141.116Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M315.327 171.871L306.901 167.011L300.938 156.699V146.962L306.901 143.53L315.327 148.407L321.272 158.702V168.44L315.327 171.871Z",
    fill: "#362C29"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M354.615 139.474L348.669 129.146L315.327 148.407L321.272 158.702L354.615 139.474Z",
    fill: "#211A1A"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M354.615 149.195V139.474L321.272 158.702V168.44L354.615 149.195Z",
    fill: "#0A0808"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M340.243 124.285L348.669 129.146L315.327 148.407L306.901 143.53L340.243 124.285Z",
    fill: "#574943"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M503.393 400.015L524.416 387.881L518.651 384.547L497.627 396.682L487.789 391.017L457.255 408.636L467.077 414.317L444.92 427.109L450.685 430.442L472.842 417.634L482.681 423.316L513.215 405.697L503.393 400.015Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M518.093 380.458L514.759 378.521L512.41 374.449V370.606L514.759 369.243L518.093 371.165L520.442 375.253V379.096L518.093 380.458Z",
    fill: "#E6E1DD"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M522.576 368.586L518.097 371.176L520.457 375.255L524.936 372.666L522.576 368.586Z",
    fill: "#B5AFA7"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M524.926 376.501V372.659L520.442 375.253V379.096L524.926 376.501Z",
    fill: "#A39C95"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M519.243 366.666L522.56 368.587L518.093 371.165L514.759 369.244L519.243 366.666Z",
    fill: "#D8D1C7"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M501.389 388.652L498.793 387.142L496.954 383.973V380.968L498.793 379.917L501.389 381.411L503.228 384.597V387.585L501.389 388.652Z",
    fill: "#E6E1DD"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M517.509 372.137L501.391 381.437L503.222 384.608L519.34 375.309L517.509 372.137Z",
    fill: "#B5AFA7"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M519.341 378.291V375.286L503.228 384.596V387.585L519.341 378.291Z",
    fill: "#A39C95"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M514.906 370.606L517.502 372.117L501.389 381.411L498.793 379.917L514.906 370.606Z",
    fill: "#D8D1C7"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M475.092 418.488L465.057 412.692L457.961 400.409V388.816L465.057 384.728L475.092 390.508L482.188 402.807V414.383L475.092 418.488Z",
    fill: "#E6E1DD"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M504.719 373.414L475.1 390.502L482.194 402.79L511.812 385.701L504.719 373.414Z",
    fill: "#B5AFA7"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M511.818 397.289V385.713L482.188 402.807V414.383L511.818 397.289Z",
    fill: "#A39C95"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M494.687 367.618L504.723 373.414L475.092 390.508L465.057 384.728L494.687 367.618Z",
    fill: "#D8D1C7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.385 402.478L490.351 397.257L483.978 386.222V375.812L490.351 372.117L499.385 377.322L505.758 388.373V398.784L499.385 402.478Z",
    fill: "#F59C72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.248 375.692L499.36 377.358L505.742 388.408L508.629 386.741L502.248 375.692Z",
    fill: "#995D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.648 397.125V386.698L505.758 388.373V398.784L508.648 397.125Z",
    fill: "#87523B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.242 370.459L502.259 375.664L499.385 377.322L490.351 372.117L493.242 370.459Z",
    fill: "#B57355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.54 413.644L469.245 408.866L463.365 398.702V389.129L469.229 385.73L477.54 390.524L483.403 400.689V410.262L477.54 413.644Z",
    fill: "#FBE979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.587 378.36L477.535 390.511L483.407 400.679L504.459 388.528L498.587 378.36Z",
    fill: "#D6A950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.46 398.111V388.538L483.403 400.689V410.262L504.46 398.111Z",
    fill: "#CC934C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.302 373.579L498.596 378.373L477.54 390.524L469.229 385.73L490.302 373.579Z",
    fill: "#E3BD5E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M480.168 395.089L479.741 394.334L500.797 382.183L501.224 382.938L480.168 395.089Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M479.166 393.349L478.739 392.593L499.795 380.442L500.222 381.198L479.166 393.349Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M478.164 391.608L477.72 390.853L498.793 378.702L499.221 379.457L478.164 391.608Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M501.813 383.857L480.758 396.035L481.193 396.788L502.249 384.611L501.813 383.857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M482.188 398.57L481.744 397.815L502.801 385.647L503.228 386.403L482.188 398.57Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M503.802 387.357L482.754 399.516L483.19 400.269L504.238 388.111L503.802 387.357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M472.76 387.766L471.889 387.257L492.946 375.106L493.817 375.615L472.76 387.766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M470.756 386.616L469.886 386.107L490.942 373.956L491.813 374.449L470.756 386.616Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M476.784 390.081L475.914 389.588L496.97 377.421L497.841 377.93L476.784 390.081Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M474.78 388.932L473.893 388.423L494.95 376.271L495.837 376.781L474.78 388.932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M483.403 402.495V401.493L504.46 389.326V390.344L483.403 402.495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M483.403 407.125V406.124L504.46 393.973V394.974L483.403 407.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M483.403 404.81V403.808L504.46 391.657V392.659L483.403 404.81Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M483.403 409.457V408.439L504.46 396.288V397.289L483.403 409.457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.092 416.485L466.075 411.28L459.686 400.229V389.818L466.075 386.14L475.092 391.345L481.465 402.396V412.807L475.092 416.485Z",
    fill: "#F59C72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.972 389.708L475.085 391.375L481.466 402.424L484.353 400.757L477.972 389.708Z",
    fill: "#995D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.372 411.132L484.356 400.721L481.465 402.396V412.807L484.372 411.132Z",
    fill: "#87523B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.966 384.465L477.983 389.671L475.092 391.345L466.075 386.14L468.966 384.465Z",
    fill: "#B57355"
  }))), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M454.561 415.68L451.966 414.186L450.126 411V407.995L451.966 406.945L454.561 408.439L456.401 411.624V414.613L454.561 415.68Z",
    fill: "#E6E1DD"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M470.68 399.111L454.565 408.416L456.397 411.587L472.511 402.282L470.68 399.111Z",
    fill: "#B5AFA7"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M472.497 405.319V402.314L456.401 411.624V414.613L472.497 405.319Z",
    fill: "#A39C95"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M468.079 397.634L470.674 399.145L454.561 408.439L451.966 406.945L468.079 397.634Z",
    fill: "#D8D1C7"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M450.619 419.391L447.301 417.47L444.952 413.398V409.556L447.301 408.193L450.619 410.114L452.984 414.186V418.028L450.619 419.391Z",
    fill: "#E6E1DD"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M455.093 407.56L450.612 410.146L452.969 414.227L457.45 411.641L455.093 407.56Z",
    fill: "#B5AFA7"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M457.468 415.45V411.608L452.984 414.186V418.028L457.468 415.45Z",
    fill: "#A39C95"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M451.785 405.598L455.103 407.519L450.619 410.114L447.301 408.193L451.785 405.598Z",
    fill: "#D8D1C7"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M465.057 204.006L440.748 206.994L409.869 219.72L390.537 234.761L394.035 243.25L418.36 240.262L449.223 227.536L468.572 212.512L465.057 204.006Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M402.56 228.784L400.079 230.476L393.608 235.812V237.06L396.105 239.622L401.689 238.965L408.735 233.661L413.466 232.167L416.915 229.178L416.718 228.078L413.531 222.2L407.076 224.154L402.56 228.784Z",
    fill: "#FF8E1C"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M452.524 208.209L451.605 210.525L449.026 214.449L449.223 215.828L452.081 217.799L457.764 216.764L462.084 213.3L463.775 206.436L464.482 204.186L465.089 196.617L464.547 194.613L463.94 193.382L459.686 193.71L455.497 194.827L453.346 200.475L452.524 208.209Z",
    fill: "#FF8E1C"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M402.56 227.553L400.079 229.227L394.725 232.676L393.608 235.812L396.105 238.374L401.689 237.717L408.735 232.429L413.466 230.935L416.718 228.078L416.159 224.104L413.531 220.968L407.076 222.906L402.56 227.553Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M398.716 166.601L391.21 180.164L382.669 204.022L384.574 211.543L396.4 221.313L402.313 227.52L407.471 228.078L413.597 224.039L413.499 219.523L402.116 207.881L397.205 203.645L408.883 188.998L418.377 175.55V167.11L400.523 162.413L398.716 166.601Z",
    fill: "#FF3F3F"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 139.852H382.406V156.847H395.3V139.852Z",
    fill: "#C7A495"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M378.76 182.889L380.813 175.878L383.014 169.047L384.574 161.97L375.541 160.032L373.356 167.799L368.79 177.93L378.76 182.889Z",
    fill: "#F0C6B4"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M386.644 132.972L383.638 131.461L379.055 132.972L376.427 146.486L375.179 159.671L377.889 162.282L382.57 163.218L386.907 162.019L388.007 156.666L379.384 146.436L387.054 138.045L386.644 132.972Z",
    fill: "#F4EFE9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M418.853 145.862L407.832 140.558L402.297 136.092L395.086 133.563L385.034 132.972L381.93 135.106L380.205 149.326L385.034 156.026L385.691 156.978L392.491 162.118L403.545 165.32L421.81 166.633L424.684 160.311V152.676L418.853 145.911V145.862ZM393.789 152.627L389.157 155.878L386.02 153.251L383.392 143.973L387.909 140.541L391.736 142.463L393.805 147.323V152.627H393.789Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M452.524 206.978L451.605 209.293L449.436 211.346L449.026 214.449L452.081 216.567L457.764 215.533L461.476 212.052L463.168 205.205L463.874 202.939L464.482 195.385L463.94 193.382L462.133 192.282L459.078 192.462L455.497 193.595L453.346 199.228L452.524 206.978Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M405.22 161.937L393.477 160.623L385.675 156.962L393.953 165.04L405.976 168.981L414.616 173.201L417.26 175.747L420.726 176.962L422.138 188.899L430.039 212.758L437.085 213.694L449.765 207.881L455.793 205.911L459.078 202.61V196.699L455.185 193.316L448.615 195.451L440.271 196.288L440.748 168.505L439.154 160.344L435.393 153.284L424.585 147.75L415.65 142.676L409.146 140.229L403.693 135.714L395.07 133.563L403.217 137.717L409.688 144.367L417.818 147.175L422.385 152.545L423.452 156.486L422.385 160.246L419.51 162.495L414.336 162.972L405.22 161.937Z",
    fill: "#FF3F3F"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M368.084 148.193L369.036 150.558L372.239 153.596L372.929 153.875V158.045H374.834L375.968 157.52L378.908 159.671H381.486L387.022 153.94L387.252 149.819L388.812 147.586L388.894 145.697L389.157 144.236L379.795 140.558L367.722 146.715L368.084 148.193Z",
    fill: "#F0C6B4"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M377.741 131.658L375.541 130.246L375.721 131.658L372.338 132.069L373.389 132.676L369.003 135.977L366.983 140.673L367.886 140.016L366.983 144.203L367.64 148.899L368.396 147.668L370.843 150.394L375.163 150.87L374.506 149.688L377.232 148.472L378.415 148.423L380.862 148.981L383.014 148.653L384.377 148.702L385.133 147.996V146.206L386.907 144.614H388.418L388.894 145.697L389.88 145.648L390.339 144.236L389.354 139.162L386.677 135.55L383.868 133.07L380.862 131.839L380.944 130.722L377.741 131.658Z",
    fill: "#403531"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M408.325 142.167L402.625 144.942L399.899 148.554L399.997 154.449L403.102 162.413L399.554 162.019L396.252 154.449V147.159L399.817 142.315L405.828 139.326L408.325 142.167Z",
    fill: "#FF3F3F"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M372.945 201.395L372.518 206.518L371.089 209.293L368.281 212.906L367.591 210.607L368.905 208.062L368.527 207.142L366.408 208.111L364.289 210.607L363.025 214.022L361.136 214.696L359.592 208.669L361.809 203.546L366.162 199.556L367.919 197.865L372.945 198.62V201.395Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M368.79 177.93L366.162 199.556L369.611 199.523L372.157 200.164L372.945 201.395L375.376 191.937L378.76 182.889L376.378 177.339H374.21L368.79 177.93Z",
    fill: "#F0C6B4"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M381.913 206.469L375.343 210.311L371.861 214.367L371.089 219.26L373.832 221.92L379.844 221.592L380.599 219.014L386.939 212.528L387.186 210.607V207.93L385.067 205.484L381.913 206.469Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M401.426 175.599L399.587 183.448L395.07 188.899L388.024 199.425L381.913 206.469L384.64 207.881L387.186 210.607L398.733 201.017L404.662 194.252L408.883 186.929L412.497 179.441L407.766 172.545L401.426 175.599Z",
    fill: "#F0C6B4"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M412.743 148.21H409.08L406.075 151.313L404.465 156.289V161.658L400.999 175.09L403.627 178.193L409.688 180.164L414.435 178.932L418.196 162.775L418.377 155.73L416.603 150.87L412.743 148.21Z",
    fill: "#F4EFE9"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M323.276 232.265V217.996L305.8 207.914H281.081L263.588 217.996V232.265L281.081 242.347H305.8L323.276 232.265Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M308.28 213.825L313.158 218.423L320.353 222.939L321.42 226.272V227.339L318.874 229.605L314.472 229.884L308.921 226.65L304.831 223.103L300.807 222.2L297.473 220.558L296.126 218.21L296.274 217.159L299.312 212.331L308.28 213.825Z",
    fill: "#211A1A"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M280.867 220.377L282.838 225.27L287.289 232.479V233.53L284.415 235.911H279.487L274.938 233.382L268.318 221.099V220.049L280.867 220.377Z",
    fill: "#211A1A"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M308.28 212.758L313.158 217.372L320.353 221.871L321.42 224.531V226.272L318.874 228.554L314.472 228.817L308.921 225.582L304.831 222.019L300.807 221.132L297.473 219.49L296.126 217.159L296.274 212.413L299.312 211.28L308.28 212.758Z",
    fill: "#944E39"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M280.867 219.31L282.838 224.203L286.698 229.556L287.289 232.479L284.415 234.86H279.487L274.938 232.315L268.318 220.049L268.844 215.402L280.867 219.31Z",
    fill: "#944E39"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M316.099 101.872L318.234 118.013L319.581 120.804L323.818 119.704L326.167 98.3084V87.0277L321.486 79.031L314.538 80.673L316.099 101.872Z",
    fill: "#F0C6B4"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M316.805 89.9342L323.276 87.5369L316.099 92.3152L316.805 89.9342Z",
    fill: "#C7A495"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M313.076 60.6074L316.099 61.9046L318.956 67.2576L321.732 78.3249L320.468 81.8225L315.129 84.1377L307.36 66.1903L313.076 60.6074Z",
    fill: "#F4EFE9"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M291.675 56.3381L289.309 61.9046L288.291 67.6517L291.675 72.233L299.263 74.5154L304.026 74.0885L306.523 70.164L303.616 55.5499L291.839 53.793L291.675 56.3381Z",
    fill: "#C7A495"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M281.048 114.992L277.96 103.924V98.3086H285.482L287.223 114.992L282.904 119.08L281.048 114.992Z",
    fill: "#2D5A78"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M304.831 67.9475L302.712 72.6929L296.372 71.2315L290.574 65.6158L289.309 61.9048L286.698 65.6979L284.809 69.4417L281.54 70.0985L278.485 73.8916L274.133 92.1182L276.679 99.9671L282.05 109.015L282.214 115.271L282.132 122.43L290.114 124.483L307.574 114.663L317.281 90.082L318.612 86.3218V76.5681L315.54 69.4417L311.532 64.4992L304.831 67.9475Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M295.879 148.013L299.789 174.811L296.619 183.514L295.025 210.64L297.982 214.876L303.616 216.256L309.331 212.972L315.474 177.783L317.281 150.969L316.099 126.174L293.432 135.287L295.879 148.013Z",
    fill: "#FF3F3F"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M316.099 126.174L316 128.243L313.421 134.433L313.783 135.813H315.212L319.613 132.906L322.373 128.604L323.818 119.704L321.634 118.013H317.708L315.852 118.916L314.686 123.415L316.099 126.174Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M316.099 73.0869L306.474 79.967L292.693 85.8948L294.073 102.643L290.328 115.468L285.384 118.128L281.048 114.992L275.447 129.77L274.346 173.021L270.01 183.825L268.318 214.351L270.963 219.54L276.367 221.132L281.343 219.113L285.696 184.252L289.523 177.684L298.425 142.709L305.734 138.686L316.099 126.174V103.382L318.562 88.4563L317.922 79.4252L316.099 73.0869Z",
    fill: "#FF3F3F"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M300.101 63.6945L303.665 65.3365L308.543 70.6074L310.728 79.4251L316.099 76.4695L313.06 67.1427L307.344 60.7881L305.685 59.8357L300.101 63.6945Z",
    fill: "#FF3F3F"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M281.261 69.9671L288.751 73.4318L293.629 78.7027L295.814 87.5368L301.185 84.5648L298.146 75.238L292.43 68.8834L286.55 65.6157L281.261 69.9671Z",
    fill: "#FF3F3F"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M267.086 77.898L268.318 70.9358L274.56 67.9473L280.555 69.6386L283.791 75.2379L282.477 78.6205L278.945 83.0375L270.569 83.1853L267.086 77.898Z",
    fill: "#D1D1D1"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M265.378 70.2955L268.795 79.6551L270.109 82.8571L273.361 84.6305L279.717 82.7257L282.904 78.9819L282.132 73.087L280.752 71.1822L277.352 67.6519H270.191L265.378 70.2955Z",
    fill: "#F0C6B4"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M278.485 68.8341L274.346 71.2315L274.001 69.4088L277.352 67.6519L278.485 68.8341Z",
    fill: "#C7A495"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M286.172 41.1329L281.409 46.8964L270.815 57.5204L265.871 63.9079L265.378 70.2954L267.711 72.6928L274.346 71.2313L281.82 62.3151L289.129 48.8505L291.625 44.9917L294.073 42.463L289.753 39.064L286.172 41.1329Z",
    fill: "#F0C6B4"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M312.584 45.353L315.277 49.7701L315.54 56.6995L314.062 58.8341V60.9523L310.399 70.7553L306.359 73.0869L304.026 72.3809L295.978 65.3366L295.37 61.954L292.956 59.688L292.266 56.4039L291.675 51.9376L295.814 44.9918L306.523 41.9705L312.584 45.353Z",
    fill: "#F0C6B4"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M292.266 56.4037L292.906 54.7453L294.5 54.6304L296.06 56.4037V58.6369L297.046 59.6878H299.017L299.789 58.0622L301.201 55.944V53.2675L299.789 50.788L299.296 48.1772L301.71 47.192L303.96 47.8159L306.293 49.5236L309.759 51.2149L312.091 50.2954L313.076 49.0967L312.584 45.3529L309.759 41.3956L306.441 38.637L303.254 37.9966L295.978 39.9178L292.02 44.8767L290.821 47.6189L290.328 52.4136L291.248 56.3052L292.266 56.4037Z",
    fill: "#6B4414"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M286.172 41.133L290.525 41.757L292.003 42.9885L291.625 44.9918L293.744 44.3021L300.166 39.8029L302.334 40.0657L303.353 41.133L304.568 39.8029L303.928 37.5205L301.858 33.9245L297.752 33.1199L293.071 33.9245L286.172 41.133Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M280.555 69.6387L281.491 77.1428L276.974 81.7404L271.111 82.0196L267.086 77.8981L273.443 91.6255L277.96 94.811L284.809 92.3972L287.223 82.66L285.023 74.4498L280.555 69.6387Z",
    fill: "#F4EFE9"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M193.913 245.599V233.234L178.769 224.482H157.351L142.207 233.234V245.599L157.351 254.334H178.769L193.913 245.599Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M178.129 228.784L182.449 231.231L193.141 236.781V237.766L192.731 240.64L185.931 240.935L177.193 237.47H175.796L167.995 236.846L163.938 234.613V233.612L166.533 226.961L178.129 228.784Z",
    fill: "#836E69"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M155.101 235.122L156.399 239.342L158.944 244.482L159.519 248.423V249.424L155.364 250.607L150.633 249.983L146.839 246.14L143.866 236.945V235.96L155.101 235.122Z",
    fill: "#836E69"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M178.129 227.799L182.449 230.246L192.172 233.989L193.141 236.781L192.731 239.638L185.931 239.966L177.193 236.469H175.796L167.995 235.845L163.938 233.612L164.841 228.374L166.533 225.976L178.129 227.799Z",
    fill: "#EFC58B"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M160.554 77.1589L159.372 81.2968L158.632 84.8272L161.967 89.5563L168.504 91.9536L174.335 89.9175L176.651 87.5366L175.222 79.5891L164.841 75.0571L160.308 75.3199L160.554 77.1589Z",
    fill: "#C7A495"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M190.792 91.4612L192.878 95.9603L193.289 108.144L189.61 125.895L188.017 126.995H183.089L183.91 95.4513L190.792 91.4612Z",
    fill: "#F0C6B4"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M186.785 98.5875L191.351 96.7812L186.785 100.328V98.5875Z",
    fill: "#C7A495"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M180.806 77.4546L183.533 78.0786L185.98 80.5745L187.54 84.1048L188.887 88.3084L190.858 90.9849L190.168 95.4513L186.079 97.6187L176.963 83.8257L180.806 77.4546Z",
    fill: "#F4EFE9"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M151.488 130.952L150.88 120.344L154.132 123.596L155.101 133.021L151.208 135.172L151.488 130.952Z",
    fill: "#2D5A78"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M174.433 85.4676L173.086 89.622H166.319L161.441 85.8781L159.372 81.2969L154.263 85.4676L153.754 88.1606L149.96 89.7205L144.918 93.5464L147.102 114.351L150.831 121.839L153.229 128.078L152.292 133.481L153.442 137.733H165.909L177.357 127.142L187.376 107.619L188.509 99.2114L186.292 90.4758L183.089 85.4676L179.426 82.2328L174.433 85.4676Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M164.841 165.385L168.619 188.669L164.841 199.474V226.223L168.619 229.408L175.123 230.245L179.016 227.618L180.954 196.978L183.713 188.111L186.785 161.017L185.602 145.435L164.841 153.743V165.385Z",
    fill: "#FF3F3F"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M155.101 234.137L156.399 238.341L158.944 243.497L159.519 246.764V248.423L155.364 249.622L150.633 248.998L146.839 245.155L143.866 235.96L143.965 232.331L155.101 234.137Z",
    fill: "#EFC58B"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M185.947 91.4612L176.651 98.8011L163.067 104.203L165.219 117.093L164.529 127.701L160.784 133.366L156.037 134.548L152.457 132.052L151.488 130.952L146.494 143.415L146.166 186.305L142.142 199.819L143.735 231.822L145.328 235.287L151.29 236.469L156.136 234.187L157.45 196.633L161.967 187.142L168.274 158.308L176.995 154.778L185.602 145.435L185.389 141.33L184.42 124.433L187.54 106.666V97.5203L185.947 91.4612Z",
    fill: "#FF3F3F"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M176.651 88.1935L179.213 91.7074L181.102 97.1261L184.945 94.8273L183.023 89.0966L179.985 83.8257L176.651 88.1935Z",
    fill: "#FF3F3F"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M183.089 67.816L182.859 71.5762L182.498 72.3152L182.235 77.6682L180.363 86.5516L175.944 88.7847L169.966 85.9276L164.923 81.8225L164.463 79.1132L162.279 78.0787L160.965 76.059L159.93 75.3201L159.371 71.4285L162.164 65.2873L172.824 62.7585L181.923 63.6288L183.089 67.816Z",
    fill: "#F0C6B4"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M160.965 76.0589L160.193 73.1361L161.441 71.0178L163.576 72.2001L164.513 74.2362L165.909 74.6467L166.319 72.8241L169.916 71.4776L171.887 67.4875L177.028 68.5712V67.4875L181.135 68.522L184.058 67.4875L183.023 62.118L180.987 58.4891L177.866 56.2067L174.22 53.8586L170.081 53.5466L166.434 54.0228L163.724 55.8455L161.441 56.4202L158.534 59.5236L157.072 63.0047L156.711 67.586L157.696 71.6254L159.47 75.7469L160.554 77.159L160.965 76.0589Z",
    fill: "#574943"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M164.463 58.0129L166.697 59.4251L169.506 62.9062L170.376 65.2871L168.767 63.2182L166.073 59.9013L164.463 58.0129Z",
    fill: "#362C29"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M150.321 141.067L156.973 140.032L158.501 142.594L163.691 144.942L165.909 150.624L162.443 153.743L156.973 154.22L146.856 148.817L146.166 146.683V143.07L150.321 141.067Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M138.89 120.591L134.718 123.399L138.89 127.865L150.321 141.067L149.697 143.218L147.825 145.435L146.166 146.683L128.69 134.827L123.811 128.702L122.875 119.343L128.887 111.97L136.59 111.231L138.89 120.591Z",
    fill: "#F0C6B4"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M154.789 96.4692L149.073 93.1523L143.669 93.6614L136.951 100.607L128.69 111.133L130.053 116.748L134.783 120.689L140.138 121.313L153.015 108.423L155.101 101.707L154.789 96.4692Z",
    fill: "#F4EFE9"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M149.96 89.7206L156.711 91.806L160.718 95.9604L163.215 100.328L165.564 105.451L169.719 102.611L168.159 98.2428L165.909 93.875L161.441 88.0622L154.263 85.4678L149.96 89.7206Z",
    fill: "#FF3F3F"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M184.42 124.433V131.428L184.009 134.959L182.679 138.161L184.009 141.97L188.23 140.032L190.858 133.645L189.61 125.895L186.785 124.088L184.42 124.433Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M134.718 123.399L129.248 124.581L130.217 125.55L134.718 123.399Z",
    fill: "#C7A495"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M412.973 320.295L353.17 354.81L324.541 338.291L384.344 303.776L412.973 320.295Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M392.672 322.052L380.944 315.286L372.65 300.919V287.372L380.944 282.577L392.672 289.359L400.983 303.727V317.273L392.672 322.052Z",
    fill: "#362C29"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M403.801 282.973L392.69 289.383L400.982 303.747L412.093 297.337L403.801 282.973Z",
    fill: "#211A1A"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M412.102 310.853L412.086 297.306L400.983 303.727V317.273L412.102 310.853Z",
    fill: "#0A0808"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M392.064 276.157L403.791 282.938L392.672 289.359L380.944 282.577L392.064 276.157Z",
    fill: "#574943"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M355.239 342.298L344.202 335.927L336.4 322.413V309.671L344.202 305.172L355.239 311.543L363.041 325.057V337.782L355.239 342.298Z",
    fill: "#D8D1C7"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M391.819 290.464L355.234 311.581L363.036 325.09L399.621 303.974L391.819 290.464Z",
    fill: "#B5AFA7"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M399.636 316.666V303.94L363.041 325.056V337.782L399.636 316.666Z",
    fill: "#A39C95"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M380.796 284.039L391.818 290.426L355.239 311.543L344.202 305.172L380.796 284.039Z",
    fill: "#E6E1DD"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M345.072 349.539L333.328 342.774L325.034 328.406V314.859L333.328 310.065L345.072 316.846L353.367 331.198V344.744L345.072 349.539Z",
    fill: "#362C29"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M342.329 322.905L336.071 319.293L331.653 321.838V329.046L336.071 336.698L342.329 340.311L346.731 337.766L346.748 330.557L342.329 322.905Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M356.175 310.429L345.064 316.839L353.356 331.203L364.467 324.793L356.175 310.429Z",
    fill: "#211A1A"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M364.487 338.324L364.47 324.794L353.367 331.198V344.744L364.487 338.324Z",
    fill: "#0A0808"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M344.448 303.644L356.175 310.426L345.072 316.846L333.328 310.065L344.448 303.644Z",
    fill: "#574943"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M386.233 310.147L379.088 297.766L368.001 291.379L368.018 287.963L386.233 298.472V310.147Z",
    fill: "#D8D1C7"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M381.437 295.713L369.348 301.116L370.35 308.242L381.437 301.855V295.713Z",
    fill: "#A39C95"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M396.909 295.927L392.491 298.472L389.37 303.398L392.491 308.735L396.909 306.173V295.927Z",
    fill: "#A39C95"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M392.491 298.472H386.233V310.147L392.491 308.735V298.472Z",
    fill: "#B5AFA7"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M396.909 292.314L378.678 281.805H359.69L346.255 289.556V300.508L364.487 311.034H370.744L375.163 308.472V304.876L370.35 302.101L381.437 295.713L386.233 298.472H392.491L396.909 295.927V292.314Z",
    fill: "#E6E1DD"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M369.792 304.876H367.246L365.456 305.927V307.388L367.246 308.423H369.792L371.582 307.388V305.927L369.792 304.876Z",
    fill: "#574943"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M391.341 292.446H388.795L387.005 293.48V294.942L388.795 295.976H391.341L393.132 294.942V293.48L391.341 292.446Z",
    fill: "#574943"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M364.487 322.708L357.342 310.327L346.255 303.923L346.271 300.508L364.487 311.033V322.708Z",
    fill: "#D8D1C7"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M375.163 308.472L370.744 311.033L367.624 315.96L370.744 321.28L375.163 318.735V308.472Z",
    fill: "#A39C95"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M370.744 311.034H364.487V322.709L370.744 321.28V311.034Z",
    fill: "#B5AFA7"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M376.559 289.884L371.993 287.257H365.554L360.988 289.884V293.612L365.554 296.239H371.993L376.559 293.612V289.884Z",
    fill: "#F4EFE9"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M372.009 296.239H365.554V299.277H372.009V296.239Z",
    fill: "#B5AFA7"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M376.559 296.65L371.993 299.277V296.239L376.559 293.612V296.65Z",
    fill: "#A39C95"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M360.988 296.65L365.554 299.277V296.239L360.988 293.612V296.65Z",
    fill: "#D8D1C7"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M373.34 288.571L370.744 287.076H367.082L364.487 288.571V290.689L367.082 292.183H370.744L373.34 290.689V288.571Z",
    fill: "#836E69"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M370.744 292.183H367.082V293.907H370.744V292.183Z",
    fill: "#544540"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M373.34 292.413L370.744 293.907V292.183L373.34 290.689V292.413Z",
    fill: "#403531"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M364.487 292.413L367.082 293.907V292.183L364.487 290.689V292.413Z",
    fill: "#685750"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M361.481 287.191L359.165 285.861H355.896L353.58 287.191V289.079L355.896 290.426H359.165L361.481 289.079V287.191Z",
    fill: "#A39C95"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M360.397 282.971L358.721 282.002H356.34L354.648 282.971V284.351L356.34 285.319H358.721L360.397 284.351V282.971Z",
    fill: "#F59C72"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M358.721 285.319H356.34V289.704H358.721V285.319Z",
    fill: "#B5AFA7"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M360.397 288.735L358.721 289.704V285.319L360.397 284.351V288.735Z",
    fill: "#A39C95"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M354.648 288.735L356.34 289.704V285.319L354.648 284.351V288.735Z",
    fill: "#D8D1C7"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M360.397 285.27L359.165 285.976H355.896L354.648 285.27V286.272L355.896 286.994H359.165L360.397 286.272V285.27Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M361.481 277.06L359.165 275.73H355.896L353.58 277.06V278.948L355.896 280.295H359.165L361.481 278.948V277.06Z",
    fill: "#E6E1DD"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M359.165 280.295H355.896V286.321H359.165V280.295Z",
    fill: "#B5AFA7"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M361.481 284.991L359.165 286.321V280.295L361.481 278.948V284.991Z",
    fill: "#A39C95"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M353.58 284.991L355.896 286.321V280.295L353.58 278.948V284.991Z",
    fill: "#D8D1C7"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M360.627 272.413L358.803 271.362H356.241L354.418 272.413V273.891L356.241 274.942H358.803L360.627 273.891V272.413Z",
    fill: "#836E69"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M358.803 274.942H356.241V279.671H358.803V274.942Z",
    fill: "#544540"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M360.627 278.62L358.803 279.671V274.942L360.627 273.891V278.62Z",
    fill: "#403531"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M354.418 278.62L356.241 279.671V274.942L354.418 273.891V278.62Z",
    fill: "#685750"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M223.396 359.769L210.141 352.117H171.657L158.386 359.769V370.606L171.657 378.258H210.141L223.396 370.606V359.769Z",
    fill: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M231.296 192.035L232.085 195.024L231.822 198.899L230.574 202.265L228.668 203.76L227.239 206.748L218.994 215.812L214.642 214.252L213.607 215.812L212.063 216.945L201.814 211.723L200.368 205.993L206.626 201.067L208.515 196.962L218.321 190.476L230.886 189.589L231.296 192.035Z",
    fill: "#F0C6B4"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M168.175 227.126L169.818 232.315L173.579 236.009L178.08 236.994L179.443 233.333L177.718 228.998L170.557 225.336L168.175 227.126Z",
    fill: "#D1D1D1"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M207.48 357.043L211.816 357.799H216.58L218.091 362.56V363.743L215.069 365.877L205.657 368.275L199.054 370.491L194.784 369.933L193.815 365.943V364.761L207.48 357.043Z",
    fill: "#FF8E1C"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M164.627 368.899V370.081L165.449 373.25L168.931 374.005L171.345 372.002L173.891 367.043L178.244 363.743L180.379 359.588V358.422L176.174 356.354L164.627 368.899Z",
    fill: "#FF8E1C"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M207.48 355.861L211.816 356.633H216.58L218.091 358.702V362.56L215.069 364.695L205.657 367.109L199.054 369.309L194.784 368.767L193.815 364.761L194.537 361.115L207.48 355.861Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M167.715 254.843L168.208 258.045L171.444 260.787L173.3 260.492L175.238 258.932L178.063 257.503L178.474 256.436L180.822 255.089L179.41 253.694L176.24 251.772L174.203 248.324L167.715 254.843Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M168.569 227.273L162.854 234.679L160.899 243.201L169.522 257.914L171.953 260.065L174.844 258.915L176.831 256.928L175.846 253.661L173.727 246.797L171.953 238.915L177.669 235.385L178.786 232.971L172.922 223.973L168.569 227.273Z",
    fill: "#F0C6B4"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M190.448 205.993L188.312 205.385L184.584 205.96L180.346 209.113L177.373 214.449L173.201 220.377L168.175 227.126L172.232 228.686L176.995 232.709L178.08 236.994L183.927 229.589L190.448 205.993Z",
    fill: "#F4EFE9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M207.135 257.356L215.89 248.932L219.306 242.298L214.642 238.981L196.952 257.356L203.998 260.18L207.135 257.356Z",
    fill: "#FF3F3F"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M219.306 222.019L216.826 219.851L213.508 216.847L213.919 215.812L212.161 212.347L208.515 208.357L202.618 205.993H200.368L196.443 206.912L195.408 205.993H190.448L184.551 210.853L181.036 216.847L177.965 223.431L176.24 231.017L176.568 240.18L182.777 251.28L196.131 260.18L205.657 257.355L214.231 245.484L219.306 242.298V222.019Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M165.202 362.79L164.627 368.899L165.449 372.084L168.931 372.823L171.345 370.836L173.891 365.877L178.244 362.56L180.379 358.423L179.755 355.861L176.174 355.188L165.202 362.79Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M165.202 280.935L166.549 318.193L163.954 330.984V361.017L166.861 365.171H174.105L176.273 360.179L179.131 333.874L179.788 326.567L182.711 316.501L185.52 299.063L186.44 284.794L165.202 280.935Z",
    fill: "#FF3F3F"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M208.515 196.962L211.685 197.651L214.986 199.31L217.894 201.51H221.951L224.644 199.228L226.09 198.538L227.404 199.228L226.845 200.952L226.303 202.544L227.404 203.513L229.161 200.131L231.034 197.471L231.066 194.269L230.442 192.068V190.886L231.296 192.035L231.822 191.724V190.328L230.722 187.093L227.683 183.99L224.858 182.824L220.653 182.134L216.103 183.513L213.065 185.517L210.913 188.341L209.468 190.886L208.515 193.924V196.962Z",
    fill: "#87511B"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M253.125 248.259L257.938 243.727L261.978 243.267L264.869 245.024L265.953 247.388V253.152H264.508L263.933 251.953L262.438 252.117L256.64 254.597L255.195 254.104L253.125 248.259Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M234.023 240.18L238.786 243.497L244.174 244.301L249.972 246.945L253.125 248.259L255.753 250.246L256.361 252.249L255.195 254.104L242.777 254.597L236.503 253.152L230.18 250.377L225.203 243.218L234.023 240.18Z",
    fill: "#F0C6B4"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M214.034 223.677L219.306 222.019L224.267 225.434L228.192 233.907L234.713 239.704L235.961 244.597L233.481 249.293L227.469 251.28L217.549 243.53L212.309 237.98L210.847 231.707L211.619 226.945L214.034 223.677Z",
    fill: "#F4EFE9"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M187.852 214.252L207.135 224.81L200.089 240.18L199.399 248.932L200.237 254.597L202.717 257.356H207.135L203.407 263.825L203.949 272.511L207.135 295.418L207.677 319.408L206.577 326.715L207.677 355.385L205.657 360.081L198.989 362.56L193.059 360.623L191.137 332.643L193.338 323.529L183.68 293.267L167.272 285.336L165.202 280.935V269.08L173.612 251.28L176.092 242.183L178.441 232.118L183.615 222.019L187.852 214.252Z",
    fill: "#FF3F3F"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M213.919 215.812L208.515 216.748L202.881 222.495L203.686 225.631L206.298 224.351L210.847 219.736L214.954 218.702L216.826 219.851L213.919 215.812Z",
    fill: "#FF3F3F"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M188.427 214.58L191.991 208.751L195.408 205.993H200.368L196.098 209.654L191.581 216.699L189.544 218.702L188.427 214.58Z",
    fill: "#FF3F3F"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M528.966 354.679V344.547L541.367 337.372H558.909L571.326 344.547V354.679L558.909 361.821H541.367L528.966 354.679Z",
    fill: "black"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M562.292 342.216V343.053L560.633 346.978L557.874 346.272L558.235 338.997L562.292 342.216Z",
    fill: "#C7AE87"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M546.114 346.649L540.431 348.652L534.058 349.588L532.859 353.496V354.35L535.668 356.436L542.238 357.7H548.873L553.62 358.702H557.973L559.862 354.547V353.693L546.114 346.649Z",
    fill: "#C7AE87"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M561.898 337.914L562.292 342.216L560.633 346.124L557.874 345.434L558.235 338.143L561.898 337.914Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M560.929 291.214L561.865 297.634L564.822 308.899L563.738 336.222L558.646 340.902L554.359 338.357L552.799 293.611L560.929 291.214Z",
    fill: "#FF3F3F"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M546.114 345.795L540.431 347.799L534.058 348.751L532.859 350.689V353.497L535.668 355.565L542.238 356.863H548.873L553.62 357.848H557.973L559.862 353.694L559.155 348.341L546.114 345.795Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M529.985 257.996L533.598 279.819L543.108 305.401L545.243 345.992L549.399 349.736L555.706 350.689L559.862 347.881V319.063L556.774 306.354L557.316 289.441L547.526 250.492L534.534 249.687L529.985 257.996Z",
    fill: "#FF3F3F"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M581.296 203.94L589.739 211.773L586.651 221.198L580.738 226.19L566.07 234.613L562.095 238.078L558.925 237.438L559.944 231.51L562.752 231.756L573.363 218.735L575.859 215.336L573.396 213.448L574.923 206.896L581.296 203.94Z",
    fill: "#F0C6B4"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M559.582 193.94L562.999 192.38H567.68L572.854 194.909L575.515 198.144L581.296 203.415V207.75L577.88 212.988L572.722 213.53L566.612 210.574L559.582 193.94Z",
    fill: "#F4EFE9"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M554.359 187.914L557.266 193.333L557.726 196.091L553.407 200.722L547.28 200.459L541.498 198.144L541.104 193.727L540.497 191.526L539.084 186.748L549.99 184.039L554.359 187.914Z",
    fill: "#F0C6B4"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M532.021 207.618L537.688 203.382L541.301 198.144H545.818H551.55L554.359 197.044L557.266 193.333L559.582 193.94L564.92 194.433L567.729 198.554L570.144 205.073L568.83 213.218L566.826 220.344L563.409 229.769L563.196 234.827L561.8 236.962L562.292 243.267L553.554 249.096L542.106 248.489L534.37 244.564L530.543 218.242L532.021 207.618Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M567.762 282.249L568.156 287.602L566.563 290.541L562.342 293.3L554.31 296.666H540.956L537.441 294.367V291.395L567.762 282.249Z",
    fill: "#17435C"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M561.8 236.961L559.451 241.411L554.425 244.416L545.095 245.861L537.918 245.007L531.019 242.101L529.081 250.098L532.711 253.267L535.865 256.781L537.326 270.36L536.949 283.201L536.357 290.492L538.838 292.544H544.603H553.932L560.732 289.999L566.727 285.96L568.123 280.935L568.632 261.034L566.891 250.426L567.663 245.336L564.674 238.636L561.8 236.961Z",
    fill: "#EF4141"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M533.335 173.382L532.76 178.407L533.713 180.164L533.253 182.167L536.472 190.87L537.786 191.527H540.497L541.104 188.128L544.011 184.187L538.378 172.528L533.335 173.382Z",
    fill: "#F0C6B4"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M534.058 170.213L533.253 172.528L533.647 176.453L535.865 179.458V182.068L536.982 182.873L537.786 182.068L538.69 181.871L540.201 184.876L540.792 187.799L543.404 190.607L547.231 191.526L552.158 190.114L555.558 186.699L557.266 179.458V173.727L554.359 167.816L549.333 165.5L544.504 163.891L536.982 164.499L533.253 165.796L532.76 168.423L533.253 170.032L534.058 170.213Z",
    fill: "#736656"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M546.426 169.113L545.013 170.623L535.766 169.868L546.426 169.113Z",
    fill: "#5E4439"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M541.301 231.198L536.423 234.022L531.397 233.661L527.439 231.198L529.196 225.533L541.301 227.076V231.198Z",
    fill: "#D1D1D1"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M536.423 251.346L537.688 253.25L537.031 256.009L533.253 257.93L530.132 259.441L526.929 257.323L526.355 255.369L527.176 252.397L536.423 251.346Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M540.841 230.344L537.721 245.073L537.277 250.295L535.47 253.973L532.317 256.715H529.64L526.355 252.495L526.929 246.879L528.227 242.38L528.671 230.18L528.769 226.518L532.645 224.778L540.102 226.518L540.841 230.344Z",
    fill: "#F0C6B4"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M535.668 206.896L540.595 208.604L543.108 215.336V221.543L541.301 231.198L536.768 228.39L531.348 227.98L527.439 231.198L527.373 221.756L526.929 215.927L528.441 211.001L531.151 207.799L535.668 206.896Z",
    fill: "#F4EFE9"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M575.859 215.336L583.612 218.111L582.659 220.344L575.859 215.336Z",
    fill: "#C7A495"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M358.984 495.023V482.954L344.218 474.432H323.309L308.527 482.954V495.023L323.309 503.545H344.218L358.984 495.023Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M340.999 498.028V498.98L342.937 501.394L347.027 500.787L350.64 497.043L355.206 492.445L355.436 489.604V488.652L349.638 484.925L340.999 498.028Z",
    fill: "#362C29"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M318.053 479.145L315.589 481.099V482.051L318.25 489.243L320.566 493.151L322.176 494.169H324.278L326.2 493.151V492.199L318.053 479.145Z",
    fill: "#362C29"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M340.999 490.031V498.028L342.937 500.442L347.027 499.834L350.64 496.09L355.206 491.509L355.436 488.652L352.398 484.498L349.638 483.956L340.999 490.031Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M318.053 478.192L315.951 479.194L315.589 481.099L318.25 488.291L320.566 492.199L322.176 493.201H324.278L326.2 492.199V485.072L318.053 478.192Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M313.799 384.449L315.376 383.578L320.271 382.495L321.223 386.009L320.205 388.734L316.115 389.999L313.799 389.933L311.73 390.344L310.317 388.931L310.662 386.009L313.799 384.449Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M296.109 363.431L288.554 371.378L290.213 379.358L296.109 383.431L310.317 388.931H313.142L314.538 386.583L313.799 384.449L301.546 372.856L304.273 370.639L303.09 364.416L296.109 363.431Z",
    fill: "#F0C6B4"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M319.466 345.532L313.142 344.826L307.607 347.536L304.486 351.772L301.677 356.485L295.945 363.069L297.456 366.83L301.776 370.245L306.901 371.05L313.471 364.038L317.856 357.93L319.466 345.532Z",
    fill: "#F4EFE9"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M328.401 335.943L328.056 339.293L326.266 343.053L326.988 346.337L336.498 348.34L339.964 346.731L341.869 343.053V339.047L342.625 335.943L343.824 333.447L332.786 332.429L328.401 335.943Z",
    fill: "#F0C6B4"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M369.94 314.925L368.543 314.285L365.833 312.134L362.63 310.968H360.315L359.937 309.441L361.678 308.899L366.244 309.162L367.755 306.666L368.346 295.795L369.94 295.401L370.712 301.772L374.736 303.431L377.594 306.502L377.199 313.973L376.707 315.204L373.98 316.091L369.94 314.925Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M362.63 340.377L365.258 336.879L366.326 329.802L369.94 314.925L371.516 313.316H375.113L376.707 315.204L377.199 334.285L374.769 343.053L371.385 348.012L367 347.404L362.63 340.377Z",
    fill: "#F0C6B4"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M353.235 348.34L357.752 343.053L362.318 339.638L368.297 341.017L371.516 345.533L371.155 352.101L362.187 363.431L355.946 368.127L350.312 365.697L353.235 348.34Z",
    fill: "#F4EFE9"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M326.266 343.053L329.715 344.925L334.248 345.533L338.765 344.925L341.869 343.053L343.955 345.533L345.992 348.751L349.622 347.717L353.235 348.341L355.666 353.053L355.946 368.127L352.529 376.567L351.544 385.861L350.049 387.831L322.373 388.324L319.466 386.321L318.562 378.078L313.684 367.799L313.142 358.078L316.148 348.751L319.466 345.533H320.977L322.866 346.633L326.266 343.053Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M318.973 361.099L334.248 362.002L351.117 361.099L349.606 378.176L350.049 385.204L352.119 386.124L355.436 404.301L354.73 427.815L351.823 448.899L352.02 461.263L351.018 487.486L348.505 491.509H342.773L339.586 488.849L337.205 463.266L338.256 453.02L335.743 433.628L334.429 416.452L332.934 430.13L329.616 448.701L330.52 459.457L328.811 484.974L325.28 487.273L319.663 486.682L317.659 482.462L316.657 456.846L317.659 443.069L315.442 420.869L314.932 398.669L318.661 386.419L320.566 385.106V377.273L319.466 367.733L318.973 361.099Z",
    fill: "#FF3F3F"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M344.842 326.731L345.384 327.782L344.842 333.135L343.282 333.579L340.473 328.176L344.842 326.731Z",
    fill: "#F0C6B4"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M325.28 319.72L326.693 315.795L327.399 316.501L331.324 311.986L339.061 310.968L337.944 311.772L344.07 315.434L345.384 320.721V325.533L343.988 328.652L343.676 332.872L341.574 336.698L338.157 337.996L333.033 338.488L329.222 336.994L326.298 333.267L324.787 327.536V323.234L325.28 319.72Z",
    fill: "#362C29"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M343.955 345.532V352.642L343.348 363.069L349.671 363.431L350.049 353.283L349.622 347.716L343.955 345.532Z",
    fill: "#FF3F3F"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M326.266 343.053L324.787 350.689L326.2 363.07L320.369 362.955L319.466 352.101L320.977 345.533L326.266 343.053Z",
    fill: "#FF3F3F"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M324.492 414.678L345.893 417.289L325.986 416.583L324.492 414.678Z",
    fill: "#377691"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M350.312 403.726L346.156 404.564H342.346L337.779 403.726V402.051L342.264 402.889H346.156L350.312 402.051V403.726Z",
    fill: "#377691"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M339.734 400.656L341.935 399.785L344.218 400.459H346.222L348.242 401.132L349.031 402.725L348.374 406.206L348.439 412.495L346.156 413.973L344.152 413.234L340.26 414.514L338.798 412.643L339.586 403.529L339.734 400.656Z",
    fill: "#F4EFE9"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M301.546 372.856L297.9 376.698H294.877L301.546 372.856Z",
    fill: "#C7A495"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M366.244 336.14L373.077 337.897L370.662 338.948L366.244 336.14Z",
    fill: "#C7A495"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M143.817 297.832L142.273 296.945L122.875 308.16L114.006 303.02L131.301 293.037V290.705L128.427 289.047H124.37L107.091 299.03L98.9112 294.301L25.4751 336.666L58.013 355.45L131.449 313.086L124.452 309.047L143.85 297.832H143.817ZM125.618 291.329L127.294 292.331L123.401 294.58L121.709 293.611L125.602 291.345L125.618 291.329Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M114.236 301.28L105.58 296.288L99.486 285.73L99.4696 275.746L105.58 272.199L114.236 277.191L120.346 287.799V297.766L114.236 301.28Z",
    fill: "#574943"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M131.991 281.066L125.865 270.492L114.236 277.191L120.346 287.799L131.991 281.066Z",
    fill: "#211A1A"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M131.991 291.034V281.066L120.346 287.799V297.766L131.991 291.034Z",
    fill: "#0A0808"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M117.225 265.467L125.865 270.492L114.236 277.191L105.58 272.199L117.225 265.467Z",
    fill: "#574943"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M121.61 300.098L123.171 298.127L140.811 287.914L142.848 284.433L141.764 280.475L140.811 279.95L120.658 291.576V299.539L121.61 300.098ZM135.572 287.897V285.943L139.464 283.694V285.648L135.572 287.897Z",
    fill: "#D8D1C7"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M141.764 288.472L143.801 284.958V281.658L141.764 280.475L121.61 292.101V300.098L141.764 288.472ZM136.524 288.472V286.518L140.417 284.268V286.222L136.524 288.472Z",
    fill: "#A39C95"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M124.978 298.193L121.61 300.098V292.101L123.565 289.884L124.025 289.622L124.978 290.163V298.193Z",
    fill: "black"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M104.184 271.017L111.131 275.04L131.285 263.398V262.282L128.41 259.392H124.353L106.713 269.572L104.2 269.933V271.034L104.184 271.017ZM125.618 261.69L127.293 262.643L123.401 264.909L121.709 263.94L125.602 261.69H125.618Z",
    fill: "#A39C95"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M104.184 269.933L111.131 273.924L131.285 262.298V259.966L128.41 258.308H124.353L104.2 269.933H104.184ZM125.618 260.607L127.293 261.576L123.401 263.825L121.709 262.856L125.602 260.607H125.618Z",
    fill: "#D8D1C7"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.712 271.855V272.971L112.511 274.219L111.115 273.924L104.184 269.933L107.764 267.865L114.712 271.855Z",
    fill: "black"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M93.031 320.442L80.8765 313.414L72.2863 298.538V284.515L80.8765 279.556L93.031 286.551L101.621 301.428L101.605 315.45L93.031 320.442Z",
    fill: "#E6E1DD"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M115.345 273.684L93.0414 286.557L101.632 301.432L123.936 288.558L115.345 273.684Z",
    fill: "#B5AFA7"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M123.943 302.577V288.554L101.621 301.428L101.605 315.451L123.943 302.577Z",
    fill: "#A39C95"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M106.105 309.704L118.818 302.38V294.991L117.439 295.828L113.201 300.935L106.105 308.111V309.704Z",
    fill: "#D8D1C7"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M106.105 308.111L117.439 301.608V295.828L106.105 302.314V308.111Z",
    fill: "#362C29"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M103.198 266.649L115.336 273.677L93.031 286.551L80.8766 279.556L103.198 266.649Z",
    fill: "#E6E1DD"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6805 333.858L59.6883 326.354L50.4904 310.41V295.418L59.6883 290.098L72.6805 297.618L81.8785 313.546V328.538L72.6805 333.858Z",
    fill: "#CFDB77"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M102.672 301.543L93.4909 285.615L72.6805 297.618L81.8785 313.546L102.672 301.543Z",
    fill: "#87A15F"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M102.672 316.551V301.543L81.8785 313.546V328.538L102.672 316.551Z",
    fill: "#6B874F"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4988 278.111L93.4909 285.615L72.6805 297.618L59.6884 290.098L80.4988 278.111Z",
    fill: "#CFDB77"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M83.521 313.809L73.2718 296.058L61.3308 289.145L64.9608 287.076L76.8853 293.957L87.1345 311.707L87.1509 325.5L83.521 327.585V313.809Z",
    fill: "black"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4486 337.52L56.9782 329.129L46.7126 311.378V294.646L56.9782 288.735L71.4486 297.126L81.6978 314.843V331.575L71.4486 337.52Z",
    fill: "#9FB366"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3441 312.774L75.095 294.991L71.4486 297.126L81.6978 314.843L85.3441 312.774Z",
    fill: "#87A15F"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3442 329.474V312.774L81.6978 314.843V331.575L85.3442 329.474Z",
    fill: "#6B874F"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5917 286.649L75.095 294.991L71.4486 297.126L56.9782 288.735L60.5917 286.649Z",
    fill: "#CFDB77"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5618 343.184L41.4073 336.206L32.8171 321.329V307.306L41.4073 302.347L53.5618 309.342L62.1357 324.219V338.258L53.5618 343.184Z",
    fill: "#574943"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4785 314.777L69.9047 299.933L53.5618 309.342L62.1357 324.219L78.4785 314.777Z",
    fill: "#211A1A"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4949 328.833L78.4785 314.777L62.1357 324.219V338.258L78.4949 328.833Z",
    fill: "#0A0808"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7502 292.906L69.9047 299.933L53.5618 309.342L41.4073 302.347L57.7502 292.906Z",
    fill: "#362C29"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M52.4285 307.224L63.4004 326.288V337.519L67.3095 335.27V324.055L56.3048 304.974L46.5812 299.359L42.6721 301.608L52.4285 307.224Z",
    fill: "black"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8353 351.509L35.2808 342.528L24.2761 323.464V305.5L35.2808 299.194L50.8353 308.16L61.8236 327.175V345.122L50.8353 351.509Z",
    fill: "#362C29"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4227 311.263L36.6769 303.907L27.6761 309.096V323.792L36.6769 339.375L49.4063 346.731L58.4072 341.542V326.846L49.4227 311.263ZM56.4855 340.426L49.4063 344.498L38.1059 337.979L29.6142 323.267V310.212L36.6769 306.14L47.9937 312.692L56.4855 327.339V340.409V340.426Z",
    fill: "#F4EFE9"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7938 324.958L51.7715 333.02V328.209L37.7938 320.147V324.958Z",
    fill: "#F4EFE9"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4905 322.511L36.3648 324.17V319.326L34.9195 318.505L33.4905 317.667V322.511Z",
    fill: "#F4EFE9"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1204 312.232L34.706 308.866L35.9214 311.674L32.3408 314.449L34.9195 318.505V315.483L37.1204 312.232Z",
    fill: "#F4EFE9"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M54.718 305.91L50.8366 308.154L61.8416 327.172L65.7229 324.927L54.718 305.91Z",
    fill: "#211A1A"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7163 342.889V324.941L61.8236 327.175V345.122L65.7163 342.889Z",
    fill: "#0A0808"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1571 296.945L54.7116 305.927L50.8353 308.16L35.2808 299.194L39.1571 296.945Z",
    fill: "#574943"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M125.865 523.792L71.8921 515.434L31.9301 492.363L16.9177 459.999L31.9466 427.634L71.9085 404.564L125.881 396.222L179.853 404.564L219.815 427.634L234.844 459.999L219.815 492.363L179.853 515.434L125.881 523.792H125.865ZM85.4756 498.931L125.865 505.187L166.27 498.931L195.391 482.117L205.657 460.015L195.391 437.913L166.27 421.099L125.881 414.859L85.492 421.099L56.3705 437.913L46.1049 460.015L56.3541 482.117L85.492 498.931H85.4756Z",
    fill: "black"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7261 425.368L84.6707 411.345V418.816L54.5309 436.222L43.4769 460.015V452.527L53.7261 425.368Z",
    fill: "#D66B24"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M198.019 425.368L167.058 411.345V418.816L197.198 436.222L208.252 459.999V452.527L198.019 425.368Z",
    fill: "#EF8F2D"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M125.865 401.05L84.6707 411.345V418.816L125.865 412.445L167.058 418.816V411.345L125.865 401.05Z",
    fill: "#DE822B"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M125.421 510.787L71.81 502.773L72.6969 513.167L125.865 521.394L179.049 513.167V505.68L125.421 510.787Z",
    fill: "#DE822B"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0441 478.242L19.5129 452.527V459.999L33.7533 490.688L72.6969 513.168V505.68L40.0441 478.242Z",
    fill: "#EF8F2D"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M211.718 478.242L232.233 452.527V459.999L217.976 490.688L179.049 513.168V505.68L211.718 478.242Z",
    fill: "#D66B24"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6969 505.68L33.7533 483.217L19.5129 452.527L33.7698 421.838L72.6969 399.358L125.865 391.148L179.032 399.358L217.959 421.838L232.216 452.527L217.959 483.217L179.032 505.68L125.848 513.906L72.6805 505.68H72.6969ZM54.5145 476.304L84.6707 493.709L125.865 500.08L167.058 493.709L197.215 476.304L208.252 452.527L197.215 428.751L167.058 411.345L125.865 404.974L84.6707 411.345L54.5145 428.751L43.4769 452.527L54.5145 476.304Z",
    fill: "#FDBD6F"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M199.662 397.355L211.734 423.365V452.527L199.662 426.518L168.126 408.307V379.161L199.662 397.355Z",
    fill: "#E3BD5E"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0836 397.355L40.0112 423.365V452.527L52.0836 426.518L83.6195 408.324V379.161L52.0836 397.355Z",
    fill: "#CC934C"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M125.865 372.626L83.6195 379.161V408.324L125.865 401.854V401.788L168.126 408.307V379.161L125.865 372.626Z",
    fill: "#D6A950"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.662 397.355L198.102 396.468V425.614L199.662 426.517L202.109 431.788V402.642L199.662 397.355Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.604 389.818V418.981L190.612 421.296V392.15L186.604 389.818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.734 423.365L209.583 418.751V447.913L211.734 452.527V423.365Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.123 383.201V412.347L179.131 414.678V385.516L175.123 383.201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.626 378.472V407.618L167.633 408.242V379.079L163.626 378.472Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.663 374.908V404.071L144.671 404.695V375.532L140.663 374.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0112 423.365V452.527L41.2595 449.818V420.655L40.0112 423.365Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.145 376.682V405.844L156.152 406.468V377.306L152.145 376.682Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.187 375.664V404.875L110.195 404.251V375.056L106.187 375.664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6899 377.454V406.616L98.7141 406.008V376.83L94.6899 377.454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0836 397.355L48.7493 404.531V433.693L52.0836 426.517L52.757 426.14V396.977L52.0836 397.355Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.174 373.759L129.166 373.135V402.297L133.174 402.905V373.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.685 373.89V403.102L121.693 402.494V373.266L117.685 373.89Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2304 392.659V421.821L64.2381 419.506V390.344L60.2304 392.659Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7278 386.025V415.187L75.7355 412.872V383.71L71.7278 386.025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6195 379.161L83.2089 379.391V408.554L83.6195 408.324L87.2166 407.765V378.603L83.6195 379.161Z",
    fill: "black"
  }))), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M228.751 423.365L215.529 394.892L177.965 373.217L125.865 365.155L73.7648 373.217L36.2173 394.892L23.0116 423.348L36.2173 451.821L73.7812 473.496L125.898 481.558L178.014 473.496L215.562 451.821L228.767 423.365H228.751ZM199.662 449.375L168.143 467.568L125.881 474.104L83.6197 467.568L52.0838 449.358L40.0114 423.365L52.0838 397.355L83.6197 379.161L125.881 372.626L168.143 379.161L199.679 397.355L211.751 423.365L199.679 449.375H199.662Z",
    fill: "#FBE979"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M125.865 481.575L73.7646 473.512V502.675L125.865 510.787V510.721L177.997 502.675V473.512L125.865 481.575Z",
    fill: "#D6A950"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M215.545 451.838L177.997 473.512V502.675L215.545 481.049V480.984L228.751 452.527V423.365L215.545 451.838Z",
    fill: "#CC934C"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2006 451.838L73.7645 473.512V502.675L36.2006 481.049L22.995 452.527V423.365L36.2006 451.838Z",
    fill: "#E3BD5E"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.633 504.268V475.105L163.626 475.729V504.875L167.633 504.268Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.663 508.438L144.671 507.815V478.668L140.663 479.276V508.438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.997 502.675L179.131 502.002V472.839L177.997 473.512L175.123 473.956V503.102L177.997 502.675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.59 482.166V452.954L209.583 455.269V484.465L213.59 482.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.612 495.384V466.222L186.604 468.521V497.699L190.612 495.384Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.088 460.425V431.263L221.08 439.9V469.062L225.088 460.425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.174 509.604V480.425L129.166 481.049V510.212L133.174 509.604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.109 488.767V459.588L198.102 461.887V491.082L202.109 488.767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.152 506.041V476.879L152.145 477.519V506.665L156.152 506.041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2381 468.012L60.2304 465.696V494.875L64.2381 497.174V468.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.757 461.378L48.7493 459.079V488.258L52.757 490.573V461.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7355 502.97V473.808L73.7645 473.512L71.7278 472.33V501.493L73.7645 502.675L75.7355 502.97Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2166 475.581L83.2089 474.974V504.136L87.2166 504.76V475.581Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.195 508.34V479.145L106.187 478.521V507.716L110.195 508.34Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2595 454.744L37.2518 452.445V481.657L41.2595 483.956V454.744Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.693 510.13V480.918L117.685 480.294V509.506L121.693 510.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.69 505.926L98.7141 506.55V477.371L94.69 476.747V505.926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7785 437.979L25.7708 429.342V458.521L29.7785 467.174V437.979Z",
    fill: "black"
  }))), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7261 388.734L84.6707 374.695V382.183L54.5309 399.588L43.4769 423.365V415.894L53.7261 388.734Z",
    fill: "#D66B24"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M198.019 388.718L167.058 374.695V382.183L197.198 399.588L208.252 423.365V415.894L198.019 388.718Z",
    fill: "#EF8F2D"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M125.865 364.416L84.6707 374.695V382.183L125.865 375.828L167.058 382.183V374.695L125.865 364.416Z",
    fill: "#DE822B"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M125.421 474.153L71.81 466.14L72.6969 476.534L125.865 484.76L179.049 476.534V469.046L125.421 474.153Z",
    fill: "#DE822B"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0441 441.608L19.5129 415.894V423.365L33.7533 454.054L72.6969 476.534V469.046L40.0441 441.608Z",
    fill: "#EF8F2D"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M211.718 441.608L232.233 415.894V423.365L217.976 454.054L179.049 476.534V469.046L211.718 441.608Z",
    fill: "#D66B24"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6969 469.046L33.7533 446.583L19.5129 415.894L33.7698 385.204L72.6969 362.725L125.865 354.498L179.032 362.725L217.959 385.204L232.216 415.894L217.959 446.583L179.032 469.046L125.848 477.273L72.6805 469.046H72.6969ZM54.5145 439.654L84.6707 457.059L125.865 463.43L167.058 457.059L197.215 439.654L208.252 415.877L197.215 392.101L167.058 374.695L125.865 368.324L84.6707 374.695L54.5145 392.101L43.4769 415.877L54.5145 439.637V439.654Z",
    fill: "#FDBD6F"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M560.502 463.743L451.358 526.747L432.732 515.992L541.876 453.004L560.502 463.743Z",
    fill: "black"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M464.958 493.562V504.563L461.279 510.918L448.747 518.159L445.067 516.041V505.056L448.747 498.685L461.279 491.444L464.958 493.562Z",
    fill: "#D8D1C7"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M436.385 491.515L432.705 497.885L445.036 505.005L448.716 498.635L436.385 491.515Z",
    fill: "#D8D1C7"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M448.944 484.333L436.411 491.558L448.747 498.685L461.279 491.444L448.944 484.333Z",
    fill: "#E6E1DD"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M432.732 508.915V497.929L445.067 505.056V516.041L432.732 508.915Z",
    fill: "#B5AFA7"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M553.571 442.429V453.414L549.892 459.785L525.878 473.644L522.199 471.509V460.524L525.878 454.153L549.892 440.294L553.571 442.429Z",
    fill: "#D8D1C7"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M513.522 447.014L509.844 453.385L522.177 460.501L525.856 454.13L513.522 447.014Z",
    fill: "#D8D1C7"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M537.556 433.184L513.543 447.043L525.878 454.153L549.892 440.294L537.556 433.184Z",
    fill: "#E6E1DD"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M509.864 464.399V453.414L522.199 460.524V471.509L509.864 464.399Z",
    fill: "#B5AFA7"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M560.568 446.468V457.454L556.889 463.825L455.744 522.199L452.064 520.081V509.095L455.744 502.724L556.889 444.35L560.568 446.468Z",
    fill: "#A39C95"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M532.514 477.897L531.709 478.357V458.882L532.514 458.406V477.897Z",
    fill: "#574943"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M448.758 498.707L445.079 505.078L452.077 509.118L455.756 502.747L448.758 498.707Z",
    fill: "#D8D1C7"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M549.892 440.294L448.747 498.685L455.744 502.724L556.889 444.35L549.892 440.294Z",
    fill: "#E6E1DD"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M445.067 516.041V505.056L452.064 509.096V520.081L445.067 516.041Z",
    fill: "#B5AFA7"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M553.587 455.45V461.46L549.908 467.831L544.701 470.82L541.022 468.701V462.708L544.701 456.337L549.908 453.332L553.587 455.45Z",
    fill: "#87817C"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M548.38 456.747L547.756 456.386L546.853 456.895L546.229 457.995V467.404L546.853 467.765L547.756 467.256L548.38 466.173V456.747Z",
    fill: "#211A1A"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M542.782 455.19L539.104 461.561L541.01 462.661L544.689 456.289L542.782 455.19Z",
    fill: "#D8D1C7"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M548.003 452.232L542.796 455.237L544.701 456.337L549.908 453.332L548.003 452.232Z",
    fill: "#E6E1DD"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M539.117 467.601V461.592L541.022 462.708V468.702L539.117 467.601Z",
    fill: "#B5AFA7"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M401.985 418.209C395.382 422.019 390.011 431.263 390.011 438.849C390.011 442.511 391.259 445.122 393.296 446.403C394.084 446.895 396.975 448.554 396.975 448.554C396.975 448.554 403.775 450.524 405.96 449.26C412.562 445.45 419.346 437.716 419.346 430.13C419.346 428.193 413.597 421.46 412.973 420.163C411.133 416.337 406.912 415.368 401.985 418.209ZM401.985 443.431C399.094 445.089 396.499 445.204 394.676 444.005C393 442.922 394.134 441.132 394.134 438.094C394.134 431.739 396.45 423.644 401.985 420.442C407.52 417.257 412.004 419.802 412.004 426.156C412.004 432.511 407.52 440.245 401.985 443.431Z",
    fill: "url(#paint0_linear_358_13776)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M414.123 419.473L410.772 417.536L400.671 419.671L392.803 429.129L390.29 435.779L392.721 437.191L393.017 443.464L395.858 447.881L396.975 448.554L395.907 445.861L394.692 438.554L397.895 428.176L406.896 420.393L414.123 419.473Z",
    fill: "url(#paint1_linear_358_13776)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M418.015 419.785L428.248 425.68L424.7 427.716L414.484 421.822L418.015 419.785Z",
    fill: "#D4D4D8"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M390.29 435.779L392.721 437.191L388.385 439.687L385.954 438.291L390.29 435.779Z",
    fill: "#D4D4D8"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M425.801 424.285L428.248 425.68L423.912 428.176L421.481 426.781L425.801 424.285Z",
    fill: "#D4D4D8"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M409.77 422.708C403.167 426.518 397.796 435.762 397.796 443.349C397.796 447.01 399.045 449.621 401.081 450.902C401.87 451.395 404.761 453.053 404.761 453.053C404.761 453.053 408.998 453.381 411.183 452.117C417.786 448.308 424.569 440.574 424.569 432.987C424.569 431.05 421.383 425.976 420.758 424.662C418.919 420.836 414.698 419.868 409.77 422.708ZM409.77 447.93C406.879 449.588 404.284 449.703 402.461 448.505C400.786 447.421 401.919 445.631 401.919 442.593C401.919 436.239 404.235 428.143 409.77 424.941C415.305 421.756 419.789 424.301 419.789 430.656C419.789 437.01 415.305 444.744 409.77 447.93Z",
    fill: "url(#paint2_linear_358_13776)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M406.37 420.738C399.767 424.547 394.396 433.792 394.396 441.378C394.396 445.04 395.645 447.651 397.681 448.931C398.47 449.424 401.361 451.083 401.361 451.083C401.361 451.083 405.598 451.411 407.783 450.147C414.386 446.337 421.169 438.603 421.169 431.017C421.169 429.079 417.983 424.005 417.359 422.692C415.519 418.866 411.298 417.897 406.37 420.738ZM406.37 445.959C403.479 447.618 400.884 447.733 399.061 446.534C397.386 445.45 398.519 443.661 398.519 440.623C398.519 434.268 403.102 429.621 408.62 426.419C411.988 424.465 412.727 421.214 414.533 423.102C415.7 424.301 416.373 426.206 416.373 428.685C416.373 435.04 411.889 442.774 406.354 445.959H406.37Z",
    fill: "url(#paint3_linear_358_13776)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M400.506 440.738L398.864 444.449L401.771 451.493L404.777 453.053L400.506 440.738Z",
    fill: "#A5A7B3"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M418.558 422.035L410.772 417.536L400.687 422.429L398.076 440.278L410.591 425.056L418.558 422.035Z",
    fill: "url(#paint4_linear_358_13776)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M388.007 442.807V456.025L398.24 461.936L399.964 456.238L406.502 460.015L405.894 455.549L398.24 448.702L388.007 442.807Z",
    fill: "#9698A6"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M414.501 414.432L416.159 349.736L412.743 347.766L409.688 349.523V419.342C409.688 419.342 409.622 419.358 409.573 419.375C409.688 419.342 413.088 421.312 413.088 421.312L422.253 417.454L418.837 415.483L414.468 414.416L414.501 414.432Z",
    fill: "#BDBDC6"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M414.402 413.759L416.159 415.976L422.27 417.454L416.915 414.367L414.402 413.759Z",
    fill: "#D4D4D8"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M423.912 428.176C424.093 429.014 424.175 429.933 424.175 430.918C424.175 438.505 418.82 447.749 412.201 451.559C405.598 455.368 400.227 452.314 400.227 444.744C400.227 443.743 400.326 442.725 400.49 441.69L396.154 444.186V449.884L398.207 448.702V461.936L405.45 457.749L406.469 460.015L417.901 453.414L418.919 449.966L426.162 445.779V432.544L428.215 431.362V425.647L423.879 428.143L423.912 428.176Z",
    fill: "#B4B5BF"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M409.688 349.539L403.036 353.382V423.201C403.036 423.201 403.102 423.135 403.134 423.102C403.2 423.037 403.266 422.987 403.332 422.922C403.414 422.84 403.512 422.774 403.594 422.692C403.66 422.643 403.726 422.593 403.775 422.528C403.906 422.413 404.054 422.298 404.186 422.199C404.235 422.166 404.268 422.134 404.317 422.101C404.448 422.002 404.563 421.904 404.695 421.822C404.761 421.772 404.81 421.739 404.876 421.69C404.974 421.608 405.089 421.542 405.188 421.477C405.253 421.427 405.303 421.395 405.368 421.362C405.483 421.296 405.582 421.214 405.697 421.148C405.746 421.115 405.795 421.083 405.861 421.05C406.025 420.951 406.19 420.853 406.354 420.754C406.518 420.656 406.682 420.574 406.847 420.491C406.896 420.459 406.945 420.442 407.011 420.409C407.126 420.36 407.224 420.294 407.339 420.245C407.405 420.212 407.454 420.18 407.52 420.163C407.618 420.114 407.733 420.065 407.832 420.015C407.898 419.982 407.947 419.966 408.013 419.933C408.144 419.884 408.259 419.835 408.39 419.785C408.44 419.769 408.473 419.753 408.522 419.736C408.653 419.687 408.801 419.638 408.932 419.588C408.998 419.572 409.064 419.556 409.113 419.523C409.212 419.49 409.294 419.473 409.376 419.441C409.442 419.424 409.507 419.408 409.573 419.391C409.606 419.391 409.639 419.375 409.688 419.358V349.539Z",
    fill: "#A5A7B3"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M410.263 422.429C410.099 422.511 409.934 422.61 409.77 422.692C409.934 422.593 410.099 422.511 410.263 422.429Z",
    fill: "#BEBEC6"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M408.62 423.431C408.522 423.496 408.407 423.578 408.308 423.644C408.407 423.562 408.522 423.496 408.62 423.431Z",
    fill: "#BEBEC6"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M408.128 423.775C407.996 423.874 407.881 423.956 407.75 424.055C407.881 423.956 407.996 423.857 408.128 423.775Z",
    fill: "#BEBEC6"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M412.792 421.411C412.71 421.444 412.612 421.46 412.53 421.493C412.628 421.46 412.71 421.444 412.792 421.411Z",
    fill: "#BEBEC6"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M401.098 352.249L398.043 354.006V420.245L391.933 428.8V437.651L397.287 440.738C398.223 435.204 400.227 427.733 404.481 423.923C404.448 423.956 406.502 355.303 406.469 355.336L401.114 352.249H401.098Z",
    fill: "#9698A6"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M406.452 355.336L403.397 357.093V423.332L397.287 431.887V440.738L398.076 440.278C399.012 434.744 402.313 428.866 406.551 425.056C406.518 425.089 406.485 425.122 406.452 425.155V355.336Z",
    fill: "#B4B5BF"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M407.027 424.662C406.929 424.744 406.846 424.81 406.764 424.892C406.846 424.81 406.945 424.744 407.027 424.662Z",
    fill: "#BEBEC6"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M407.618 424.17C407.487 424.285 407.339 424.383 407.208 424.498C407.339 424.383 407.487 424.268 407.618 424.17Z",
    fill: "#BEBEC6"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M416.159 415.976V349.736L413.104 351.493V421.312C413.104 421.312 413.039 421.329 413.006 421.345C417.26 420.245 420.545 422.331 421.481 426.78L422.27 426.321V417.47L416.159 415.976Z",
    fill: "#B4B5BF"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M411.413 421.887C411.413 421.887 411.298 421.936 411.232 421.969C411.298 421.936 411.347 421.92 411.413 421.887Z",
    fill: "#818175"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M412.989 421.345C412.989 421.345 412.858 421.378 412.792 421.395C412.858 421.378 412.924 421.362 412.989 421.345Z",
    fill: "#818175"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M412.53 421.477C412.53 421.477 412.398 421.509 412.349 421.542C412.415 421.526 412.48 421.509 412.53 421.477Z",
    fill: "#818175"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M411.922 421.69C411.922 421.69 411.84 421.723 411.79 421.739C411.84 421.723 411.873 421.707 411.922 421.69Z",
    fill: "#818175"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M406.764 424.892C406.764 424.892 406.633 425.007 406.567 425.073C406.633 425.007 406.699 424.958 406.764 424.892Z",
    fill: "#818175"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M408.801 423.316C408.801 423.316 408.686 423.398 408.62 423.431C408.686 423.398 408.735 423.349 408.801 423.316Z",
    fill: "#818175"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M410.936 422.101C410.936 422.101 410.821 422.15 410.756 422.183C410.821 422.15 410.871 422.133 410.936 422.101Z",
    fill: "#818175"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M409.294 423.004C409.294 423.004 409.195 423.069 409.13 423.102C409.179 423.069 409.228 423.037 409.294 423.004Z",
    fill: "#818175"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M407.766 424.055C407.766 424.055 407.684 424.12 407.635 424.153C407.684 424.12 407.717 424.088 407.766 424.055Z",
    fill: "#818175"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M410.427 422.347C410.427 422.347 410.329 422.396 410.263 422.429C410.312 422.396 410.361 422.38 410.427 422.347Z",
    fill: "#818175"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M407.208 424.498C407.208 424.498 407.076 424.597 407.027 424.662C407.093 424.613 407.159 424.564 407.208 424.498Z",
    fill: "#818175"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M408.308 423.661C408.308 423.661 408.193 423.743 408.128 423.792C408.177 423.743 408.243 423.71 408.308 423.661Z",
    fill: "#818175"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M421.925 423.973L418.558 422.035L408.456 424.17L400.589 433.628L398.076 440.278L400.506 441.69L400.819 447.963L403.66 452.38L404.777 453.053L403.693 450.36L402.477 443.053L405.68 432.675L414.698 424.892L421.925 423.973Z",
    fill: "url(#paint5_linear_358_13776)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M413.187 424.679C406.584 428.488 401.213 437.733 401.213 445.319C401.213 452.905 406.567 455.959 413.187 452.133C419.806 448.308 425.16 439.079 425.16 431.493C425.16 423.907 419.806 420.853 413.187 424.679ZM413.187 449.9C407.651 453.086 403.167 450.541 403.167 444.186C403.167 437.831 407.651 430.097 413.187 426.912C418.722 423.726 423.206 426.271 423.206 432.626C423.206 438.981 418.722 446.715 413.187 449.9Z",
    fill: "#D3D3D6"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M398.076 440.278L400.506 441.69L396.187 444.186L393.739 442.79L398.076 440.278Z",
    fill: "#D4D4D8"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M389.485 436.239L399.718 442.15L396.187 444.186L385.954 438.291L389.485 436.239Z",
    fill: "#D4D4D8"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M398.043 420.245L403.397 423.332L397.287 431.887L391.916 428.8L398.043 420.245Z",
    fill: "#D4D4D8"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M385.954 443.989L396.187 449.9V444.186L385.954 438.291V443.989Z",
    fill: "#A5A7B3"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M420.676 371.756C412.957 376.091 400.605 375.96 393.099 371.477C385.593 366.994 385.773 359.851 393.493 355.516C401.213 351.181 413.564 351.313 421.071 355.795C428.577 360.278 428.396 367.421 420.676 371.756ZM419.198 370.869C426.08 367.01 426.244 360.639 419.543 356.633C412.858 352.626 401.853 352.528 394.955 356.387C388.056 360.245 387.909 366.616 394.61 370.623C401.295 374.63 412.3 374.728 419.198 370.869Z",
    fill: "#DDDDDE"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M419.198 369.933C412.316 373.792 401.311 373.677 394.61 369.687C391.325 367.716 389.682 365.188 389.699 362.643V363.579C389.699 366.107 391.325 368.652 394.61 370.623C401.295 374.629 412.3 374.728 419.198 370.869C422.697 368.899 424.454 366.288 424.47 363.677V362.741C424.47 365.352 422.697 367.963 419.198 369.933Z",
    fill: "#BEBEC6"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M420.561 351.969C417.851 350.36 414.501 349.326 410.969 348.882C410.871 348.882 410.788 348.866 410.69 348.849C413.959 349.26 417.079 350.212 419.576 351.707C426.261 355.713 426.113 362.084 419.231 365.943C412.349 369.802 401.344 369.687 394.643 365.697C387.958 361.69 388.106 355.319 394.988 351.46C397.451 350.081 400.441 349.211 403.578 348.833C403.479 348.833 403.397 348.849 403.299 348.866C399.915 349.26 396.679 350.212 394.019 351.707C386.595 355.877 386.414 362.757 393.641 367.076C400.868 371.395 412.743 371.509 420.184 367.339C427.608 363.168 427.788 356.288 420.561 351.969Z",
    fill: "#D4D4D8"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M419.215 365.434C412.332 369.293 401.328 369.178 394.626 365.188C391.341 363.217 389.699 360.688 389.715 358.143V358.652C389.715 361.181 391.341 363.726 394.626 365.697C401.311 369.703 412.316 369.802 419.215 365.943C422.713 363.973 424.471 361.362 424.487 358.751V358.242C424.487 360.853 422.713 363.463 419.215 365.434Z",
    fill: "#A5A7B3"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M420.561 348.735C417.884 347.142 414.566 346.107 411.084 345.664C410.986 345.664 410.887 345.648 410.789 345.631C414.024 346.042 417.096 346.994 419.576 348.472C426.261 352.478 426.113 358.85 419.231 362.708C412.349 366.567 401.344 366.452 394.643 362.462C387.958 358.455 388.106 352.084 394.988 348.226C397.419 346.863 400.375 345.992 403.479 345.615C403.381 345.615 403.282 345.631 403.184 345.648C399.833 346.058 396.647 346.994 394.019 348.472C386.595 352.643 386.414 359.523 393.641 363.841C400.868 368.16 412.743 368.275 420.184 364.104C427.608 359.933 427.788 353.053 420.561 348.735Z",
    fill: "#D4D4D8"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M419.231 362.199C412.349 366.058 401.344 365.943 394.643 361.953C391.358 359.983 389.715 357.454 389.732 354.909V355.418C389.732 357.946 391.358 360.492 394.643 362.462C401.328 366.469 412.332 366.567 419.231 362.708C422.729 360.738 424.487 358.127 424.503 355.516V355.007C424.503 357.618 422.729 360.229 419.231 362.199Z",
    fill: "#A5A7B3"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M420.578 345.5C417.901 343.907 414.583 342.872 411.101 342.429C411.002 342.429 410.903 342.413 410.805 342.396C414.041 342.807 417.112 343.759 419.592 345.237C426.277 349.244 426.129 355.615 419.247 359.473C412.365 363.332 401.361 363.217 394.659 359.227C387.974 355.221 388.122 348.85 395.004 344.991C397.435 343.628 400.392 342.758 403.496 342.38C403.397 342.38 403.299 342.396 403.2 342.413C399.849 342.823 396.663 343.759 394.035 345.237C386.611 349.408 386.43 356.288 393.657 360.606C400.884 364.925 412.76 365.04 420.184 360.869C427.608 356.698 427.788 349.818 420.561 345.5H420.578Z",
    fill: "#D4D4D8"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M419.231 358.964C412.349 362.823 401.344 362.708 394.643 358.718C391.358 356.748 389.715 354.219 389.732 351.674V352.183C389.732 354.712 391.358 357.257 394.643 359.227C401.328 363.234 412.332 363.332 419.231 359.473C422.729 357.503 424.487 354.892 424.503 352.281V351.772C424.503 354.383 422.729 356.994 419.231 358.964Z",
    fill: "#A5A7B3"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M420.578 342.265C417.901 340.672 414.583 339.638 411.101 339.194C411.002 339.194 410.903 339.178 410.805 339.161C414.041 339.572 417.112 340.524 419.592 342.002C426.277 346.009 426.129 352.38 419.247 356.239C412.365 360.097 401.361 359.982 394.659 355.992C387.974 351.986 388.122 345.615 395.004 341.756C397.435 340.393 400.392 339.523 403.496 339.145C403.397 339.145 403.299 339.161 403.2 339.178C399.849 339.588 396.663 340.524 394.035 342.002C386.611 346.173 386.43 353.053 393.657 357.372C400.884 361.69 412.76 361.805 420.184 357.634C427.608 353.464 427.788 346.583 420.561 342.265H420.578Z",
    fill: "#D4D4D8"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M420.676 371.756C412.957 376.091 400.605 375.96 393.099 371.477C389.403 369.276 387.58 366.419 387.58 363.579L387.531 381.148C387.531 383.989 389.354 386.846 393.05 389.047C400.556 393.529 412.891 393.661 420.627 389.326C424.553 387.125 426.524 384.203 426.54 381.263L426.589 363.694C426.589 366.633 424.602 369.556 420.676 371.756Z",
    fill: "url(#paint6_linear_358_13776)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M420.184 367.339C412.76 371.509 400.868 371.395 393.641 367.076C390.093 364.958 388.319 362.216 388.336 359.473V360.574C388.336 363.316 390.093 366.058 393.641 368.176C400.868 372.495 412.743 372.61 420.184 368.439C423.961 366.321 425.867 363.496 425.867 360.672V359.572C425.867 362.396 423.961 365.221 420.184 367.339Z",
    fill: "#BEBEC6"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M420.2 360.853C412.776 365.024 400.884 364.909 393.674 360.59C390.126 358.472 388.352 355.73 388.368 352.988V354.088C388.368 356.83 390.126 359.572 393.674 361.69C400.901 366.009 412.776 366.124 420.2 361.953C423.978 359.835 425.883 357.011 425.883 354.186V353.086C425.883 355.91 423.978 358.735 420.2 360.853Z",
    fill: "#BEBEC6"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M420.2 357.618C412.776 361.789 400.884 361.674 393.674 357.355C390.126 355.237 388.352 352.495 388.368 349.753V350.853C388.368 353.595 390.126 356.337 393.674 358.455C400.901 362.774 412.776 362.889 420.2 358.718C423.978 356.6 425.883 353.776 425.883 350.951V349.851C425.883 352.675 423.978 355.5 420.2 357.618Z",
    fill: "#BEBEC6"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M420.742 347.109C413.022 351.444 400.671 351.313 393.165 346.83C389.469 344.629 387.646 341.772 387.646 338.932L387.613 348.242C387.613 351.083 389.436 353.94 393.132 356.14C400.638 360.623 412.973 360.754 420.709 356.419C424.635 354.219 426.606 351.296 426.622 348.357L426.655 339.047C426.655 341.986 424.668 344.909 420.742 347.109Z",
    fill: "url(#paint7_linear_358_13776)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M420.742 347.109C413.022 351.444 400.671 351.313 393.165 346.83C385.658 342.347 385.839 335.204 393.559 330.869C401.278 326.534 413.63 326.666 421.136 331.148C428.642 335.631 428.462 342.774 420.742 347.109ZM416.143 344.367C421.251 341.493 421.366 336.764 416.406 333.809C411.446 330.836 403.266 330.754 398.158 333.628C393.05 336.501 392.935 341.231 397.895 344.186C402.855 347.158 411.035 347.24 416.143 344.367Z",
    fill: "url(#paint8_linear_358_13776)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M420.167 368.439C412.743 372.61 400.851 372.495 393.624 368.176C391.933 367.158 390.635 366.009 389.765 364.777L391.029 366.551C391.851 367.684 393.033 368.751 394.61 369.703C401.295 373.71 412.3 373.809 419.198 369.95C420.923 368.981 422.22 367.848 423.107 366.649C423.534 366.058 423.961 365.483 424.388 364.892C423.436 366.19 422.04 367.405 420.167 368.456V368.439Z",
    fill: "#9698A6"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M420.184 364.104C412.76 368.275 400.868 368.16 393.641 363.841C390.093 361.723 388.319 358.981 388.336 356.239V357.339C388.336 360.081 390.093 362.823 393.641 364.942C400.868 369.26 412.743 369.375 420.167 365.204C423.945 363.086 425.85 360.262 425.85 357.437V356.337C425.85 359.162 423.945 361.986 420.167 364.104H420.184Z",
    fill: "#BEBEC6"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M418.114 335.057C417.309 334.301 416.488 333.546 415.683 332.791C418.13 335.073 417.605 338.094 414.156 340.015C410.181 342.249 403.824 342.183 399.964 339.868C396.679 337.897 396.252 334.942 398.65 332.725C397.829 333.48 397.024 334.219 396.203 334.974C393.115 337.815 393.657 341.625 397.895 344.153C402.855 347.125 411.035 347.208 416.143 344.334C420.578 341.855 421.251 337.963 418.114 335.04V335.057Z",
    fill: "url(#paint9_linear_358_13776)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M414.156 340.032C410.181 342.265 403.824 342.199 399.964 339.884C396.105 337.569 396.187 333.891 400.162 331.674C404.136 329.441 410.493 329.506 414.353 331.822C418.213 334.137 418.13 337.815 414.156 340.032Z",
    fill: "url(#paint10_linear_358_13776)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M425.571 377.684C425.571 380.82 423.354 384.646 420.627 386.222C417.901 387.799 415.683 386.534 415.683 383.398C415.683 380.262 417.901 376.436 420.627 374.859C423.354 373.283 425.571 374.547 425.571 377.684Z",
    fill: "#DDDDDE"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M423.321 374.235C423.814 374.826 424.109 375.713 424.109 376.846C424.109 379.982 421.892 383.808 419.165 385.385C418.163 385.959 417.244 386.156 416.472 386.025C417.358 387.092 418.886 387.24 420.643 386.239C423.37 384.662 425.587 380.836 425.587 377.7C425.587 375.713 424.684 374.465 423.337 374.235H423.321Z",
    fill: "url(#paint11_linear_358_13776)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M292.397 253.891L295.403 259.145L312.091 249.507C312.485 249.277 312.731 248.801 312.731 248.111C312.731 246.748 311.779 245.09 310.596 244.4C310.005 244.055 309.463 244.022 309.085 244.252L292.414 253.875L292.397 253.891Z",
    fill: "url(#paint12_linear_358_13776)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M292.151 294.58L295.157 299.835L311.844 290.196C312.239 289.966 312.485 289.49 312.485 288.8C312.485 287.438 311.532 285.779 310.35 285.089C309.759 284.745 309.216 284.712 308.839 284.942L292.167 294.564L292.151 294.58Z",
    fill: "url(#paint13_linear_358_13776)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M259.153 258.472L262.159 263.727L278.847 254.088C279.241 253.858 279.487 253.382 279.487 252.692C279.487 251.329 278.535 249.671 277.352 248.981C276.761 248.636 276.219 248.604 275.841 248.833L259.17 258.456L259.153 258.472Z",
    fill: "#8F9584"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M261.058 239.786L261.962 241.362C260.024 244.548 258.94 248.817 258.94 254.006C258.94 271.247 270.963 292.15 285.794 300.722C290.246 303.283 294.434 304.449 298.13 304.35L299 305.878L302.679 303.743C307.541 300.902 310.547 294.843 310.547 286.222C310.547 268.998 298.524 248.078 283.692 239.507C276.284 235.221 269.567 234.843 264.705 237.684L261.042 239.786H261.058Z",
    fill: "url(#paint14_linear_358_13776)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M298.886 305.928C309.438 299.913 309.541 280.221 299.117 261.944C288.694 243.666 271.689 233.725 261.138 239.74C250.586 245.754 250.482 265.447 260.906 283.724C271.33 302.001 288.334 311.942 298.886 305.928Z",
    fill: "url(#paint15_linear_358_13776)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M247.475 269.113L266.824 302.955L289.671 289.769C292.2 288.324 293.761 285.221 293.761 280.771C293.761 271.953 287.601 261.264 280.013 256.879C276.202 254.679 272.753 254.499 270.273 255.96L247.475 269.113Z",
    fill: "url(#paint16_linear_358_13776)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M283.216 299.539C283.281 300.508 283.61 301.608 284.218 302.676C284.809 303.71 285.581 304.548 286.369 305.089L287.256 306.633L289.162 305.533C290.525 304.728 290.525 302.167 289.162 299.802C287.798 297.438 285.597 296.173 284.234 296.945L282.345 298.029L283.199 299.539H283.216Z",
    fill: "url(#paint17_linear_358_13776)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M282.329 303.759C283.692 306.124 285.909 307.405 287.273 306.616C288.636 305.812 288.636 303.25 287.273 300.886C285.909 298.521 283.692 297.24 282.329 298.029C280.966 298.833 280.966 301.395 282.329 303.759Z",
    fill: "#C3C3CA"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M287.946 256.239C288.012 257.208 288.34 258.308 288.948 259.375C289.539 260.41 290.311 261.247 291.1 261.789L291.987 263.333L293.892 262.232C295.255 261.428 295.255 258.866 293.892 256.502C292.529 254.137 290.328 252.873 288.964 253.645L287.076 254.728L287.93 256.239H287.946Z",
    fill: "url(#paint18_linear_358_13776)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M287.076 260.475C288.439 262.84 290.656 264.121 292.02 263.333C293.383 262.528 293.383 259.966 292.02 257.602C290.656 255.237 288.439 253.957 287.076 254.745C285.712 255.549 285.712 258.111 287.076 260.475Z",
    fill: "#C3C3CA"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M254.653 260.869C254.718 261.838 255.047 262.938 255.655 264.006C256.246 265.04 257.018 265.878 257.806 266.42L258.693 267.963L260.599 266.863C261.962 266.058 261.962 263.497 260.599 261.132C259.235 258.768 257.034 257.503 255.671 258.275L253.782 259.359L254.636 260.869H254.653Z",
    fill: "#BEC3C9"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M253.766 265.089C255.129 267.454 257.346 268.735 258.71 267.947C260.073 267.142 260.073 264.58 258.71 262.216C257.346 259.851 255.129 258.571 253.766 259.359C252.403 260.163 252.403 262.725 253.766 265.089Z",
    fill: "#C3C3CA"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M238.573 265.237L276.728 315.828L280.736 313.513C281.54 313.053 282.066 312.068 282.066 310.574V268.242C282.066 264.236 278.338 259.556 275.332 259.819L243.533 262.627C243.155 262.659 242.827 262.774 242.548 262.939L238.573 265.237Z",
    fill: "url(#paint19_linear_358_13776)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M278.042 312.905V270.574C278.042 266.567 274.313 261.888 271.308 262.15L239.509 264.958C236.487 265.221 236.487 270.278 239.509 274.022L271.308 313.546C274.313 317.273 278.042 316.912 278.042 312.905Z",
    fill: "url(#paint20_linear_358_13776)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M237.275 275.007L256.624 308.85L272.293 299.802C274.823 298.357 276.383 295.254 276.383 290.804C276.383 281.986 270.224 271.296 262.635 266.912C258.825 264.712 255.375 264.531 252.895 265.993L237.259 275.007H237.275Z",
    fill: "url(#paint21_linear_358_13776)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M273.016 305.976C274.511 306.83 275.726 308.948 275.726 310.672C275.726 312.396 274.511 313.119 273.016 312.249C271.521 311.395 270.306 309.277 270.306 307.553C270.306 305.828 271.521 305.106 273.016 305.976Z",
    fill: "#C8C8CF"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M273.016 271.707C274.511 272.561 275.726 271.855 275.726 270.131C275.726 268.406 274.511 266.288 273.016 265.434C271.521 264.58 270.306 265.287 270.306 267.011C270.306 268.735 271.521 270.853 273.016 271.707Z",
    fill: "#C8C8CF"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M245.192 271.182C244.453 269.244 242.794 267.766 241.496 267.881C240.199 267.996 239.755 269.654 240.494 271.592C241.234 273.53 242.892 275.007 244.19 274.893C245.488 274.778 245.931 273.119 245.192 271.182Z",
    fill: "#C8C8CF"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M274.198 311.575C272.704 310.722 271.488 308.603 271.488 306.879C271.488 306.354 271.603 305.943 271.8 305.631C270.93 305.631 270.322 306.337 270.322 307.569C270.322 309.309 271.538 311.411 273.032 312.265C274.083 312.873 274.97 312.692 275.43 311.937C275.069 311.937 274.658 311.838 274.215 311.592L274.198 311.575Z",
    fill: "#A5A7B3"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M274.198 271.017C272.704 270.163 271.488 268.045 271.488 266.321C271.488 265.796 271.603 265.385 271.8 265.073C270.93 265.073 270.322 265.779 270.322 267.011C270.322 268.751 271.538 270.853 273.032 271.707C274.083 272.314 274.97 272.134 275.43 271.378C275.069 271.378 274.658 271.28 274.215 271.034L274.198 271.017Z",
    fill: "#A5A7B3"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M241.677 270.919C241.201 269.687 241.217 268.571 241.611 267.897C241.578 267.897 241.529 267.897 241.496 267.897C240.199 268.012 239.755 269.671 240.494 271.608C241.234 273.546 242.892 275.024 244.19 274.909C244.666 274.86 245.028 274.613 245.258 274.219C243.977 274.236 242.4 272.807 241.677 270.935V270.919Z",
    fill: "#A5A7B3"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M246.966 275.96C254.554 280.344 260.714 291.034 260.714 299.851C260.714 308.669 254.554 312.265 246.966 307.881C239.378 303.497 233.218 292.807 233.218 283.989C233.218 275.172 239.378 271.575 246.966 275.96Z",
    fill: "#EFF1F3"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M246.966 277.75C253.7 281.641 259.153 291.132 259.153 298.948C259.153 306.764 253.7 309.966 246.966 306.075C240.232 302.183 234.779 292.692 234.779 284.876C234.779 277.06 240.232 273.858 246.966 277.75Z",
    fill: "#43474A"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M246.966 279.638C252.797 283.004 257.544 291.231 257.544 298.012C257.544 304.794 252.813 307.552 246.966 304.186C241.135 300.82 236.388 292.594 236.388 285.812C236.388 279.03 241.119 276.272 246.966 279.638Z",
    fill: "#EFF1F3"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M246.966 281.165C252.074 284.121 256.213 291.313 256.213 297.257C256.213 303.201 252.074 305.615 246.966 302.659C241.858 299.704 237.719 292.512 237.719 286.567C237.719 280.623 241.858 278.209 246.966 281.165Z",
    fill: "url(#paint22_linear_358_13776)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M253.519 300.722L256.032 299.277C256.147 298.653 256.213 297.996 256.213 297.273C256.213 291.329 252.074 284.137 246.966 281.181C246.358 280.837 245.767 280.557 245.192 280.36L242.679 281.805L246.867 289.129C247.491 290.656 248.329 292.117 249.331 293.414L253.519 300.722Z",
    fill: "#A8ADA0"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M240.445 286.814C240.445 291.74 243.894 297.733 248.132 300.18C252.37 302.626 255.819 300.623 255.819 295.681C255.819 294.449 255.605 293.168 255.228 291.871C254.374 289.424 253.043 287.043 251.401 285.04C250.415 283.924 249.315 282.988 248.148 282.314C243.911 279.868 240.462 281.871 240.462 286.814H240.445Z",
    fill: "#EFF1F3"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M248.132 284.236C251.466 286.157 254.16 290.853 254.16 294.728C254.16 298.603 251.466 300.18 248.132 298.259C244.798 296.337 242.104 291.641 242.104 287.766C242.104 283.891 244.798 282.315 248.132 284.236Z",
    fill: "#43474A"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M182.136 342.413L185.98 340.196C186.243 339.391 186.391 338.981 186.67 338.193C186.029 335.073 185.438 332.002 184.896 328.915C183.648 327.733 183.007 327.158 181.726 326.009C178.129 327.06 174.762 328.455 171.608 330.212L167.765 332.429L182.12 342.413H182.136Z",
    fill: "#F4D144"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M162.098 337.191C167.781 331.871 174.22 328.193 181.726 326.009C183.007 327.158 179.804 329.95 181.052 331.132C181.594 334.219 182.186 337.29 182.826 340.409C182.531 341.198 182.399 341.608 182.137 342.413C177.078 344.203 172.61 346.764 168.504 350.179C167.666 349.999 167.239 349.917 166.401 349.769C164.003 347.651 161.622 345.598 159.207 343.579C158.813 341.92 162.459 338.866 162.114 337.191H162.098Z",
    fill: "#AC6E14"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M219.799 393.808C219.569 374.695 206.002 351.756 189.511 342.577C173.021 333.398 159.848 341.427 160.078 360.541C160.308 379.654 173.875 402.593 190.365 411.772C206.856 420.951 220.029 412.922 219.799 393.808ZM190.152 390.77C183.746 387.076 178.556 378.11 178.556 370.771C178.556 363.431 183.746 360.459 190.152 364.153C196.558 367.848 201.748 376.813 201.748 384.153C201.748 391.493 196.558 394.465 190.152 390.77Z",
    fill: "url(#paint23_linear_358_13776)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M221.326 392.921C221.097 373.808 207.53 350.869 191.039 341.69C182.925 337.175 175.616 336.83 170.311 339.9L168.783 340.787C174.088 337.7 181.397 338.061 189.511 342.577C206.002 351.756 219.553 374.695 219.799 393.808C219.914 403.513 216.58 410.376 211.094 413.562L212.621 412.675C218.107 409.49 221.458 402.642 221.326 392.921Z",
    fill: "url(#paint24_linear_358_13776)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M189.166 347.487C189.166 348.061 189.577 348.767 190.07 349.063C190.579 349.358 190.973 349.129 190.973 348.537C190.973 347.946 190.563 347.257 190.07 346.961C189.561 346.666 189.166 346.895 189.166 347.487Z",
    fill: "#666863"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M192.123 354.991C192.123 355.565 192.534 356.272 193.026 356.567C193.535 356.863 193.93 356.633 193.93 356.042C193.93 355.451 193.519 354.761 193.026 354.465C192.517 354.17 192.123 354.4 192.123 354.991Z",
    fill: "#666863"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M193.962 363.201C193.962 363.775 194.373 364.481 194.866 364.777C195.359 365.073 195.769 364.843 195.769 364.252C195.769 363.66 195.359 362.971 194.866 362.675C194.357 362.38 193.962 362.61 193.962 363.201Z",
    fill: "#666863"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M194.455 370.771C194.455 371.345 194.866 372.051 195.359 372.347C195.851 372.642 196.262 372.413 196.262 371.821C196.262 371.23 195.851 370.541 195.359 370.245C194.849 369.949 194.455 370.179 194.455 370.771Z",
    fill: "#666863"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M215.791 391.099C215.282 390.804 214.888 391.033 214.888 391.625C214.888 392.216 215.299 392.905 215.791 393.201C216.3 393.496 216.695 393.267 216.695 392.675C216.695 392.084 216.284 391.395 215.791 391.099Z",
    fill: "#666863"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M210.716 391.575C210.207 391.28 209.813 391.509 209.813 392.101C209.813 392.692 210.223 393.381 210.716 393.677C211.225 393.973 211.619 393.743 211.619 393.151C211.619 392.56 211.209 391.871 210.716 391.575Z",
    fill: "#666863"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M204.491 390.081C203.982 389.785 203.588 390.015 203.588 390.606C203.588 391.198 203.998 391.887 204.491 392.183C205 392.478 205.394 392.248 205.394 391.657C205.394 391.066 204.984 390.377 204.491 390.081Z",
    fill: "#666863"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M198.134 386.977C197.625 386.682 197.231 386.912 197.231 387.503C197.231 388.094 197.642 388.784 198.134 389.079C198.644 389.375 199.038 389.145 199.038 388.554C199.038 387.963 198.627 387.273 198.134 386.977Z",
    fill: "#666863"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M191.154 407.421C191.154 406.846 190.743 406.14 190.25 405.844C189.758 405.549 189.347 405.778 189.347 406.37C189.347 406.961 189.758 407.65 190.25 407.946C190.743 408.242 191.154 408.012 191.154 407.421Z",
    fill: "#666863"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M188.197 399.9C188.197 399.325 187.787 398.619 187.294 398.324C186.785 398.028 186.391 398.258 186.391 398.849C186.391 399.44 186.801 400.13 187.294 400.425C187.803 400.721 188.197 400.491 188.197 399.9Z",
    fill: "#666863"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M186.358 391.69C186.358 391.115 185.947 390.409 185.454 390.114C184.945 389.818 184.551 390.048 184.551 390.639C184.551 391.23 184.962 391.92 185.454 392.216C185.964 392.511 186.358 392.281 186.358 391.69Z",
    fill: "#666863"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M185.865 384.137C185.865 383.562 185.454 382.856 184.962 382.56C184.452 382.265 184.058 382.495 184.058 383.086C184.058 383.677 184.469 384.366 184.962 384.662C185.471 384.958 185.865 384.728 185.865 384.137Z",
    fill: "#666863"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M171.329 346.6C171.69 347.207 172.265 347.552 172.61 347.339C172.971 347.142 172.971 346.469 172.61 345.861C172.249 345.253 171.674 344.909 171.329 345.122C170.968 345.319 170.968 345.992 171.329 346.6Z",
    fill: "#666863"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M176.995 351.592C177.357 352.199 177.932 352.544 178.277 352.33C178.638 352.133 178.638 351.46 178.277 350.853C177.915 350.245 177.34 349.9 176.995 350.114C176.634 350.311 176.634 350.984 176.995 351.592Z",
    fill: "#666863"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M182.711 358.439C183.073 359.047 183.648 359.391 183.993 359.178C184.354 358.981 184.354 358.308 183.993 357.7C183.631 357.093 183.056 356.748 182.711 356.961C182.35 357.158 182.35 357.831 182.711 358.439Z",
    fill: "#666863"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M187.557 365.992C187.918 366.6 188.493 366.945 188.838 366.731C189.199 366.534 189.199 365.861 188.838 365.253C188.477 364.646 187.902 364.301 187.557 364.514C187.212 364.728 187.195 365.385 187.557 365.992Z",
    fill: "#666863"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M207.579 365.91C207.217 366.107 207.217 366.78 207.579 367.388C207.94 367.996 208.515 368.34 208.86 368.127C209.221 367.93 209.221 367.257 208.86 366.649C208.499 366.041 207.924 365.697 207.579 365.91Z",
    fill: "#666863"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M206.084 371.559C205.723 371.756 205.723 372.429 206.084 373.037C206.445 373.644 207.02 373.989 207.365 373.776C207.727 373.579 207.727 372.905 207.365 372.298C207.004 371.69 206.429 371.345 206.084 371.559Z",
    fill: "#666863"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M202.98 376.321C202.618 376.518 202.618 377.191 202.98 377.798C203.341 378.406 203.916 378.751 204.261 378.537C204.622 378.34 204.622 377.667 204.261 377.059C203.9 376.452 203.325 376.107 202.98 376.321Z",
    fill: "#666863"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M198.841 379.473C198.479 379.67 198.479 380.344 198.841 380.951C199.202 381.559 199.777 381.904 200.122 381.69C200.467 381.477 200.483 380.82 200.122 380.212C199.76 379.605 199.186 379.26 198.841 379.473Z",
    fill: "#666863"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M208.975 408.291C208.614 407.683 208.039 407.339 207.694 407.552C207.332 407.749 207.332 408.422 207.694 409.03C208.055 409.637 208.63 409.982 208.975 409.769C209.32 409.555 209.336 408.898 208.975 408.291Z",
    fill: "#666863"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M203.308 403.316C202.947 402.708 202.372 402.363 202.027 402.577C201.682 402.79 201.666 403.447 202.027 404.054C202.389 404.662 202.963 405.007 203.308 404.793C203.653 404.58 203.67 403.923 203.308 403.316Z",
    fill: "#666863"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M197.592 396.452C197.231 395.844 196.656 395.499 196.311 395.713C195.95 395.91 195.95 396.583 196.311 397.191C196.673 397.798 197.247 398.143 197.592 397.93C197.954 397.733 197.954 397.059 197.592 396.452Z",
    fill: "#666863"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M192.763 388.915C192.402 388.307 191.827 387.963 191.482 388.176C191.137 388.389 191.121 389.046 191.482 389.654C191.844 390.261 192.419 390.606 192.763 390.393C193.108 390.179 193.125 389.522 192.763 388.915Z",
    fill: "#666863"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M172.741 388.997C173.103 388.8 173.103 388.127 172.741 387.519C172.38 386.912 171.805 386.567 171.46 386.78C171.099 386.978 171.099 387.651 171.46 388.258C171.822 388.866 172.397 389.211 172.741 388.997Z",
    fill: "#666863"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M174.236 383.349C174.597 383.152 174.597 382.478 174.236 381.871C173.875 381.263 173.3 380.918 172.955 381.132C172.594 381.329 172.594 382.002 172.955 382.61C173.316 383.217 173.891 383.562 174.236 383.349Z",
    fill: "#666863"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M177.34 378.587C177.702 378.39 177.702 377.716 177.34 377.109C176.979 376.501 176.404 376.156 176.059 376.37C175.714 376.583 175.698 377.24 176.059 377.848C176.421 378.455 176.996 378.8 177.34 378.587Z",
    fill: "#666863"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M181.48 375.434C181.841 375.237 181.841 374.564 181.48 373.956C181.118 373.349 180.543 373.004 180.198 373.217C179.837 373.414 179.837 374.088 180.198 374.695C180.56 375.303 181.135 375.647 181.48 375.434Z",
    fill: "#666863"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M164.529 363.792C165.038 364.087 165.432 363.858 165.432 363.266C165.432 362.675 165.022 361.986 164.529 361.69C164.02 361.395 163.626 361.624 163.626 362.216C163.626 362.807 164.036 363.496 164.529 363.792Z",
    fill: "#666863"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M169.588 363.332C170.097 363.628 170.491 363.398 170.491 362.807C170.491 362.216 170.081 361.526 169.588 361.23C169.095 360.935 168.684 361.165 168.684 361.756C168.684 362.347 169.095 363.037 169.588 363.332Z",
    fill: "#666863"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M175.829 364.81C176.339 365.106 176.733 364.876 176.733 364.285C176.733 363.693 176.322 363.004 175.829 362.708C175.32 362.413 174.926 362.643 174.926 363.234C174.926 363.825 175.337 364.514 175.829 364.81Z",
    fill: "#666863"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M182.169 367.914C182.679 368.209 183.073 367.979 183.073 367.388C183.073 366.797 182.662 366.107 182.169 365.812C181.66 365.516 181.266 365.746 181.266 366.337C181.266 366.928 181.677 367.618 182.169 367.914Z",
    fill: "#666863"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M193.026 384.777L187.261 388.127C186.226 388.718 184.814 388.652 183.237 387.782C180.034 386.008 177.406 381.559 177.373 377.848C177.357 375.959 177.997 374.629 179.065 374.022L184.83 370.672C183.763 371.296 183.122 372.626 183.138 374.498C183.188 378.209 185.816 382.642 189.002 384.432C190.579 385.302 191.991 385.368 193.026 384.777Z",
    fill: "#62635F"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M199.153 386.682L202.717 384.613C202.766 388.866 201.304 391.854 198.906 393.25L195.342 395.319C197.74 393.923 199.202 390.935 199.153 386.682Z",
    fill: "#7C7D7A"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M176.848 363.496L180.412 361.427C182.728 360.081 185.931 360.229 189.478 362.215C196.689 366.238 202.618 376.255 202.717 384.613L199.153 386.682C199.054 378.324 193.125 368.307 185.914 364.284C182.366 362.314 179.18 362.15 176.848 363.496Z",
    fill: "#7C7D7A"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M184.157 339.703C184.157 339.703 184.157 339.671 184.14 339.654C183.451 338.061 182.038 336.945 181.036 337.191C172.462 339.276 165.219 343.398 159.076 349.703C158.353 350.442 158.616 352.216 159.667 353.611L159.7 353.661C160.308 354.465 157.121 357.207 157.745 357.306L156.973 358.094L162.427 354.941C162.525 354.892 162.607 354.826 162.689 354.744C167.255 350.048 172.446 346.633 178.392 344.416L178.359 345.894L183.795 342.758C184.518 342.331 184.732 341.066 184.157 339.72V339.703Z",
    fill: "#31312D"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M153.688 352.79C159.831 346.485 167.058 342.363 175.649 340.278C176.667 340.032 178.08 341.165 178.753 342.741C178.753 342.758 178.753 342.774 178.769 342.79C179.426 344.301 179.164 345.664 178.211 345.894C170.031 347.881 163.149 351.805 157.302 357.815C156.612 358.521 155.298 358.045 154.313 356.731C154.313 356.731 154.296 356.698 154.28 356.682C153.245 355.303 152.966 353.529 153.688 352.774V352.79Z",
    fill: "#464643"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M209.057 400.015C208.827 380.902 195.26 357.963 178.769 348.784C162.279 339.605 149.106 347.635 149.336 366.748C149.566 385.861 163.133 408.8 179.623 417.979C196.114 427.158 209.287 419.129 209.057 400.015ZM179.41 396.978C173.004 393.283 167.814 384.317 167.814 376.978C167.814 369.638 173.004 366.666 179.41 370.36C185.816 374.055 191.006 383.02 191.006 390.36C191.006 397.7 185.816 400.672 179.41 396.978Z",
    fill: "url(#paint25_linear_358_13776)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M210.585 399.129C210.355 380.015 196.788 357.076 180.297 347.897C172.183 343.382 164.874 343.037 159.569 346.107L158.041 346.994C163.346 343.907 170.655 344.268 178.769 348.784C195.26 357.963 208.811 380.902 209.057 400.015C209.172 409.72 205.838 416.583 200.352 419.769L201.879 418.882C207.365 415.697 210.716 408.849 210.585 399.129Z",
    fill: "url(#paint26_linear_358_13776)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M178.424 353.694C178.424 354.268 178.835 354.974 179.328 355.27C179.821 355.566 180.231 355.336 180.231 354.744C180.231 354.153 179.821 353.464 179.328 353.168C178.835 352.873 178.424 353.102 178.424 353.694Z",
    fill: "#666863"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M181.365 361.198C181.365 361.772 181.775 362.479 182.268 362.774C182.777 363.07 183.171 362.84 183.171 362.249C183.171 361.658 182.761 360.968 182.268 360.672C181.775 360.377 181.365 360.607 181.365 361.198Z",
    fill: "#666863"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M183.221 369.424C183.221 369.999 183.631 370.705 184.124 371.001C184.633 371.296 185.027 371.066 185.027 370.475C185.027 369.884 184.617 369.194 184.124 368.899C183.615 368.603 183.221 368.833 183.221 369.424Z",
    fill: "#666863"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M183.697 376.978C183.697 377.552 184.108 378.258 184.6 378.554C185.109 378.849 185.504 378.62 185.504 378.028C185.504 377.437 185.093 376.748 184.6 376.452C184.091 376.157 183.697 376.386 183.697 376.978Z",
    fill: "#666863"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M205.033 397.322C204.524 397.027 204.13 397.257 204.13 397.848C204.13 398.439 204.54 399.129 205.033 399.424C205.526 399.72 205.936 399.49 205.936 398.899C205.936 398.308 205.526 397.618 205.033 397.322Z",
    fill: "#666863"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M199.974 397.782C199.465 397.487 199.071 397.717 199.071 398.308C199.071 398.899 199.481 399.588 199.974 399.884C200.483 400.18 200.877 399.95 200.877 399.359C200.877 398.767 200.467 398.078 199.974 397.782Z",
    fill: "#666863"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M193.733 396.304C193.223 396.009 192.829 396.239 192.829 396.83C192.829 397.421 193.24 398.111 193.733 398.406C194.242 398.702 194.636 398.472 194.636 397.881C194.636 397.29 194.225 396.6 193.733 396.304Z",
    fill: "#666863"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M187.392 393.201C186.883 392.905 186.489 393.135 186.489 393.726C186.489 394.317 186.9 395.007 187.392 395.303C187.902 395.598 188.296 395.368 188.296 394.777C188.296 394.186 187.885 393.496 187.392 393.201Z",
    fill: "#666863"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M180.395 413.628C180.395 413.053 179.985 412.347 179.492 412.051C178.983 411.756 178.589 411.986 178.589 412.577C178.589 413.168 178.999 413.857 179.492 414.153C180.001 414.449 180.395 414.219 180.395 413.628Z",
    fill: "#666863"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M177.455 406.124C177.455 405.549 177.045 404.843 176.552 404.547C176.043 404.252 175.649 404.482 175.649 405.073C175.649 405.664 176.059 406.354 176.552 406.649C177.061 406.945 177.455 406.715 177.455 406.124Z",
    fill: "#666863"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M175.599 397.897C175.599 397.322 175.189 396.616 174.696 396.321C174.187 396.025 173.793 396.255 173.793 396.846C173.793 397.437 174.203 398.127 174.696 398.423C175.205 398.718 175.599 398.488 175.599 397.897Z",
    fill: "#666863"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M175.123 390.344C175.123 389.769 174.712 389.063 174.22 388.767C173.71 388.472 173.316 388.702 173.316 389.293C173.316 389.884 173.727 390.574 174.22 390.869C174.729 391.165 175.123 390.935 175.123 390.344Z",
    fill: "#666863"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M160.587 352.807C160.948 353.414 161.523 353.759 161.868 353.546C162.213 353.332 162.229 352.676 161.868 352.068C161.507 351.46 160.932 351.116 160.587 351.329C160.226 351.526 160.226 352.199 160.587 352.807Z",
    fill: "#666863"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M166.254 357.799C166.615 358.406 167.19 358.751 167.535 358.538C167.88 358.324 167.896 357.667 167.535 357.06C167.173 356.452 166.598 356.107 166.254 356.321C165.909 356.534 165.892 357.191 166.254 357.799Z",
    fill: "#666863"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M171.969 364.662C172.331 365.27 172.906 365.615 173.251 365.401C173.612 365.204 173.612 364.531 173.251 363.923C172.889 363.316 172.314 362.971 171.969 363.185C171.625 363.398 171.608 364.055 171.969 364.662Z",
    fill: "#666863"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M176.798 372.199C177.16 372.807 177.735 373.152 178.08 372.938C178.424 372.725 178.441 372.068 178.08 371.46C177.718 370.853 177.143 370.508 176.798 370.721C176.453 370.935 176.437 371.592 176.798 372.199Z",
    fill: "#666863"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M196.837 372.117C196.476 372.314 196.476 372.987 196.837 373.595C197.198 374.203 197.773 374.547 198.118 374.334C198.479 374.137 198.479 373.464 198.118 372.856C197.757 372.249 197.182 371.904 196.837 372.117Z",
    fill: "#666863"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M195.342 377.766C194.981 377.963 194.981 378.636 195.342 379.244C195.704 379.851 196.278 380.196 196.623 379.983C196.985 379.786 196.985 379.112 196.623 378.505C196.262 377.897 195.687 377.552 195.342 377.766Z",
    fill: "#666863"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M192.238 382.528C191.877 382.725 191.877 383.398 192.238 384.005C192.599 384.613 193.174 384.958 193.519 384.744C193.88 384.547 193.88 383.874 193.519 383.266C193.158 382.659 192.583 382.314 192.238 382.528Z",
    fill: "#666863"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M188.082 385.68C187.721 385.877 187.721 386.551 188.082 387.158C188.444 387.766 189.019 388.111 189.363 387.897C189.725 387.7 189.725 387.027 189.363 386.419C189.002 385.812 188.427 385.467 188.082 385.68Z",
    fill: "#666863"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M198.233 414.514C197.872 413.907 197.297 413.562 196.952 413.775C196.59 413.972 196.59 414.646 196.952 415.253C197.313 415.861 197.888 416.206 198.233 415.992C198.594 415.795 198.594 415.122 198.233 414.514Z",
    fill: "#666863"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M192.566 409.523C192.205 408.915 191.63 408.57 191.285 408.784C190.924 408.981 190.924 409.654 191.285 410.262C191.647 410.869 192.221 411.214 192.566 411C192.928 410.803 192.928 410.13 192.566 409.523Z",
    fill: "#666863"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M186.85 402.675C186.489 402.068 185.914 401.723 185.569 401.936C185.224 402.15 185.208 402.807 185.569 403.414C185.931 404.022 186.506 404.366 186.85 404.153C187.212 403.956 187.212 403.283 186.85 402.675Z",
    fill: "#666863"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M182.022 395.122C181.66 394.514 181.085 394.17 180.74 394.383C180.379 394.58 180.379 395.253 180.74 395.861C181.102 396.468 181.677 396.813 182.022 396.6C182.383 396.403 182.383 395.73 182.022 395.122Z",
    fill: "#666863"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M161.983 395.204C162.344 395.007 162.344 394.334 161.983 393.726C161.622 393.119 161.047 392.774 160.702 392.988C160.357 393.201 160.341 393.858 160.702 394.465C161.063 395.073 161.638 395.418 161.983 395.204Z",
    fill: "#666863"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M163.478 389.556C163.839 389.359 163.839 388.685 163.478 388.078C163.116 387.47 162.542 387.125 162.197 387.339C161.835 387.536 161.835 388.209 162.197 388.817C162.558 389.424 163.133 389.769 163.478 389.556Z",
    fill: "#666863"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M166.582 384.794C166.943 384.597 166.943 383.923 166.582 383.316C166.221 382.708 165.646 382.363 165.301 382.577C164.956 382.79 164.94 383.447 165.301 384.055C165.662 384.662 166.237 385.007 166.582 384.794Z",
    fill: "#666863"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M170.721 381.641C171.082 381.444 171.082 380.771 170.721 380.163C170.36 379.556 169.785 379.211 169.44 379.424C169.095 379.638 169.079 380.295 169.44 380.902C169.801 381.51 170.376 381.854 170.721 381.641Z",
    fill: "#666863"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M153.787 370.015C154.296 370.311 154.69 370.081 154.69 369.49C154.69 368.899 154.28 368.209 153.787 367.914C153.278 367.618 152.884 367.848 152.884 368.439C152.884 369.03 153.294 369.72 153.787 370.015Z",
    fill: "#666863"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M158.846 369.539C159.355 369.835 159.749 369.605 159.749 369.014C159.749 368.423 159.339 367.733 158.846 367.437C158.337 367.142 157.943 367.372 157.943 367.963C157.943 368.554 158.353 369.244 158.846 369.539Z",
    fill: "#666863"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M165.087 371.033C165.597 371.329 165.991 371.099 165.991 370.508C165.991 369.917 165.58 369.227 165.087 368.932C164.595 368.636 164.184 368.866 164.184 369.457C164.184 370.048 164.595 370.738 165.087 371.033Z",
    fill: "#666863"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M171.427 374.121C171.937 374.416 172.331 374.186 172.331 373.595C172.331 373.004 171.92 372.314 171.427 372.019C170.918 371.723 170.524 371.953 170.524 372.544C170.524 373.135 170.935 373.825 171.427 374.121Z",
    fill: "#666863"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M183.68 390.212L177.915 393.562C176.88 394.153 175.468 394.087 173.891 393.217C170.688 391.444 168.06 386.994 168.027 383.283C168.011 381.395 168.652 380.064 169.719 379.457L175.484 376.107C174.417 376.731 173.776 378.061 173.793 379.933C173.842 383.644 176.47 388.078 179.656 389.867C181.233 390.738 182.646 390.803 183.68 390.212Z",
    fill: "url(#paint27_linear_358_13776)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M178.72 368.422C175.172 366.452 171.986 366.288 169.654 367.634L164.562 370.59C166.878 369.243 170.081 369.391 173.628 371.378C180.839 375.401 186.768 385.417 186.867 393.775C186.916 398.028 185.454 401.017 183.056 402.413L188.148 399.457C190.546 398.061 192.008 395.073 191.959 390.82C191.86 382.462 185.931 372.445 178.72 368.422Z",
    fill: "url(#paint28_linear_358_13776)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M186.867 393.775C186.965 402.133 181.2 405.647 174.006 401.624C166.796 397.601 160.866 387.585 160.768 379.227C160.669 370.869 166.434 367.355 173.628 371.378C180.839 375.401 186.768 385.418 186.867 393.775ZM179.607 389.736C179.558 386.025 176.93 381.592 173.743 379.802C170.54 378.028 167.995 379.588 168.044 383.283C168.093 386.994 170.721 391.427 173.908 393.217C177.11 394.991 179.656 393.431 179.607 389.736Z",
    fill: "url(#paint29_linear_358_13776)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M148.022 345.319C153.705 339.999 160.143 336.321 167.65 334.137C168.931 335.286 169.555 335.861 170.82 337.043C171.362 340.13 171.953 343.201 172.594 346.321C172.298 347.109 172.167 347.52 171.904 348.324C166.845 350.114 162.377 352.675 158.271 356.091C157.433 355.91 157.006 355.828 156.169 355.68C153.771 353.562 151.389 351.51 148.974 349.49C148.58 347.831 148.383 346.994 148.038 345.319H148.022Z",
    fill: "#4A191C"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M168.044 350.541L171.887 348.324C172.15 347.52 172.281 347.109 172.577 346.321C171.937 343.201 171.345 340.13 170.803 337.043C169.555 335.861 168.914 335.286 167.633 334.137C164.036 335.188 160.669 336.584 157.515 338.341L153.672 340.557L168.027 350.541H168.044Z",
    fill: "#F4D144"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M153.688 340.557L163.806 336.354L181.726 326.009L171.608 330.212L153.688 340.557Z",
    fill: "#AC6E14"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M154.411 358.308L158.255 356.091C160.193 354.465 162.213 353.053 164.348 351.805L156.793 338.767C155.643 339.441 154.05 340.212 152.949 340.984C151.077 342.298 149.763 343.693 148.038 345.319C148.4 346.994 148.58 347.831 148.974 349.49C151.389 351.509 152.03 356.189 154.428 358.308H154.411Z",
    fill: "#AC6E14"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M161.26 353.595C163.412 352.396 165.662 351.378 168.06 350.541C168.323 349.736 168.454 349.326 168.75 348.537C168.11 345.418 167.518 342.347 166.976 339.26C165.728 338.078 165.087 337.503 163.806 336.354C160.209 337.404 156.842 338.8 153.688 340.557L161.244 353.595H161.26Z",
    fill: "#D39623"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M152.309 357.897C153.146 358.045 153.573 358.127 154.411 358.308C156.349 356.682 158.37 355.27 160.505 354.022L152.949 340.984C149.829 342.79 146.921 344.974 144.195 347.536C144.556 349.211 144.737 350.048 145.131 351.707C147.546 353.726 149.927 355.779 152.325 357.897H152.309Z",
    fill: "#D39623"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M166.976 339.26L163.806 336.354L181.726 326.009L184.896 328.915L166.976 339.26Z",
    fill: "#F2C636"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M166.976 339.26L167.765 343.644L185.684 333.3L184.896 328.915L166.976 339.26Z",
    fill: "#F4D144"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M232.413 478.619C232.873 478.472 233.333 478.34 233.777 478.192C232.463 478.603 231.461 477.831 231.428 476.206C231.395 474.301 232.725 471.953 234.401 470.951C235.863 470.081 237.111 470.524 237.423 471.936C237.374 471.706 237.324 471.477 237.275 471.23C237.226 471 237.177 470.77 237.127 470.524C236.717 468.718 235.123 468.127 233.235 469.26C231.066 470.557 229.358 473.595 229.408 476.058C229.44 478.143 230.738 479.145 232.43 478.619H232.413Z",
    fill: "#B0B1B7"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M225.597 475.614L230.541 478.488C229.851 478.094 229.424 477.256 229.408 476.058C229.358 473.595 231.083 470.557 233.235 469.26C234.351 468.603 235.353 468.521 236.093 468.948L231.149 466.074C230.426 465.647 229.408 465.729 228.291 466.386C226.123 467.683 224.414 470.721 224.464 473.184C224.48 474.383 224.924 475.22 225.597 475.614Z",
    fill: "url(#paint30_linear_358_13776)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M232.331 478.094L233.777 478.931C233.251 478.619 232.906 477.979 232.89 477.043C232.857 475.138 234.187 472.79 235.863 471.788C236.717 471.279 237.505 471.214 238.08 471.542L236.635 470.705C236.076 470.376 235.288 470.426 234.417 470.951C232.742 471.953 231.411 474.301 231.444 476.206C231.461 477.125 231.789 477.782 232.331 478.094Z",
    fill: "#6C6D79"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M232.955 477.7C232.955 477.7 232.955 477.765 232.972 477.798C232.972 477.798 232.972 477.831 232.972 477.847C232.972 477.88 232.972 477.913 232.988 477.946C233.005 477.979 232.988 478.012 233.005 478.044C233.005 478.044 233.005 478.077 233.005 478.094C233.005 478.127 233.005 478.159 233.021 478.192C233.021 478.225 233.021 478.258 233.037 478.291C233.037 478.291 233.037 478.324 233.037 478.34C233.037 478.373 233.037 478.406 233.054 478.439C233.054 478.471 233.054 478.504 233.07 478.537C233.07 478.537 233.07 478.57 233.07 478.586C233.07 478.619 233.07 478.652 233.087 478.685C233.037 478.439 233.005 478.176 233.005 477.897C232.955 475.581 234.581 472.708 236.618 471.493C236.93 471.312 237.226 471.181 237.505 471.082C237.16 471.181 236.832 471.296 236.487 471.394C236.257 471.46 236.01 471.575 235.764 471.723C234.089 472.724 232.758 475.072 232.791 476.977C232.791 477.207 232.824 477.42 232.857 477.618L232.955 477.7Z",
    fill: "#6C6D79"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M234.171 480.245L240.708 484.071C240.067 483.693 245.258 474.678 245.931 475.073L239.394 471.247C238.704 470.852 237.751 470.918 236.7 471.542C234.664 472.757 233.037 475.631 233.087 477.946C233.103 479.079 233.514 479.867 234.154 480.245H234.171Z",
    fill: "url(#paint31_linear_358_13776)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M255.014 493.151C251.581 495.204 248.74 493.693 248.674 489.785C248.608 485.877 251.318 481.05 254.751 479.013C258.184 476.961 261.026 478.472 261.091 482.38C261.157 486.288 258.447 491.115 255.014 493.151ZM260.303 482.839C260.237 479.424 257.757 478.11 254.768 479.9C251.778 481.69 249.397 485.894 249.462 489.309C249.528 492.724 252.008 494.038 254.998 492.248C257.987 490.458 260.369 486.255 260.303 482.839Z",
    fill: "#C7CAD0"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M251.039 492.675L254.587 494.744C253.634 494.186 253.043 493.036 253.01 491.378C252.945 487.962 255.326 483.759 258.316 481.969C259.859 481.049 261.256 480.951 262.274 481.542L258.726 479.473C257.724 478.882 256.312 478.98 254.768 479.9C251.778 481.69 249.397 485.893 249.462 489.309C249.495 490.967 250.087 492.117 251.039 492.675Z",
    fill: "#979DA8"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M241.036 488.16L250.481 493.644C249.397 493.004 248.707 491.673 248.674 489.785C248.608 485.877 251.318 481.05 254.751 479.013C256.509 477.962 258.118 477.848 259.285 478.521L249.84 473.036C248.69 472.363 247.081 472.478 245.307 473.529C241.874 475.582 239.148 480.409 239.23 484.301C239.263 486.189 239.952 487.519 241.036 488.16Z",
    fill: "url(#paint32_linear_358_13776)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M262.126 497.273C258.693 499.325 255.852 497.815 255.786 493.907C255.72 489.999 258.43 485.171 261.863 483.135C265.296 481.099 268.138 482.593 268.203 486.501C268.269 490.409 265.559 495.237 262.126 497.273ZM267.415 486.961C267.349 483.545 264.869 482.232 261.88 484.022C258.89 485.811 256.509 490.015 256.574 493.43C256.64 496.846 259.12 498.159 262.11 496.37C265.099 494.58 267.481 490.376 267.415 486.961Z",
    fill: "#C7CAD0"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M258.151 496.813L261.699 498.882C260.746 498.324 260.155 497.174 260.122 495.516C260.057 492.1 262.438 487.897 265.428 486.107C266.971 485.187 268.368 485.089 269.386 485.68L265.838 483.611C264.836 483.02 263.424 483.118 261.88 484.038C258.89 485.828 256.509 490.031 256.574 493.447C256.607 495.105 257.199 496.255 258.151 496.813Z",
    fill: "#979DA8"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M254.045 495.713L257.593 497.782C256.509 497.141 255.819 495.811 255.786 493.923C255.72 490.015 258.43 485.187 261.863 483.151C263.621 482.1 265.23 481.985 266.397 482.659L262.849 480.59C261.699 479.916 260.089 480.031 258.316 481.082C254.883 483.135 252.156 487.962 252.238 491.854C252.271 493.742 252.961 495.072 254.045 495.713Z",
    fill: "url(#paint33_linear_358_13776)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M269.222 501.411C265.789 503.463 262.947 501.953 262.882 498.044C262.816 494.136 265.526 489.309 268.959 487.273C272.392 485.22 275.233 486.731 275.299 490.639C275.365 494.547 272.655 499.374 269.222 501.411ZM274.511 491.099C274.445 487.683 271.965 486.37 268.975 488.159C265.986 489.949 263.604 494.153 263.67 497.568C263.736 500.984 266.216 502.297 269.205 500.508C272.195 498.718 274.576 494.514 274.511 491.099Z",
    fill: "#C7CAD0"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M261.141 499.834L264.688 501.903C263.604 501.263 262.915 499.933 262.882 498.044C262.816 494.136 265.526 489.309 268.959 487.273C270.716 486.222 272.326 486.107 273.492 486.78L269.944 484.711C268.795 484.038 267.185 484.153 265.411 485.204C261.978 487.256 259.252 492.084 259.334 495.976C259.367 497.864 260.057 499.194 261.141 499.834Z",
    fill: "url(#paint34_linear_358_13776)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M265.263 500.935L268.811 503.003C267.858 502.445 267.267 501.296 267.234 499.637C267.169 496.222 269.55 492.018 272.54 490.228C274.083 489.309 275.48 489.21 276.498 489.802L272.95 487.733C271.948 487.141 270.536 487.24 268.992 488.16C266.002 489.949 263.621 494.153 263.686 497.568C263.719 499.227 264.311 500.376 265.263 500.935Z",
    fill: "#979DA8"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M268.253 503.956L283.347 512.724C282.263 512.084 281.573 510.754 281.54 508.866C281.475 504.957 284.185 500.13 287.618 498.094C289.375 497.043 290.985 496.928 292.151 497.601L277.056 488.833C275.907 488.16 274.297 488.274 272.523 489.325C269.09 491.378 266.364 496.205 266.446 500.097C266.479 501.985 267.169 503.315 268.253 503.956Z",
    fill: "url(#paint35_linear_358_13776)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M291.133 519.26C285.154 522.839 280.194 520.212 280.079 513.397C279.947 506.583 284.71 498.159 290.689 494.58C296.668 491 301.628 493.627 301.743 500.442C301.875 507.256 297.111 515.68 291.133 519.26ZM297.768 502.823C297.686 498.504 294.549 496.846 290.771 499.112C286.977 501.378 283.971 506.698 284.053 511.016C284.136 515.335 287.273 516.993 291.05 514.727C294.845 512.461 297.85 507.141 297.768 502.823Z",
    fill: "#D0D3D7"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M286.041 515.269L289.523 517.289C288.324 516.583 287.568 515.122 287.519 513.036C287.437 508.718 290.443 503.398 294.237 501.132C296.191 499.966 297.965 499.851 299.23 500.59L295.748 498.57C294.467 497.831 292.693 497.946 290.755 499.112C286.961 501.378 283.955 506.698 284.037 511.017C284.07 513.102 284.825 514.58 286.041 515.269Z",
    fill: "#A4A9B2"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M278.206 517.207L283.216 520.113C281.31 519.013 280.111 516.682 280.062 513.381C279.931 506.567 284.694 498.143 290.673 494.563C293.761 492.724 296.553 492.527 298.573 493.693L293.563 490.787C291.543 489.621 288.735 489.818 285.663 491.657C279.684 495.237 274.921 503.66 275.053 510.475C275.118 513.775 276.317 516.107 278.206 517.207Z",
    fill: "url(#paint36_linear_358_13776)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M304.716 521.378C304.716 521.378 304.749 521.345 304.765 521.328C304.765 521.328 304.782 521.312 304.798 521.296C304.815 521.279 304.831 521.263 304.847 521.246C304.864 521.23 304.88 521.214 304.897 521.197L304.93 521.164C304.93 521.164 304.962 521.131 304.979 521.115C304.995 521.099 305.012 521.082 305.028 521.066C305.028 521.066 305.045 521.049 305.061 521.033C305.077 521.016 305.094 521 305.11 520.984C305.127 520.967 305.143 520.951 305.16 520.934C305.16 520.934 305.176 520.918 305.192 520.902C305.209 520.885 305.225 520.869 305.242 520.852C304.404 521.706 303.484 522.429 302.532 523.003C297.998 525.713 294.237 523.726 294.155 518.553C294.056 513.381 297.67 507.01 302.203 504.301C306.736 501.591 310.498 503.578 310.58 508.75L310.875 507.371C310.76 501.378 306.408 499.063 301.152 502.215C295.896 505.352 291.707 512.757 291.822 518.751C291.937 524.744 296.29 527.059 301.546 523.906C302.647 523.25 303.698 522.396 304.683 521.427L304.716 521.378Z",
    fill: "#D0D3D7"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M302.564 522.954C298.031 525.664 294.27 523.677 294.188 518.504C294.089 513.332 297.703 506.961 302.236 504.251C306.769 501.542 310.53 503.529 310.613 508.701C310.711 513.874 307.098 520.245 302.564 522.954ZM308.674 509.851C308.609 505.893 305.734 504.383 302.269 506.452C298.803 508.521 296.044 513.414 296.109 517.355C296.175 521.312 299.049 522.823 302.515 520.754C305.981 518.685 308.74 513.792 308.674 509.851Z",
    fill: "#D0D3D7"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M287.634 520.557L294.631 524.629C292.956 523.66 291.905 521.624 291.855 518.701C291.74 512.708 295.929 505.302 301.185 502.166C303.895 500.54 306.359 500.376 308.132 501.411L301.135 497.339C299.362 496.304 296.898 496.485 294.188 498.094C288.932 501.23 284.743 508.636 284.858 514.629C284.908 517.536 285.959 519.572 287.634 520.557Z",
    fill: "url(#paint37_linear_358_13776)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M319.827 528.127C317.675 529.407 315.901 528.471 315.869 526.025C315.819 523.578 317.528 520.557 319.679 519.276C321.831 517.995 323.605 518.931 323.638 521.378C323.687 523.824 321.979 526.846 319.827 528.127ZM323.03 521.739C322.997 519.67 321.486 518.865 319.679 519.966C317.856 521.049 316.427 523.611 316.46 525.68C316.493 527.749 318.004 528.553 319.811 527.453C321.634 526.37 323.063 523.808 323.03 521.739Z",
    fill: "#D9DBDF"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M319.137 529.966C320.041 529.407 320.698 528.865 321.502 528.028C322.127 527.355 322.8 526.435 323.293 525.549C324.048 524.218 324.393 523.085 324.475 522.757C324.525 522.576 324.59 522.33 324.64 522.149C324.705 521.805 324.787 521.345 324.837 521C324.837 520.902 324.919 520.409 324.902 519.703C324.902 520.343 324.229 521.017 323.654 521.361C323.703 523.808 321.995 526.829 319.843 528.11C317.692 529.391 315.918 528.455 315.885 526.008C315.836 523.562 317.544 520.54 319.696 519.26C321.847 517.979 323.621 518.915 323.654 521.361C324.229 521.017 324.919 520.343 324.902 519.703C324.902 519.391 324.869 518.964 324.82 518.652C324.755 518.176 324.672 517.897 324.59 517.65C324.541 517.519 324.492 517.338 324.426 517.207C324.344 517.026 324.229 516.796 324.147 516.616C324.048 516.435 323.884 516.205 323.769 516.041C322.636 514.563 320.599 514.35 318.283 515.729C314.817 517.798 312.058 522.691 312.124 526.632C312.173 529.161 313.356 530.688 315.113 530.918C315.327 530.934 315.606 530.967 315.819 530.967C315.951 530.967 316.131 530.967 316.263 530.951C316.476 530.934 316.739 530.902 316.953 530.852C317.265 530.77 317.593 530.704 318.07 530.507C318.644 530.278 319.137 529.966 319.154 529.966H319.137Z",
    fill: "#D0D3D7"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M320.55 527.864C318.727 528.948 317.232 528.159 317.199 526.09C317.166 524.021 318.595 521.46 320.418 520.376C322.242 519.292 323.736 520.081 323.769 522.15C323.802 524.218 322.356 526.78 320.55 527.864ZM322.455 522.938C322.439 521.69 321.535 521.214 320.435 521.87C319.351 522.527 318.48 524.054 318.497 525.302C318.513 526.55 319.416 527.026 320.517 526.37C321.601 525.713 322.471 524.186 322.455 522.938Z",
    fill: "#B0B1B7"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M319.088 526.534L319.86 526.977C319.515 526.78 319.301 526.353 319.285 525.746C319.269 524.498 320.123 522.971 321.223 522.314C321.782 521.985 322.291 521.936 322.669 522.15L321.897 521.706C321.535 521.493 321.026 521.526 320.451 521.871C319.367 522.527 318.497 524.054 318.513 525.302C318.513 525.91 318.743 526.32 319.088 526.534Z",
    fill: "url(#paint38_linear_358_13776)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M320.435 527.108C320.878 527.108 321.322 527.076 321.765 527.059C321.289 527.076 320.944 526.714 320.927 526.074C320.927 525.171 321.535 524.054 322.34 523.578C322.931 523.233 323.441 523.332 323.67 523.775C323.457 523.381 323.26 522.987 323.046 522.593C322.734 521.985 322.028 521.854 321.207 522.33C320.123 522.987 319.252 524.514 319.269 525.762C319.269 526.649 319.745 527.141 320.402 527.125L320.435 527.108Z",
    fill: "url(#paint39_linear_358_13776)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M323.802 524.366C323.785 523.463 323.128 523.118 322.34 523.595C321.552 524.071 320.911 525.187 320.928 526.091C320.944 526.994 321.601 527.338 322.389 526.862C323.178 526.386 323.818 525.27 323.802 524.366Z",
    fill: "#323A3D"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M317.429 527.7L318.168 528.126C317.593 527.798 317.232 527.092 317.215 526.09C317.183 524.021 318.612 521.46 320.435 520.376C321.371 519.818 322.225 519.752 322.833 520.113L322.094 519.686C321.486 519.325 320.632 519.391 319.696 519.949C317.872 521.033 316.443 523.594 316.476 525.663C316.493 526.665 316.854 527.371 317.429 527.7Z",
    fill: "#6C6D79"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M297.949 521.247L313.93 530.557C312.83 529.916 312.14 528.57 312.107 526.649C312.042 522.692 314.785 517.815 318.267 515.746C320.057 514.678 321.683 514.563 322.849 515.237L306.868 505.926C305.702 505.253 304.075 505.368 302.285 506.435C298.819 508.504 296.06 513.398 296.126 517.338C296.159 519.26 296.848 520.606 297.949 521.247Z",
    fill: "url(#paint40_linear_358_13776)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M431.55 310.196L443.737 317.782C452.409 323.168 466.995 316.14 477.26 301.231C478.131 299.966 478.952 298.669 479.708 297.388L467.52 289.802C466.765 291.099 465.944 292.38 465.073 293.644C454.807 308.538 440.206 315.582 431.55 310.196Z",
    fill: "#20201C"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M467.52 289.802L479.708 297.388C488.314 282.643 489.316 266.534 481.564 260.032C481.153 259.687 480.726 259.375 480.283 259.096L468.095 251.51C468.539 251.789 468.966 252.101 469.376 252.446C477.129 258.948 476.127 275.073 467.52 289.802Z",
    fill: "#20201C"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M437.183 299.408L439.368 300.771C444.87 304.186 454.118 299.72 460.638 290.278C461.197 289.474 461.706 288.653 462.199 287.832L460.014 286.469C459.538 287.29 459.012 288.111 458.454 288.915C451.933 298.373 442.686 302.84 437.183 299.408Z",
    fill: "#2A2A26"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M459.998 286.469L462.182 287.832C467.652 278.472 468.276 268.259 463.365 264.121C463.102 263.907 462.839 263.71 462.544 263.53L460.359 262.167C460.638 262.347 460.918 262.544 461.18 262.758C466.091 266.879 465.467 277.109 459.998 286.469Z",
    fill: "#2A2A26"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M434.145 308.833C441.865 315.319 456.154 308.915 466.059 294.564C475.963 280.213 477.72 263.316 470.001 256.83C462.281 250.344 447.991 256.731 438.087 271.099C428.183 285.451 426.425 302.347 434.145 308.833ZM441.273 274.006C448.139 264.055 458.027 259.621 463.381 264.121C468.736 268.62 467.504 280.311 460.655 290.262C453.789 300.212 443.901 304.646 438.547 300.147C433.192 295.664 434.424 283.956 441.273 274.006Z",
    fill: "#181815"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M450.406 307.043L452.59 308.406C458.092 311.822 467.34 307.355 473.86 297.914C474.419 297.109 474.928 296.288 475.421 295.467L473.236 294.104C472.76 294.925 472.234 295.746 471.676 296.551C465.155 306.009 455.908 310.475 450.406 307.043Z",
    fill: "#2A2A26"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M473.22 294.104L475.404 295.467C480.874 286.107 481.498 275.894 476.587 271.756C476.324 271.543 476.061 271.346 475.766 271.165L473.581 269.802C473.86 269.983 474.14 270.18 474.402 270.393C479.313 274.515 478.689 284.744 473.22 294.104Z",
    fill: "#2A2A26"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M451.752 307.799L449.404 313.513C456.253 319.26 468.9 313.595 477.671 300.869C486.442 288.144 488.002 273.185 481.17 267.438C474.32 261.69 461.673 267.355 452.902 280.081C444.131 292.807 442.571 307.766 449.404 313.513L451.752 307.799C446.398 303.316 447.63 291.608 454.479 281.658C461.345 271.707 471.232 267.273 476.587 271.773C481.941 276.255 480.71 287.963 473.86 297.914C466.995 307.864 457.107 312.298 451.752 307.799Z",
    fill: "#20201C"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M441.273 278.669C442.275 276.928 443.359 275.204 444.542 273.497C457.813 254.236 476.981 245.681 487.329 254.367C491.484 257.848 493.587 263.579 493.767 270.426L493.833 272.873C493.669 266.469 491.698 261.099 487.805 257.848C478.114 249.72 460.178 257.733 447.745 275.763C446.644 277.355 445.626 278.981 444.69 280.607C435.015 297.437 433.964 315.713 442.801 323.135L443.096 323.381C447.991 327.257 454.906 327.175 462.117 323.858L459.899 324.876C452.196 328.422 444.821 328.521 439.581 324.367L439.269 324.104C429.825 316.189 430.958 296.666 441.29 278.685L441.273 278.669Z",
    fill: "#20201C"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M447.728 275.746C460.162 257.717 478.098 249.704 487.789 257.832C497.48 265.96 495.262 287.175 482.845 305.204C470.411 323.234 452.475 331.247 442.784 323.119C433.094 314.991 435.311 293.776 447.728 275.746ZM449.404 313.513C456.253 319.26 468.9 313.595 477.671 300.869C486.442 288.144 488.002 273.185 481.17 267.438C474.32 261.69 461.673 267.356 452.902 280.081C444.131 292.807 442.571 307.766 449.404 313.513Z",
    fill: "#181815"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M485.686 253.185L471.462 244.334C460.819 237.717 442.899 246.354 430.301 264.646C429.234 266.206 428.232 267.782 427.296 269.375L441.52 278.226C442.456 276.633 443.458 275.057 444.525 273.497C457.14 255.204 475.043 246.567 485.686 253.185Z",
    fill: "#2A2A26"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M441.52 278.209L427.296 269.359C416.718 287.454 415.502 307.24 425.013 315.237L439.237 324.088C429.71 316.107 430.942 296.321 441.52 278.209Z",
    fill: "#2A2A26"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M483.683 251.92L483.732 251.953C482.911 251.444 482.089 250.935 481.284 250.426L481.17 250.344L483.683 251.92Z",
    fill: "#313131"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M479.691 249.441L480.841 250.18C480.627 250.131 480.627 250.131 480.48 250.131L478.903 248.932L478.969 248.965L479.708 249.424L479.691 249.441Z",
    fill: "#313131"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M480.907 250.196L481.005 250.262L480.874 250.196L479.97 249.622L480.907 250.196Z",
    fill: "#313131"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M475.519 246.847L475.634 246.929C474.813 246.42 473.992 245.911 473.187 245.402L473.006 245.287L475.519 246.847Z",
    fill: "#313131"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M477.72 248.21L478.262 248.554L479.839 249.753C478.328 248.686 478.246 248.62 477.293 247.98L476.981 247.75L477.72 248.21Z",
    fill: "#313131"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M476.702 247.586L476.948 247.75L475.848 247.06L475.749 246.994L476.702 247.586Z",
    fill: "#313131"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M483.354 251.756L483.683 251.92L481.17 250.344L479.576 249.49C480.398 249.999 481.219 250.508 482.024 251.017L483.354 251.74V251.756Z",
    fill: "#313131"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M483.6 251.904L484.06 252.183L483.666 252.052L482.303 251.395L481.843 251.099L482.27 251.181L483.6 251.904Z",
    fill: "#313131"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M479.691 249.441L478.952 248.981L479.051 249.047L479.691 249.441Z",
    fill: "#313131"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M480.907 250.196L479.954 249.605L479.067 249.08C479.067 249.08 479.231 249.26 479.281 249.342L480.89 250.213L480.907 250.196Z",
    fill: "#313131"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M475.519 246.847L473.006 245.287L471.889 244.613L471.495 244.466C472.316 244.975 473.138 245.484 473.942 245.993L475.536 246.847H475.519Z",
    fill: "#313131"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M469.869 243.645L471.232 244.301L471.627 244.449L471.167 244.17L469.984 243.53C469.984 243.53 469.853 243.464 469.771 243.431L469.393 243.365L469.853 243.645H469.869Z",
    fill: "#313131"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M477.72 248.209L476.981 247.75L476.8 247.651L477.72 248.209Z",
    fill: "#313131"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M476.456 247.438L476.702 247.569L475.749 246.978L474.14 246.108C474.829 246.502 475.749 247.027 476.456 247.421V247.438Z",
    fill: "#313131"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M478.87 249.211C479.691 249.72 480.513 250.229 481.317 250.738L480.874 250.705L479.461 250.147C478.64 249.638 477.819 249.129 477.014 248.62L478.87 249.211Z",
    fill: "#313131"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M481.12 250.853L481.58 251.132L481.12 251.165L479.691 250.672L479.231 250.377L479.724 250.295L481.12 250.853Z",
    fill: "#313131"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M478.229 248.554C478.394 248.702 478.394 248.718 478.476 248.85C477.917 248.571 477.162 248.209 476.587 247.947C476.554 247.881 476.521 247.783 476.472 247.7L478.213 248.554H478.229Z",
    fill: "#313131"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M478.525 248.883L478.607 249.047L476.751 248.456C476.718 248.324 476.669 248.127 476.62 247.996C477.195 248.259 478.065 248.439 478.509 248.883H478.525Z",
    fill: "#313131"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M470.772 244.17C471.594 244.679 472.415 245.188 473.22 245.697L471.364 245.106C470.543 244.597 469.738 244.088 468.916 243.579L469.393 243.546L470.772 244.17Z",
    fill: "#313131"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M467.258 242.922L468.687 243.415L469.163 243.382L468.703 243.103L467.455 242.61C467.455 242.61 467.307 242.577 467.225 242.561L466.781 242.643L467.241 242.922H467.258Z",
    fill: "#313131"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M477.622 248.16L475.881 247.306C475.421 247.077 474.813 246.765 474.37 246.535C474.55 246.568 474.78 246.584 474.961 246.633C476.554 247.52 476.653 247.586 477.622 248.16Z",
    fill: "#313131"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M474.583 246.436C474.402 246.403 474.172 246.37 473.992 246.354C473.269 246.009 472.316 245.566 471.594 245.237L473.45 245.828L474.6 246.436H474.583Z",
    fill: "#313131"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M476.275 248.456C476.702 248.719 477.277 249.08 477.704 249.343C478.016 249.54 478.427 249.786 478.739 249.983L478.229 250.114L476.768 249.72C475.946 249.211 475.125 248.702 474.32 248.193L476.291 248.456H476.275Z",
    fill: "#313131"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M478.459 250.262L478.919 250.541L478.394 250.738L476.899 250.393L476.439 250.114L476.998 249.868L478.459 250.262Z",
    fill: "#313131"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M475.782 247.438C475.881 247.733 475.881 247.75 475.93 247.963C475.339 247.766 474.55 247.487 473.942 247.29C473.926 247.175 473.91 247.027 473.893 246.912L475.782 247.421V247.438Z",
    fill: "#313131"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M475.963 248.029L476.012 248.292L474.041 248.029C474.041 247.832 474.008 247.569 473.992 247.372C474.583 247.569 475.388 247.815 475.979 248.029H475.963Z",
    fill: "#313131"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M468.177 243.415C468.999 243.924 469.82 244.433 470.625 244.942L468.654 244.679C467.832 244.17 467.011 243.661 466.206 243.152L466.732 242.955L468.177 243.415Z",
    fill: "#313131"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M464.465 242.659L465.96 243.004L466.486 242.807L466.026 242.528L464.728 242.183C464.728 242.183 464.564 242.183 464.498 242.167L464.005 242.38L464.465 242.659Z",
    fill: "#313131"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M475.158 247.043L473.269 246.534C472.793 246.337 472.169 246.075 471.692 245.894C471.889 245.845 472.169 245.779 472.382 245.763C474.041 246.518 474.14 246.567 475.158 247.06V247.043Z",
    fill: "#313131"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M472.021 245.582C471.807 245.631 471.528 245.681 471.331 245.73C470.592 245.451 469.606 245.089 468.867 244.81L470.838 245.073L472.021 245.582Z",
    fill: "#313131"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M473.499 248.144C473.926 248.407 474.501 248.768 474.928 249.031C475.24 249.228 475.651 249.474 475.963 249.671L475.404 249.966L473.893 249.737C473.072 249.228 472.251 248.719 471.446 248.209L473.532 248.16L473.499 248.144Z",
    fill: "#313131"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M475.634 250.114L476.094 250.41L475.503 250.755L473.975 250.574L473.515 250.278L474.107 249.884L475.634 250.114Z",
    fill: "#313131"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M473.154 246.781C473.203 247.224 473.203 247.241 473.22 247.536C472.596 247.405 471.774 247.208 471.167 247.093C471.167 246.945 471.167 246.748 471.167 246.6L473.171 246.797L473.154 246.781Z",
    fill: "#313131"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M473.22 247.635V247.996L471.15 248.045C471.15 247.799 471.15 247.454 471.15 247.191C471.774 247.323 472.596 247.487 473.22 247.618V247.635Z",
    fill: "#313131"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M465.402 243.103C466.223 243.612 467.044 244.121 467.849 244.63L465.763 244.679C464.942 244.17 464.12 243.661 463.316 243.152L463.89 242.807L465.385 243.103H465.402Z",
    fill: "#313131"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M461.542 242.824L463.086 243.004L463.66 242.659L463.201 242.38L461.854 242.167C461.772 242.167 461.69 242.167 461.607 242.183L461.082 242.544L461.542 242.824Z",
    fill: "#313131"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M472.53 246.387L470.526 246.19C470.05 246.025 469.393 245.828 468.916 245.664C469.146 245.549 469.442 245.402 469.688 245.303C471.397 245.927 471.495 245.96 472.546 246.37L472.53 246.387Z",
    fill: "#313131"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M469.294 245.188C469.064 245.303 468.752 245.434 468.522 245.566C467.767 245.336 466.748 245.057 465.993 244.843L468.079 244.794L469.294 245.204V245.188Z",
    fill: "#313131"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M470.575 248.275C471.002 248.538 471.577 248.899 472.004 249.162C472.316 249.359 472.727 249.605 473.039 249.802L472.431 250.246L470.871 250.163C470.05 249.654 469.229 249.145 468.424 248.636L470.592 248.275H470.575Z",
    fill: "#313131"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M472.678 250.41L473.138 250.689L472.514 251.198L470.937 251.165L470.477 250.87L471.117 250.328L472.678 250.41Z",
    fill: "#313131"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M470.345 246.584C470.345 246.978 470.345 247.301 470.345 247.553C469.705 247.487 468.851 247.372 468.227 247.323C468.227 247.142 468.243 246.896 468.259 246.715L470.362 246.584H470.345Z",
    fill: "#313131"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M470.329 247.684V248.127L468.144 248.489C468.161 248.177 468.177 247.766 468.194 247.454C468.834 247.52 469.688 247.585 470.329 247.668V247.684Z",
    fill: "#313131"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M462.494 243.251C463.316 243.76 464.12 244.269 464.942 244.778L462.774 245.139C461.952 244.63 461.131 244.121 460.326 243.612L460.95 243.119L462.494 243.251Z",
    fill: "#313131"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M458.503 243.431L460.08 243.464L460.704 242.971L460.244 242.692L458.864 242.61C458.782 242.627 458.7 242.643 458.602 242.659L458.043 243.152L458.503 243.431Z",
    fill: "#313131"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M469.721 246.19L467.619 246.321C467.126 246.206 466.469 246.042 465.96 245.927C466.206 245.746 466.535 245.516 466.798 245.352C468.588 245.845 468.654 245.861 469.721 246.19Z",
    fill: "#313131"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M466.403 245.237C466.157 245.418 465.812 245.648 465.566 245.828C464.794 245.664 463.759 245.451 462.987 245.287L465.155 244.925L466.403 245.237Z",
    fill: "#313131"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M467.553 248.85C468.374 249.359 469.196 249.868 470.001 250.377L469.36 250.968L467.767 251.034C466.945 250.525 466.124 250.016 465.319 249.507L467.553 248.85Z",
    fill: "#313131"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M469.606 251.116L470.066 251.411L469.409 252.052L467.816 252.167L467.34 251.887L468.013 251.181L469.606 251.116Z",
    fill: "#313131"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M467.389 246.814C467.367 247.295 467.345 247.689 467.323 247.996C466.666 247.996 465.796 247.963 465.139 247.98C465.139 247.766 465.172 247.471 465.188 247.241L467.373 246.814H467.389Z",
    fill: "#313131"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M467.323 248.16L467.29 248.702L465.057 249.359C465.089 248.998 465.122 248.505 465.155 248.144C465.812 248.144 466.683 248.144 467.34 248.144L467.323 248.16Z",
    fill: "#313131"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M459.456 243.809C460.277 244.318 461.098 244.827 461.903 245.336L459.669 245.993C458.848 245.484 458.027 244.975 457.222 244.466L457.879 243.809H459.456Z",
    fill: "#313131"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M455.382 244.433L456.992 244.318L457.649 243.661L457.189 243.382L455.793 243.431C455.711 243.464 455.612 243.497 455.53 243.513L454.939 244.137L455.399 244.416L455.382 244.433Z",
    fill: "#313131"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M466.765 246.42L464.58 246.847C464.071 246.765 463.398 246.65 462.905 246.567C463.168 246.338 463.513 246.009 463.792 245.779C465.582 246.141 465.681 246.157 466.781 246.403L466.765 246.42Z",
    fill: "#313131"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M463.381 245.714C463.118 245.943 462.757 246.272 462.494 246.502C461.706 246.387 460.655 246.239 459.883 246.14L462.117 245.484L463.381 245.714Z",
    fill: "#313131"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M464.432 249.819C465.254 250.328 466.075 250.837 466.88 251.346L466.206 252.085L464.597 252.298C463.775 251.789 462.954 251.28 462.149 250.771L464.432 249.819Z",
    fill: "#313131"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M466.469 252.232L466.929 252.528L466.239 253.316L464.63 253.579L464.17 253.3L464.843 252.446L466.469 252.232Z",
    fill: "#313131"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M464.334 247.47C464.301 247.93 464.268 248.406 464.219 248.866C463.562 248.915 462.675 248.981 462.002 249.047C462.018 248.8 462.051 248.456 462.067 248.193L464.317 247.47H464.334Z",
    fill: "#313131"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M464.219 249.063L464.17 249.687L461.887 250.64C461.919 250.229 461.969 249.671 462.002 249.26C462.659 249.195 463.546 249.112 464.219 249.063Z",
    fill: "#313131"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M456.335 244.778C457.156 245.287 457.977 245.796 458.782 246.305L456.499 247.257C455.678 246.748 454.873 246.239 454.052 245.73L454.725 244.942L456.335 244.778Z",
    fill: "#313131"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M452.196 245.845L453.822 245.582L454.495 244.794L454.035 244.515L452.606 244.696C452.524 244.728 452.426 244.778 452.344 244.827L451.736 245.582L452.196 245.861V245.845Z",
    fill: "#313131"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M463.71 247.076L461.46 247.799C460.95 247.75 460.277 247.684 459.768 247.635C460.047 247.339 460.408 246.945 460.688 246.649C462.527 246.896 462.609 246.896 463.726 247.076H463.71Z",
    fill: "#313131"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M460.277 246.617C459.998 246.912 459.636 247.306 459.357 247.618C458.569 247.553 457.501 247.487 456.713 247.438L458.996 246.485L460.277 246.633V246.617Z",
    fill: "#313131"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M461.262 251.198C461.689 251.461 462.264 251.822 462.691 252.085C463.004 252.282 463.414 252.528 463.726 252.725L463.036 253.612L461.41 253.957C460.589 253.448 459.768 252.939 458.963 252.43L461.262 251.198Z",
    fill: "#313131"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M463.266 253.76L463.726 254.039L463.053 254.975L461.427 255.369L460.967 255.09L461.657 254.104L463.266 253.76Z",
    fill: "#313131"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M461.197 248.538C461.147 249.063 461.098 249.605 461.065 250.131C460.392 250.246 459.505 250.377 458.832 250.508C458.864 250.229 458.897 249.835 458.914 249.556L461.197 248.538Z",
    fill: "#313131"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M461.049 250.36L460.983 251.066L458.667 252.298C458.7 251.838 458.766 251.214 458.799 250.738C459.472 250.623 460.359 250.459 461.032 250.344L461.049 250.36Z",
    fill: "#313131"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M453.165 246.157C453.592 246.42 454.167 246.781 454.594 247.044C454.906 247.241 455.317 247.487 455.629 247.684L453.329 248.916C452.508 248.407 451.687 247.898 450.882 247.389L451.572 246.453L453.198 246.157H453.165Z",
    fill: "#313131"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M448.993 247.635L450.619 247.241L451.309 246.305L450.849 246.026L449.42 246.338C449.321 246.387 449.239 246.436 449.141 246.502L448.533 247.372L448.993 247.651V247.635Z",
    fill: "#313131"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M460.589 248.144L458.306 249.162C457.797 249.145 457.107 249.112 456.598 249.112C456.877 248.751 457.255 248.275 457.534 247.93C459.39 248.045 459.472 248.045 460.589 248.144Z",
    fill: "#313131"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M457.123 247.914C456.844 248.275 456.466 248.751 456.187 249.113C455.382 249.113 454.331 249.113 453.526 249.113L455.842 247.881L457.123 247.93V247.914Z",
    fill: "#313131"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M458.043 252.955C458.47 253.218 459.045 253.579 459.472 253.842C459.784 254.039 460.195 254.285 460.507 254.482L459.817 255.5L458.191 255.993C457.37 255.484 456.548 254.975 455.744 254.465L458.06 252.955H458.043Z",
    fill: "#313131"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M460.063 255.664L460.523 255.943L459.833 257.011L458.207 257.553L457.747 257.257L458.437 256.141L460.063 255.664Z",
    fill: "#313131"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M458.027 249.999C457.977 250.59 457.928 251.198 457.879 251.789C457.205 251.953 456.302 252.167 455.645 252.347C455.678 252.035 455.711 251.609 455.727 251.28L458.027 249.983V249.999Z",
    fill: "#313131"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M457.846 252.035L457.78 252.824L455.464 254.334C455.497 253.825 455.563 253.136 455.596 252.61C456.269 252.429 457.156 252.2 457.83 252.035H457.846Z",
    fill: "#313131"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M449.962 247.93C450.783 248.439 451.588 248.948 452.409 249.457L450.093 250.968C449.272 250.459 448.451 249.95 447.646 249.441L448.336 248.374L449.962 247.93Z",
    fill: "#313131"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M445.774 249.802L447.4 249.277L448.09 248.209L447.63 247.93L446.201 248.357C446.102 248.423 446.02 248.488 445.921 248.538L445.314 249.523L445.774 249.802Z",
    fill: "#313131"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M457.403 249.622L455.103 250.919C454.594 250.919 453.904 250.952 453.395 250.968C453.674 250.558 454.052 249.999 454.348 249.605C456.22 249.605 456.286 249.605 457.419 249.622H457.403Z",
    fill: "#313131"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M453.92 249.589C453.641 249.999 453.247 250.557 452.968 250.968C452.163 251.001 451.112 251.066 450.307 251.116L452.623 249.605H453.92V249.589Z",
    fill: "#313131"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M454.84 255.106C455.662 255.615 456.483 256.124 457.288 256.633L456.614 257.782L455.005 258.406C454.183 257.897 453.362 257.388 452.557 256.879L454.857 255.106H454.84Z",
    fill: "#313131"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M456.861 257.93L457.32 258.226L456.647 259.424L455.037 260.081L454.577 259.786L455.251 258.554L456.861 257.93Z",
    fill: "#313131"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M454.807 251.855C454.758 252.512 454.709 253.185 454.643 253.842C453.97 254.071 453.083 254.351 452.409 254.597C452.442 254.252 452.475 253.776 452.491 253.431L454.791 251.871L454.807 251.855Z",
    fill: "#313131"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M454.627 254.104L454.561 254.975L452.262 256.748C452.294 256.19 452.344 255.434 452.393 254.876C453.066 254.646 453.953 254.334 454.627 254.121V254.104Z",
    fill: "#313131"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M446.743 250.065C447.564 250.574 448.385 251.083 449.19 251.592L446.891 253.365C446.069 252.856 445.265 252.347 444.443 251.838L445.117 250.64L446.743 250.065Z",
    fill: "#313131"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M442.604 252.347L444.213 251.69L444.887 250.492L444.427 250.213L442.998 250.755C442.916 250.82 442.817 250.902 442.735 250.968L442.144 252.068L442.604 252.347Z",
    fill: "#313131"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M454.183 251.461L451.884 253.021C451.375 253.07 450.685 253.119 450.176 253.185C450.455 252.725 450.833 252.101 451.112 251.625C452.951 251.51 453.05 251.51 454.183 251.461Z",
    fill: "#313131"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M450.701 251.658C450.422 252.134 450.044 252.758 449.765 253.218C448.977 253.3 447.909 253.431 447.121 253.53L449.42 251.756L450.718 251.658H450.701Z",
    fill: "#313131"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M451.654 257.602C452.475 258.111 453.296 258.62 454.101 259.129L453.428 260.41L451.834 261.149C451.013 260.64 450.192 260.131 449.387 259.621L451.654 257.602Z",
    fill: "#313131"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M453.691 260.574L454.15 260.853L453.493 262.183L451.917 262.955L451.457 262.676L452.097 261.313L453.691 260.574Z",
    fill: "#313131"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M451.605 254.088C451.555 254.81 451.506 255.533 451.457 256.255C450.783 256.535 449.896 256.896 449.239 257.175C449.256 256.797 449.289 256.288 449.305 255.911L451.588 254.088H451.605Z",
    fill: "#313131"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M451.44 256.534L451.391 257.487L449.141 259.506C449.174 258.899 449.207 258.078 449.239 257.47C449.896 257.191 450.783 256.797 451.457 256.534H451.44Z",
    fill: "#313131"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M443.573 252.577C444.394 253.086 445.199 253.595 446.02 254.104L443.753 256.124C442.932 255.615 442.127 255.106 441.306 254.597L441.963 253.267L443.573 252.577Z",
    fill: "#313131"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M439.483 255.221L441.06 254.433L441.717 253.103L441.257 252.823L439.844 253.48C439.762 253.562 439.664 253.645 439.581 253.727L439.007 254.942L439.466 255.221H439.483Z",
    fill: "#313131"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M450.98 253.694L448.697 255.517C448.188 255.599 447.515 255.697 447.006 255.763C447.285 255.237 447.646 254.548 447.925 254.039C449.749 253.809 449.863 253.809 450.997 253.694H450.98Z",
    fill: "#313131"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M447.515 254.088C447.235 254.613 446.858 255.303 446.595 255.828C445.807 255.96 444.755 256.14 443.967 256.288L446.217 254.269L447.498 254.088H447.515Z",
    fill: "#313131"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M448.533 260.459C448.96 260.722 449.535 261.083 449.962 261.346C450.274 261.543 450.685 261.789 450.997 261.986L450.356 263.382L448.796 264.252C447.975 263.743 447.153 263.234 446.349 262.725L448.55 260.459H448.533Z",
    fill: "#313131"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M450.586 263.546L451.046 263.825L450.422 265.27L448.878 266.173L448.418 265.894L449.026 264.4L450.586 263.546Z",
    fill: "#313131"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M448.435 256.666C448.402 257.454 448.352 258.226 448.32 259.014C447.663 259.342 446.792 259.769 446.135 260.114C446.135 259.704 446.168 259.162 446.184 258.751L448.435 256.666Z",
    fill: "#313131"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M448.303 259.326L448.254 260.344L446.053 262.61C446.069 261.953 446.102 261.083 446.119 260.426C446.776 260.098 447.646 259.638 448.303 259.326Z",
    fill: "#313131"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M440.436 255.418C441.257 255.927 442.078 256.436 442.883 256.945L440.682 259.211C439.861 258.702 439.056 258.193 438.235 257.684L438.859 256.239L440.436 255.418Z",
    fill: "#313131"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M436.444 258.439L437.988 257.536L438.612 256.091L438.153 255.812L436.773 256.567C436.691 256.666 436.609 256.748 436.51 256.846L435.968 258.16L436.428 258.439H436.444Z",
    fill: "#313131"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M447.81 256.272L445.56 258.357C445.051 258.456 444.394 258.603 443.885 258.702C444.148 258.127 444.493 257.372 444.772 256.797C446.611 256.469 446.694 256.452 447.81 256.272Z",
    fill: "#313131"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M444.378 256.879C444.115 257.454 443.753 258.209 443.491 258.801C442.719 258.981 441.684 259.227 440.912 259.408L443.113 257.142L444.378 256.896V256.879Z",
    fill: "#313131"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M445.494 263.661C446.316 264.17 447.137 264.679 447.942 265.188L447.334 266.715L445.807 267.7C444.985 267.191 444.164 266.682 443.359 266.173L445.478 263.677L445.494 263.661Z",
    fill: "#313131"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M447.58 266.863L448.04 267.142L447.449 268.702L445.954 269.72L445.494 269.441L446.053 267.832L447.58 266.863Z",
    fill: "#313131"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M445.314 259.605C445.265 260.886 445.265 261.198 445.232 262.118C444.591 262.495 443.737 262.988 443.096 263.382C443.096 262.939 443.096 262.364 443.113 261.92L445.297 259.605H445.314Z",
    fill: "#313131"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M445.232 262.446V263.53L443.08 266.025C443.08 265.336 443.08 264.4 443.08 263.71C443.721 263.333 444.558 262.807 445.215 262.446H445.232Z",
    fill: "#313131"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M437.397 258.62C438.218 259.129 439.039 259.638 439.844 260.147L437.725 262.643C436.904 262.134 436.083 261.625 435.278 261.116L435.869 259.556L437.413 258.62H437.397Z",
    fill: "#313131"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M433.521 261.986L435.032 260.968L435.623 259.408L435.163 259.129L433.816 259.983C433.734 260.081 433.652 260.18 433.57 260.278L433.077 261.69L433.537 261.97L433.521 261.986Z",
    fill: "#313131"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M444.69 259.211L442.505 261.526C442.012 261.658 441.355 261.838 440.863 261.97C441.109 261.346 441.438 260.525 441.7 259.901C443.491 259.474 443.589 259.441 444.69 259.211Z",
    fill: "#313131"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M441.306 259.999C441.06 260.623 440.715 261.444 440.468 262.085C439.713 262.298 438.695 262.61 437.923 262.84L440.041 260.344L441.29 260.016L441.306 259.999Z",
    fill: "#313131"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M442.554 267.175C443.376 267.684 444.197 268.193 445.002 268.702L444.443 270.328L442.981 271.411C442.16 270.902 441.339 270.393 440.534 269.884L442.554 267.158V267.175Z",
    fill: "#313131"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M444.69 270.492L445.15 270.771L444.624 272.446L443.179 273.579L442.719 273.283L443.228 271.575L444.69 270.492Z",
    fill: "#313131"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M442.292 262.873C442.292 264.039 442.275 264.564 442.275 265.549C441.651 265.976 440.813 266.535 440.206 266.962C440.206 266.502 440.206 265.878 440.206 265.418L442.308 262.856L442.292 262.873Z",
    fill: "#313131"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M442.275 265.911V267.076L440.255 269.802C440.255 269.063 440.222 268.078 440.206 267.356C440.83 266.929 441.651 266.338 442.275 265.927V265.911Z",
    fill: "#313131"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M434.457 262.134C435.278 262.643 436.099 263.152 436.904 263.661L434.884 266.387C434.063 265.878 433.258 265.369 432.437 264.86L432.962 263.185L434.457 262.134Z",
    fill: "#313131"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M430.745 265.845L432.19 264.712L432.716 263.037L432.256 262.758L430.958 263.71C430.876 263.825 430.811 263.924 430.728 264.039L430.285 265.549L430.745 265.828V265.845Z",
    fill: "#313131"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M441.684 262.479L439.581 265.04C439.105 265.205 438.448 265.402 437.972 265.566C438.202 264.893 438.514 264.006 438.744 263.333C440.452 262.824 440.6 262.774 441.684 262.479Z",
    fill: "#313131"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M438.35 263.464C438.12 264.137 437.808 265.024 437.578 265.697C436.839 265.96 435.837 266.305 435.097 266.584L437.118 263.858L438.35 263.464Z",
    fill: "#313131"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M439.762 271.001C440.583 271.51 441.405 272.019 442.209 272.528L441.733 274.252L440.353 275.401C439.926 275.139 439.352 274.777 438.924 274.515C438.612 274.318 438.202 274.071 437.89 273.874L439.746 271.001H439.762Z",
    fill: "#313131"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M441.98 274.416L442.439 274.695L441.996 276.436L440.649 277.585L440.189 277.306L440.6 275.566L441.98 274.416Z",
    fill: "#313131"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M439.401 266.452C439.417 267.897 439.434 268.242 439.45 269.293C438.859 269.753 438.054 270.377 437.463 270.853C437.446 270.36 437.413 269.72 437.397 269.227L439.401 266.452Z",
    fill: "#313131"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M439.45 269.671L439.483 270.886L437.627 273.759C437.578 273.004 437.512 271.986 437.479 271.231C438.07 270.754 438.859 270.13 439.466 269.671H439.45Z",
    fill: "#313131"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M431.665 265.976C432.486 266.485 433.307 266.994 434.112 267.503L432.256 270.377C431.829 270.114 431.254 269.753 430.827 269.49C430.515 269.293 430.104 269.047 429.792 268.85L430.236 267.109L431.665 265.976Z",
    fill: "#313131"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M428.215 269.851L429.562 268.685L430.006 266.945L429.546 266.666L428.33 267.684C428.265 267.799 428.183 267.914 428.117 268.029L427.772 269.572L428.232 269.851H428.215Z",
    fill: "#313131"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M438.777 266.075L436.773 268.85C436.297 269.03 435.672 269.277 435.212 269.457C435.426 268.751 435.689 267.799 435.902 267.093C437.643 266.469 437.709 266.436 438.777 266.075Z",
    fill: "#313131"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M435.525 267.224C435.311 267.93 435.032 268.883 434.835 269.589C434.128 269.868 433.176 270.262 432.469 270.541L434.325 267.668L435.525 267.208V267.224Z",
    fill: "#313131"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M437.216 275.007C438.038 275.516 438.859 276.025 439.664 276.534L439.286 278.275L438.021 279.441C437.2 278.932 436.379 278.423 435.574 277.914L437.216 274.991V275.007Z",
    fill: "#313131"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M439.532 278.439L439.992 278.735L439.664 280.475L438.432 281.658L437.972 281.362L438.267 279.605L439.532 278.439Z",
    fill: "#313131"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M436.641 270.344C436.74 272.117 436.74 272.183 436.822 273.267C436.264 273.743 435.524 274.383 434.982 274.876C434.933 274.383 434.867 273.727 434.835 273.234L436.658 270.344H436.641Z",
    fill: "#313131"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M436.855 273.661L436.953 274.909L435.311 277.832C435.212 277.06 435.097 276.042 435.015 275.286C435.557 274.81 436.296 274.153 436.838 273.677L436.855 273.661Z",
    fill: "#313131"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M429.119 269.983C429.546 270.245 430.121 270.607 430.548 270.869C430.86 271.066 431.27 271.313 431.583 271.51L429.94 274.433C429.119 273.924 428.298 273.415 427.493 272.905L427.821 271.149L429.135 269.983H429.119Z",
    fill: "#313131"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M425.998 273.924L427.23 272.741L427.558 270.984L427.098 270.705L425.982 271.74C425.916 271.855 425.867 271.97 425.801 272.085L425.555 273.645L426.014 273.924H425.998Z",
    fill: "#313131"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M436.017 269.966L434.194 272.856C433.751 273.037 433.159 273.3 432.716 273.48C432.88 272.758 433.094 271.789 433.258 271.067C434.72 270.475 434.983 270.36 436.001 269.95L436.017 269.966Z",
    fill: "#313131"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M432.913 271.214C432.749 271.937 432.535 272.906 432.371 273.628C431.697 273.924 430.811 274.318 430.137 274.613L431.78 271.691L432.913 271.214Z",
    fill: "#313131"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 279.08C435.804 279.589 436.625 280.098 437.43 280.607L437.167 282.364L436.017 283.546C435.196 283.037 434.375 282.528 433.57 282.019L434.982 279.08Z",
    fill: "#313131"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M437.413 282.511L437.873 282.807L437.66 284.564L436.543 285.746L436.083 285.467L436.264 283.694L437.413 282.511Z",
    fill: "#313131"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M434.161 274.367C434.342 276.157 434.358 276.239 434.49 277.323C433.981 277.815 433.307 278.456 432.798 278.948C432.732 278.456 432.634 277.799 432.568 277.29L434.161 274.351V274.367Z",
    fill: "#313131"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M434.555 277.717L434.72 278.965L433.307 281.904C433.176 281.132 432.995 280.114 432.88 279.342C433.389 278.85 434.046 278.193 434.555 277.717Z",
    fill: "#313131"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M426.885 274.039C427.706 274.548 428.511 275.057 429.332 275.566L427.92 278.505C427.098 277.996 426.277 277.487 425.472 276.978L425.686 275.221L426.885 274.039Z",
    fill: "#313131"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M424.109 278.012L425.226 276.83L425.44 275.073L424.98 274.794L423.961 275.828C423.912 275.943 423.863 276.058 423.797 276.173L423.649 277.733L424.109 278.012Z",
    fill: "#313131"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M433.537 273.989L431.944 276.928C431.533 277.126 430.975 277.372 430.548 277.569C430.663 276.83 430.811 275.861 430.942 275.139C432.42 274.482 432.568 274.416 433.537 274.006V273.989Z",
    fill: "#313131"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M430.613 275.27C430.498 275.993 430.334 276.978 430.236 277.7C429.612 277.996 428.774 278.39 428.133 278.686L429.546 275.746L430.613 275.254V275.27Z",
    fill: "#313131"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M433.061 283.168C433.882 283.677 434.703 284.186 435.508 284.695L435.36 286.452L434.325 287.635C433.504 287.126 432.683 286.616 431.878 286.107L433.061 283.168Z",
    fill: "#313131"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M435.607 286.616L436.067 286.896L435.968 288.653L434.966 289.835L434.506 289.539L434.572 287.782L435.607 286.616Z",
    fill: "#313131"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M431.993 278.456C432.272 280.262 432.289 280.327 432.486 281.428C432.026 281.92 431.418 282.561 430.958 283.053C430.86 282.561 430.728 281.887 430.63 281.395L431.993 278.456Z",
    fill: "#313131"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M432.552 281.805L432.782 283.053L431.599 285.993C431.418 285.221 431.205 284.203 431.04 283.431C431.5 282.938 432.092 282.282 432.552 281.805Z",
    fill: "#313131"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M424.963 278.127C425.785 278.636 426.589 279.145 427.411 279.654L426.228 282.594C425.407 282.084 424.602 281.575 423.781 281.066L423.879 279.309L424.963 278.127Z",
    fill: "#313131"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M422.532 282.101L423.534 280.935L423.633 279.178L423.173 278.899L422.253 279.933C422.204 280.048 422.171 280.163 422.122 280.278L422.072 281.822L422.532 282.101Z",
    fill: "#313131"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M431.369 278.062L430.006 281.001C429.611 281.198 429.102 281.444 428.708 281.641C428.774 280.902 428.856 279.933 428.938 279.195C429.956 278.713 430.767 278.33 431.369 278.045V278.062Z",
    fill: "#313131"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M428.626 279.359C428.56 280.081 428.462 281.067 428.412 281.789C427.821 282.085 427.033 282.479 426.458 282.774L427.64 279.835L428.626 279.359Z",
    fill: "#313131"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M431.451 287.257C432.272 287.766 433.094 288.275 433.898 288.784L433.866 290.541L432.946 291.707C432.125 291.198 431.303 290.689 430.498 290.18L431.451 287.273V287.257Z",
    fill: "#313131"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M434.112 290.689L434.572 290.968L434.588 292.708L433.701 293.874L433.241 293.579L433.192 291.838L434.112 290.689Z",
    fill: "#313131"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M430.154 282.544C430.515 284.285 430.548 284.416 430.811 285.517C430.4 286.009 429.841 286.649 429.447 287.142C429.316 286.649 429.152 285.993 429.037 285.5L430.17 282.561L430.154 282.544Z",
    fill: "#313131"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M430.893 285.894L431.188 287.142L430.236 290.065C430.022 289.309 429.743 288.291 429.529 287.52C429.94 287.027 430.466 286.387 430.893 285.91V285.894Z",
    fill: "#313131"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M423.354 282.216C424.175 282.725 424.996 283.234 425.801 283.743L424.848 286.649C424.027 286.14 423.222 285.631 422.401 285.122V283.382L423.354 282.216Z",
    fill: "#313131"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M421.268 286.14L422.155 284.991V283.25L421.678 282.971L420.857 283.989C420.824 284.104 420.791 284.219 420.758 284.334L420.808 285.878L421.268 286.157V286.14Z",
    fill: "#313131"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M429.529 282.15L428.396 285.089C428.035 285.286 427.542 285.533 427.181 285.73C427.197 285.007 427.213 284.038 427.246 283.3C428.462 282.676 428.675 282.577 429.513 282.15H429.529Z",
    fill: "#313131"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M426.967 283.447C426.951 284.17 426.918 285.139 426.901 285.861C426.359 286.157 425.62 286.534 425.078 286.83L426.031 283.907L426.951 283.431L426.967 283.447Z",
    fill: "#313131"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M430.17 291.296C430.991 291.805 431.812 292.314 432.617 292.823L432.699 294.548L431.895 295.681C431.073 295.172 430.252 294.663 429.447 294.154L430.17 291.296Z",
    fill: "#313131"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M432.946 294.695L433.406 294.991L433.537 296.715L432.765 297.832L432.305 297.552L432.141 295.845L432.946 294.695Z",
    fill: "#313131"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M428.626 286.616C429.086 288.341 429.119 288.488 429.431 289.556C429.07 290.032 428.577 290.656 428.232 291.148C428.084 290.656 427.87 290.015 427.723 289.523L428.626 286.616Z",
    fill: "#313131"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M429.546 289.95L429.924 291.181L429.201 294.055C428.938 293.3 428.61 292.298 428.347 291.543C428.708 291.067 429.184 290.426 429.546 289.95Z",
    fill: "#313131"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M422.072 286.255C422.894 286.764 423.699 287.273 424.52 287.782L423.797 290.639C422.976 290.13 422.155 289.621 421.35 289.112L421.218 287.388L422.072 286.239V286.255Z",
    fill: "#313131"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M420.331 290.098L421.103 288.965L420.972 287.241L420.512 286.961L419.789 287.963C419.757 288.078 419.74 288.193 419.707 288.291L419.855 289.802L420.315 290.081L420.331 290.098Z",
    fill: "#313131"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M428.002 286.239L427.098 289.145C426.77 289.326 426.31 289.572 425.982 289.769C425.949 289.047 425.916 288.094 425.899 287.372C426.885 286.83 427.23 286.649 428.002 286.239Z",
    fill: "#313131"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M425.62 287.503C425.653 288.226 425.686 289.178 425.719 289.901C425.21 290.18 424.536 290.557 424.043 290.836L424.766 287.963L425.62 287.503Z",
    fill: "#313131"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M429.201 295.27C430.022 295.779 430.843 296.288 431.648 296.797L431.845 298.488L431.155 299.589C430.334 299.08 429.513 298.57 428.708 298.061L429.201 295.27Z",
    fill: "#313131"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M432.108 298.636L432.568 298.915L432.814 300.607L432.174 301.69L431.714 301.395L431.418 299.736L432.108 298.636Z",
    fill: "#313131"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M427.411 290.639C427.969 292.347 428.018 292.478 428.38 293.546C428.068 294.006 427.641 294.63 427.328 295.089C427.148 294.613 426.901 293.973 426.737 293.48L427.411 290.639Z",
    fill: "#313131"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M428.511 293.94L428.955 295.155L428.478 297.947C428.183 297.208 427.788 296.222 427.493 295.483C427.805 295.024 428.215 294.4 428.527 293.94H428.511Z",
    fill: "#313131"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M421.12 290.229C421.941 290.738 422.746 291.247 423.567 291.756L423.074 294.548C422.253 294.039 421.432 293.529 420.627 293.02L420.381 291.346L421.12 290.229Z",
    fill: "#313131"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M419.74 293.94L420.381 292.856L420.134 291.181L419.674 290.902L419.067 291.871C419.067 291.986 419.034 292.085 419.017 292.2L419.28 293.661L419.74 293.94Z",
    fill: "#313131"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M426.786 290.262L426.113 293.103C425.801 293.283 425.39 293.513 425.078 293.694C424.996 292.988 424.898 292.052 424.832 291.346C425.67 290.869 426.064 290.656 426.77 290.262H426.786Z",
    fill: "#313131"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M424.585 291.493C424.668 292.199 424.75 293.135 424.848 293.842C424.388 294.104 423.781 294.465 423.321 294.728L423.797 291.937L424.585 291.493Z",
    fill: "#313131"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M428.577 299.129C429.398 299.638 430.219 300.147 431.024 300.656L431.353 302.298L430.778 303.349C429.956 302.84 429.135 302.331 428.33 301.822L428.577 299.129Z",
    fill: "#313131"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M431.599 302.446L432.059 302.741L432.42 304.367L431.895 305.385L431.435 305.106L431.024 303.497L431.599 302.446Z",
    fill: "#313131"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M426.524 294.597C427.197 296.337 427.23 296.403 427.657 297.454C427.394 297.897 427.033 298.488 426.77 298.932C426.556 298.456 426.277 297.832 426.08 297.355L426.507 294.58L426.524 294.597Z",
    fill: "#313131"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M427.821 297.815L428.33 298.997L428.084 301.69C427.739 300.968 427.279 300.016 426.951 299.293C427.213 298.85 427.558 298.259 427.821 297.815Z",
    fill: "#313131"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M420.479 294.088C421.3 294.597 422.122 295.106 422.927 295.615L422.68 298.308C421.859 297.799 421.038 297.29 420.233 296.781L419.872 295.155L420.479 294.088Z",
    fill: "#313131"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M419.461 297.651L419.986 296.633L419.625 295.007L419.165 294.728L418.656 295.648C418.656 295.746 418.656 295.861 418.64 295.96L419.001 297.372L419.461 297.651Z",
    fill: "#313131"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M425.899 294.203L425.472 296.978C425.193 297.142 424.815 297.372 424.536 297.536C424.405 296.846 424.241 295.943 424.126 295.254C424.717 294.909 425.308 294.564 425.899 294.219V294.203Z",
    fill: "#313131"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M423.896 295.369C424.027 296.058 424.175 296.961 424.323 297.651C423.912 297.897 423.354 298.226 422.927 298.489L423.173 295.796L423.896 295.369Z",
    fill: "#313131"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M428.281 302.84C429.102 303.349 429.924 303.858 430.728 304.367L431.172 305.96L430.728 306.945C430.301 306.682 429.726 306.321 429.299 306.058C428.987 305.861 428.577 305.615 428.265 305.418V302.84H428.281Z",
    fill: "#313131"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M431.418 306.107L431.878 306.387L432.371 307.963L431.96 308.915L431.5 308.636L430.975 307.093L431.418 306.107Z",
    fill: "#313131"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M425.965 298.423C426.721 300.048 426.77 300.196 427.279 301.214C427.066 301.641 426.77 302.2 426.556 302.626C426.327 302.167 425.998 301.559 425.768 301.099L425.965 298.439V298.423Z",
    fill: "#313131"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M427.46 301.575L428.035 302.741V305.303C427.641 304.613 427.131 303.677 426.754 302.971C426.967 302.544 427.246 301.986 427.46 301.575Z",
    fill: "#313131"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M420.184 297.799C421.005 298.308 421.81 298.817 422.631 299.326V301.904C421.81 301.395 420.988 300.886 420.167 300.377L419.674 298.817L420.167 297.815L420.184 297.799Z",
    fill: "#313131"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M419.527 301.181L419.937 300.229L419.444 298.669L418.985 298.39L418.59 299.26C418.59 299.359 418.59 299.457 418.59 299.556L419.067 300.919L419.527 301.198V301.181Z",
    fill: "#313131"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M425.357 298.029L425.16 300.689C424.914 300.836 424.569 301.05 424.323 301.198C424.142 300.541 423.912 299.654 423.748 298.981C424.29 298.653 424.815 298.341 425.357 298.012V298.029Z",
    fill: "#313131"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M423.534 299.129C423.715 299.786 423.928 300.672 424.126 301.329C423.748 301.559 423.255 301.855 422.877 302.085V299.523L423.534 299.129Z",
    fill: "#313131"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M428.314 306.387C429.135 306.896 429.956 307.405 430.761 307.914L431.32 309.424L430.991 310.327C430.17 309.818 429.349 309.309 428.544 308.8L428.314 306.37V306.387Z",
    fill: "#313131"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M431.583 309.589L432.042 309.868L432.65 311.362L432.371 312.232L431.911 311.937L431.254 310.492L431.583 309.589Z",
    fill: "#313131"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M425.752 302.101C426.622 303.71 426.671 303.809 427.23 304.794C427.066 305.188 426.836 305.713 426.688 306.107C426.425 305.664 426.064 305.089 425.801 304.646L425.752 302.101Z",
    fill: "#313131"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M427.427 305.155L428.084 306.272L428.33 308.685C427.903 308.012 427.328 307.125 426.901 306.452C427.066 306.058 427.263 305.533 427.443 305.155H427.427Z",
    fill: "#313131"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M420.233 301.345C420.66 301.608 421.235 301.969 421.662 302.232C421.974 302.429 422.385 302.675 422.697 302.873L422.927 305.303C422.105 304.794 421.284 304.285 420.479 303.776L419.872 302.281L420.249 301.345H420.233Z",
    fill: "#313131"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M419.937 304.498L420.216 303.628L419.609 302.134L419.149 301.854L418.853 302.659C418.853 302.758 418.886 302.84 418.886 302.938L419.461 304.219L419.921 304.498H419.937Z",
    fill: "#313131"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M425.127 301.723L425.177 304.268C424.947 304.4 424.651 304.58 424.438 304.728C424.208 304.088 423.896 303.25 423.682 302.61C424.158 302.314 424.651 302.019 425.127 301.74V301.723Z",
    fill: "#313131"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M423.501 302.708C423.731 303.349 424.027 304.186 424.257 304.81C423.928 305.007 423.485 305.27 423.157 305.484L422.91 303.07L423.485 302.708H423.501Z",
    fill: "#313131"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M428.692 309.72C429.513 310.229 430.334 310.738 431.139 311.247L431.829 312.676L431.632 313.497C430.811 312.988 429.989 312.479 429.184 311.97L428.708 309.72H428.692Z",
    fill: "#313131"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M432.075 312.84L432.535 313.119L433.274 314.515L433.11 315.303L432.65 315.024L431.878 313.644L432.075 312.84Z",
    fill: "#313131"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M425.867 305.598C426.852 307.191 426.901 307.24 427.509 308.193C427.394 308.554 427.23 309.03 427.131 309.391C426.836 308.965 426.441 308.406 426.162 307.996L425.867 305.615V305.598Z",
    fill: "#313131"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M427.739 308.538L428.462 309.605L428.955 311.855C428.478 311.214 427.838 310.36 427.378 309.72C427.493 309.359 427.624 308.882 427.739 308.538Z",
    fill: "#313131"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M420.611 304.679C421.432 305.188 422.253 305.697 423.058 306.206L423.534 308.456C422.713 307.947 421.892 307.438 421.087 306.929L420.348 305.533L420.594 304.679H420.611Z",
    fill: "#313131"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M420.676 307.569L420.841 306.781L420.101 305.385L419.642 305.106L419.461 305.828C419.477 305.91 419.51 305.992 419.527 306.091L420.216 307.29L420.676 307.569Z",
    fill: "#313131"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M425.242 305.221L425.538 307.602C425.341 307.717 425.078 307.881 424.881 307.996C424.602 307.388 424.224 306.6 423.961 305.992C424.388 305.73 424.815 305.483 425.242 305.221Z",
    fill: "#313131"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M423.814 306.091C424.093 306.699 424.454 307.487 424.75 308.094C424.471 308.259 424.093 308.488 423.797 308.653L423.304 306.403L423.814 306.091Z",
    fill: "#313131"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M429.414 312.807C429.841 313.07 430.416 313.431 430.843 313.694C431.155 313.891 431.566 314.137 431.878 314.334L432.683 315.68L432.601 316.403C431.78 315.894 430.958 315.385 430.154 314.876L429.414 312.823V312.807Z",
    fill: "#313131"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M432.929 315.828L433.389 316.124L434.243 317.421L434.21 318.094L433.751 317.815L432.847 316.551L432.929 315.828Z",
    fill: "#313131"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M426.327 308.882C427.427 310.393 427.46 310.459 428.15 311.345C428.084 311.674 428.002 312.084 427.936 312.413C427.608 312.019 427.181 311.493 426.869 311.083L426.327 308.866V308.882Z",
    fill: "#313131"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M428.38 311.674L429.184 312.692L429.924 314.744C429.398 314.153 428.708 313.349 428.199 312.741C428.248 312.429 428.33 312.002 428.396 311.674H428.38Z",
    fill: "#313131"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M421.317 307.782C422.138 308.291 422.959 308.8 423.764 309.309L424.503 311.362C423.682 310.853 422.861 310.344 422.056 309.835L421.202 308.538L421.333 307.782H421.317Z",
    fill: "#313131"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M421.777 310.36L421.81 309.687L420.956 308.39L420.496 308.111L420.414 308.751C420.414 308.751 420.479 308.899 420.512 308.981L421.317 310.098L421.777 310.377V310.36Z",
    fill: "#313131"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M425.702 308.505L426.244 310.722C426.08 310.82 425.85 310.951 425.686 311.034C425.357 310.475 424.914 309.72 424.602 309.162C424.963 308.948 425.341 308.735 425.702 308.505Z",
    fill: "#313131"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M424.454 309.227C424.783 309.786 425.21 310.541 425.555 311.099C425.308 311.231 424.996 311.411 424.766 311.543L424.027 309.49L424.454 309.244V309.227Z",
    fill: "#313131"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M430.482 315.631C430.909 315.894 431.484 316.255 431.911 316.518C432.223 316.715 432.634 316.961 432.946 317.158L433.882 318.39L433.931 318.998C433.11 318.488 432.289 317.979 431.484 317.47L430.498 315.631H430.482Z",
    fill: "#313131"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M434.112 318.538L434.572 318.833L435.557 320.015L435.656 320.574L435.196 320.295L434.161 319.145L434.112 318.538Z",
    fill: "#313131"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M427.115 311.92C428.265 313.299 428.363 313.414 429.102 314.252C429.102 314.531 429.07 314.892 429.07 315.171C428.725 314.794 428.248 314.301 427.903 313.923L427.115 311.92Z",
    fill: "#313131"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M429.382 314.547L430.252 315.5L431.238 317.339C430.663 316.781 429.924 316.025 429.365 315.467C429.365 315.188 429.365 314.827 429.382 314.547Z",
    fill: "#313131"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M422.385 310.59C423.206 311.099 424.011 311.608 424.832 312.117L425.817 313.956C424.996 313.447 424.175 312.938 423.37 312.429L422.385 311.247V310.607V310.59Z",
    fill: "#313131"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M423.222 312.84L423.14 312.281L422.155 311.099L421.695 310.82L421.728 311.362C421.728 311.362 421.81 311.493 421.859 311.575L422.762 312.577L423.222 312.856V312.84Z",
    fill: "#313131"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M426.491 311.526L427.279 313.529C427.148 313.595 426.967 313.694 426.819 313.759C426.441 313.234 425.932 312.561 425.555 312.035C425.927 311.827 426.233 311.657 426.474 311.526H426.491Z",
    fill: "#313131"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M425.456 312.101C425.834 312.61 426.327 313.316 426.721 313.825C426.524 313.923 426.277 314.038 426.08 314.137L425.095 312.298L425.456 312.101Z",
    fill: "#313131"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M431.895 318.144C432.716 318.653 433.537 319.162 434.342 319.671L435.41 320.787L435.59 321.263C434.769 320.754 433.948 320.245 433.143 319.736L431.911 318.144H431.895Z",
    fill: "#313131"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M435.656 320.918L436.116 321.214L437.233 322.281L437.446 322.708L436.986 322.429L435.837 321.411L435.656 320.918Z",
    fill: "#313131"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M428.265 314.662C429.562 315.992 429.628 316.058 430.433 316.83C430.466 317.06 430.515 317.372 430.581 317.585C430.203 317.24 429.694 316.781 429.316 316.436L428.281 314.646L428.265 314.662Z",
    fill: "#313131"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M430.728 317.125L431.681 318.012L432.913 319.605C432.305 319.096 431.484 318.406 430.876 317.881C430.827 317.651 430.761 317.355 430.728 317.125Z",
    fill: "#313131"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M423.797 313.103C424.618 313.612 425.44 314.121 426.244 314.63L427.476 316.222C427.049 315.96 426.474 315.598 426.047 315.336C425.735 315.139 425.325 314.892 425.013 314.695L423.896 313.628L423.764 313.103H423.797Z",
    fill: "#313131"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M425.013 314.974L424.799 314.547L423.682 313.48L423.222 313.201L423.37 313.628C423.37 313.628 423.469 313.743 423.534 313.808L424.553 314.712L425.013 314.991V314.974Z",
    fill: "#313131"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M427.64 314.285L428.675 316.075C428.56 316.124 428.429 316.173 428.314 316.222C427.887 315.746 427.296 315.139 426.885 314.646C427.328 314.449 427.345 314.432 427.64 314.285Z",
    fill: "#313131"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M426.803 314.679C427.23 315.155 427.805 315.779 428.248 316.239C428.1 316.288 427.903 316.354 427.755 316.387L426.524 314.794L426.803 314.679Z",
    fill: "#313131"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M437.43 322.955L437.315 322.807L436.132 321.822C435.311 321.313 434.49 320.804 433.685 320.295L434.72 321.263L437.446 322.955H437.43Z",
    fill: "#313131"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M438.53 323.644L438.021 323.25L437.561 322.955L437.676 323.119L438.53 323.644Z",
    fill: "#313131"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M429.759 317.093C431.172 318.324 431.221 318.373 432.108 319.096C432.207 319.276 432.322 319.523 432.42 319.687C432.01 319.375 431.451 318.948 431.057 318.636L429.759 317.093Z",
    fill: "#313131"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M434.473 321.116L433.455 320.18L432.437 319.375C432.535 319.556 432.65 319.786 432.765 319.95L433.849 320.738L434.49 321.132L434.473 321.116Z",
    fill: "#313131"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M429.07 317.75L428.035 316.781C427.213 316.272 426.409 315.763 425.587 315.254L425.834 315.648L426.343 316.042L429.07 317.733V317.75Z",
    fill: "#313131"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M426.097 315.91L425.587 315.516L425.127 315.221L425.242 315.368L426.097 315.91Z",
    fill: "#313131"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M429.135 316.715L430.433 318.259C430.433 318.259 430.252 318.291 430.17 318.308C429.677 317.897 429.037 317.339 428.56 316.912C428.889 316.814 428.905 316.814 429.135 316.731V316.715Z",
    fill: "#313131"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M429.94 318.291H430.121C429.628 317.881 428.971 317.339 428.495 316.912L428.281 316.961L429.299 317.897L429.94 318.291Z",
    fill: "#313131"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M433.011 320.212C432.584 319.9 432.026 319.49 431.599 319.178L432.19 319.703L433.011 320.212Z",
    fill: "#313131"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M431.583 319.309L430.991 318.784C430.991 318.784 430.827 318.784 430.761 318.784L431.583 319.293V319.309Z",
    fill: "#313131"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M469.886 308.094C469.738 320.475 478.279 325.697 488.971 319.736C499.664 313.776 508.451 298.915 508.599 286.518C508.747 274.137 500.206 268.915 489.513 274.876C478.821 280.837 470.033 295.697 469.886 308.094ZM472.448 307.799C472.579 296.419 480.66 282.741 490.482 277.273C500.305 271.805 508.156 276.584 508.024 287.979C507.876 299.359 499.812 313.037 489.99 318.505C480.168 323.973 472.316 319.194 472.448 307.799Z",
    fill: "#A5A7B3"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M489.99 318.488C499.812 313.02 507.893 299.342 508.024 287.963C508.09 282.183 506.103 278.094 502.834 276.189L514.118 282.741C514.726 283.102 515.284 283.529 515.81 284.022L517.715 285.122C520.951 286.994 522.922 291.033 522.856 296.764C522.725 308.028 514.726 321.542 505.002 326.961C500.222 329.621 495.919 329.835 492.782 328.012C492.306 327.733 491.862 327.421 491.435 327.043C490.532 326.846 489.694 326.518 488.906 326.074C485.522 324.104 481.005 321.493 477.622 319.523C480.775 321.362 485.144 321.148 489.973 318.455L489.99 318.488Z",
    fill: "url(#paint41_linear_358_13776)"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M489.99 318.488C499.812 313.02 507.893 299.342 508.024 287.963C508.09 282.38 506.234 278.39 503.179 276.419L508.993 279.802C509.601 280.163 510.16 280.59 510.685 281.083L512.59 282.183C515.826 284.055 517.797 288.094 517.731 293.825C517.6 305.089 509.601 318.603 499.878 324.022C495.098 326.682 490.795 326.895 487.657 325.073C487.181 324.794 486.738 324.482 486.31 324.104C485.555 323.94 484.832 323.677 484.159 323.332C481.892 322.019 479.576 320.672 477.638 319.539C480.792 321.378 485.161 321.165 489.99 318.472V318.488Z",
    fill: "url(#paint42_linear_358_13776)"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M508.304 299.079C509.897 299.408 512.262 298.669 514.414 297.47C515.596 296.813 516.73 296.009 517.633 295.171L519.046 295.992C518.142 296.83 517.009 297.634 515.826 298.291C512.87 299.933 509.552 300.705 508.304 299.079Z",
    fill: "url(#paint43_linear_358_13776)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M508.271 281.756C508.221 285.96 505.183 294.515 501.553 296.551C500.124 297.339 498.826 297.011 497.775 296.058C498.498 296.272 499.303 296.19 500.14 295.73C503.77 293.71 506.809 285.155 506.858 280.935C509.305 280.705 511.474 281.264 513.215 282.511C511.769 281.855 510.094 281.592 508.271 281.756Z",
    fill: "url(#paint44_linear_358_13776)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M496.905 326.633L495.492 325.812C497.365 321.854 498.531 315.204 496.954 312.905C497.102 312.905 497.25 312.922 497.381 312.971C500.288 313.808 499.073 322.035 496.888 326.633H496.905Z",
    fill: "url(#paint45_linear_358_13776)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M514.857 306.14C514.759 306.042 514.66 305.943 514.545 305.861C515.235 306.14 515.826 306.501 516.27 306.961C516.27 306.994 514.857 306.14 514.857 306.14Z",
    fill: "url(#paint46_linear_358_13776)"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M482.434 314.777C483.338 314.613 484.455 314.153 485.637 313.497C488.955 311.641 492.766 308.16 493.636 304.744C494.244 302.347 493.275 300.475 491.731 299.293C494.03 300.278 495.837 302.495 495.049 305.566C494.178 308.981 490.367 312.462 487.05 314.318C485.867 314.974 484.75 315.434 483.847 315.598C483.962 318.111 484.504 320.262 485.391 322.002C485.243 322.281 485.111 322.544 484.98 322.807C483.502 320.869 482.598 318.16 482.434 314.794V314.777Z",
    fill: "url(#paint47_linear_358_13776)"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M490.499 277.273C495.328 274.58 499.68 274.367 502.85 276.206L514.134 282.758C510.981 280.919 506.612 281.132 501.783 283.825C491.961 289.293 483.88 302.971 483.748 314.35C483.682 320.13 485.67 324.219 488.938 326.124L477.655 319.572C474.386 317.667 472.399 313.595 472.464 307.799C472.596 296.419 480.677 282.741 490.499 277.273Z",
    fill: "url(#paint48_linear_358_13776)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M495.131 289.079C492.388 291.871 489.973 295.237 488.084 298.833C491.517 298.209 496.231 300.935 495.049 305.565C494.178 308.981 490.367 312.462 487.05 314.317C485.867 314.974 484.75 315.434 483.847 315.598C484.011 318.964 484.914 321.674 486.393 323.611C488.068 320.081 491.961 315.204 494.983 313.513C495.903 313.004 496.724 312.79 497.397 312.971C500.305 313.808 499.089 322.035 496.905 326.633C498.022 326.337 499.171 325.894 500.37 325.303C500.37 325.303 500.387 325.303 500.403 325.286C500.469 325.253 500.535 325.22 500.584 325.188C500.617 325.171 500.666 325.155 500.699 325.122C500.715 325.122 500.748 325.106 500.764 325.089C500.83 325.056 500.879 325.023 500.945 324.991C500.962 324.991 500.978 324.974 500.994 324.958C501.06 324.925 501.126 324.892 501.192 324.843C501.257 324.81 501.323 324.761 501.389 324.728C501.389 324.728 501.422 324.711 501.438 324.695C501.504 324.662 501.569 324.629 501.619 324.58C501.635 324.58 501.651 324.564 501.684 324.547C501.734 324.514 501.766 324.498 501.816 324.465C501.865 324.432 501.914 324.416 501.947 324.383C501.98 324.367 501.996 324.35 502.029 324.334C503.228 323.611 504.378 322.757 505.495 321.805C503.409 319.588 502.374 312.61 505.331 308.505C506.02 307.552 506.858 306.846 507.778 306.337C510.817 304.646 514.627 305.221 516.237 306.928C517.781 303.299 518.766 299.539 519.013 295.943C518.109 296.797 516.976 297.585 515.793 298.242C512.475 300.097 508.698 300.836 507.893 298.34C506.825 294.974 511.654 286.928 515.12 283.71C513.297 282.166 510.932 281.477 508.221 281.723C508.172 285.927 505.134 294.482 501.504 296.518C497.874 298.538 495.016 293.267 495.065 289.047L495.131 289.079Z",
    fill: "url(#paint49_linear_358_13776)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M501.504 300.459C499.631 301.51 498.087 304.121 498.071 306.288C498.038 308.455 499.533 309.375 501.421 308.341C503.294 307.29 504.838 304.679 504.871 302.511C504.904 300.344 503.409 299.424 501.52 300.475L501.504 300.459Z",
    fill: "url(#paint50_linear_358_13776)"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M500.962 301.296C502.292 300.557 503.36 301.198 503.343 302.741C503.327 304.285 502.226 306.14 500.896 306.879C499.565 307.618 498.498 306.978 498.514 305.434C498.531 303.891 499.631 302.035 500.962 301.296Z",
    fill: "url(#paint51_linear_358_13776)"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M501.766 283.825C505.183 281.92 508.353 281.263 511.03 281.69C512.016 281.838 513.001 282.002 513.97 282.15C511.161 281.707 507.86 282.396 504.296 284.383C494.03 290.098 485.604 304.367 485.456 316.255C485.407 320.574 486.458 323.989 488.298 326.304C487.674 325.533 487.066 324.744 486.442 323.973C484.668 321.756 483.666 318.488 483.715 314.35C483.847 302.971 491.928 289.293 501.75 283.825H501.766Z",
    fill: "#A5A7B3"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M488.216 274.121C493.472 271.198 498.219 270.968 501.651 272.955L502.965 273.71C499.533 271.707 494.786 271.937 489.53 274.876C478.837 280.836 470.05 295.697 469.902 308.094C469.82 314.383 471.988 318.833 475.552 320.902L474.238 320.147C470.69 318.078 468.522 313.644 468.588 307.339C468.736 294.958 477.523 280.081 488.216 274.121Z",
    fill: "url(#paint52_linear_358_13776)"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M504.312 283.464C509.568 280.541 514.315 280.311 517.748 282.298L518.947 283.004C515.514 281.001 510.767 281.231 505.511 284.17C494.819 290.131 486.031 304.991 485.883 317.388C485.801 323.677 487.969 328.127 491.534 330.196L490.335 329.49C486.787 327.421 484.619 322.988 484.684 316.682C484.832 304.301 493.62 289.424 504.312 283.464Z",
    fill: "url(#paint53_linear_358_13776)"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M505.528 284.17C516.22 278.209 524.761 283.431 524.614 295.812C524.466 308.193 515.678 323.069 504.986 329.03C494.293 334.991 485.752 329.769 485.9 317.388C486.048 305.007 494.835 290.13 505.528 284.17ZM487.657 316.403C487.526 327.667 495.295 332.413 505.002 326.994C514.726 321.575 522.708 308.061 522.856 296.797C522.987 285.533 515.218 280.787 505.511 286.206C495.804 291.625 487.805 305.138 487.657 316.403Z",
    fill: "#E3E3E4"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M451.276 122.134L443.918 117.849C441.75 116.584 440.386 113.957 440.321 110.18C440.173 102.43 445.593 92.8405 452.393 88.7683C455.891 86.6665 459.094 86.453 461.394 87.783L468.752 92.0687C466.453 90.7387 463.266 90.9522 459.751 93.054C452.935 97.1262 447.531 106.716 447.679 114.466C447.745 118.226 449.108 120.87 451.276 122.134Z",
    fill: "url(#paint54_linear_358_13776)"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M472.349 99.7369C472.497 107.487 467.077 117.077 460.277 121.149C453.461 125.221 447.827 122.233 447.679 114.466C447.531 106.716 452.951 97.1261 459.751 93.0538C466.568 88.9816 472.201 91.9701 472.349 99.7369ZM470.477 100.853C470.362 94.2689 465.566 91.7402 459.784 95.1885C454.003 98.6367 449.42 106.781 449.535 113.366C449.65 119.95 454.446 122.479 460.228 119.031C466.009 115.583 470.592 107.438 470.477 100.853Z",
    fill: "#A5A7B3"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M467.8 128.702L452.59 119.868C450.75 118.801 449.601 116.551 449.535 113.366C449.42 106.781 454.003 98.6533 459.784 95.1886C462.757 93.4152 465.467 93.2181 467.422 94.3511L482.631 103.185C480.677 102.052 477.967 102.249 474.994 104.023C469.212 107.471 464.63 115.615 464.745 122.2C464.81 125.402 465.96 127.635 467.8 128.702Z",
    fill: "url(#paint55_linear_358_13776)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M485.686 109.688C485.801 116.272 481.219 124.4 475.437 127.865C469.656 131.313 464.876 128.784 464.745 122.2C464.63 115.615 469.212 107.487 474.994 104.023C480.775 100.574 485.555 103.103 485.686 109.688ZM483.42 111.051C483.321 105.895 479.576 103.908 475.043 106.617C470.51 109.326 466.913 115.697 467.011 120.853C467.11 126.009 470.855 127.996 475.388 125.287C479.921 122.578 483.518 116.207 483.42 111.051Z",
    fill: "#A5A7B3"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M510.488 126.781C510.587 131.937 506.99 138.308 502.456 141.018C497.923 143.727 494.178 141.74 494.08 136.584C493.981 131.428 497.578 125.057 502.111 122.348C506.645 119.638 510.39 121.625 510.488 126.781Z",
    fill: "#777B77"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M496.478 141.674L469.393 125.944C467.947 125.106 467.044 123.349 467.011 120.853C466.913 115.697 470.51 109.326 475.043 106.617C477.375 105.221 479.494 105.074 481.022 105.96L508.106 121.691C506.579 120.804 504.46 120.952 502.128 122.348C497.594 125.057 493.997 131.428 494.096 136.584C494.145 139.08 495.049 140.837 496.494 141.674H496.478Z",
    fill: "url(#paint56_linear_358_13776)"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M482.007 167.011L481.876 122.693C481.876 125.074 514.972 125.123 514.956 122.594L515.087 166.913C515.087 169.441 513.395 171.954 509.995 173.858C503.409 177.537 492.93 177.422 486.606 173.629C483.535 171.789 482.007 169.409 482.007 167.028V167.011Z",
    fill: "url(#paint57_linear_358_13776)"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M510.291 173.776L496.97 166.305C495.426 165.435 494.457 163.546 494.375 160.755C494.211 154.679 498.366 146.666 503.655 142.857C506.513 140.788 509.125 140.377 510.948 141.412L524.269 148.883C522.445 147.865 519.85 148.275 516.976 150.328C511.687 154.137 507.532 162.151 507.696 168.226C507.778 171.018 508.747 172.906 510.291 173.776Z",
    fill: "url(#paint58_linear_358_13776)"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M480.43 190.591L455.859 176.404L449.174 135.911L508.123 140.476L505.363 180.033L480.43 190.591Z",
    fill: "#373F42"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M486.163 191.116L480.43 190.591L478.657 154.335L485.013 153.809L486.163 191.116Z",
    fill: "#424A4D"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M485.013 153.809L486.163 191.116L505.363 180.032L508.123 140.476L485.013 153.809Z",
    fill: "#373F42"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M478.985 157.537L447.613 139.425C446.677 138.883 446.677 137.537 447.613 136.995L472.267 122.759C473.86 121.839 475.815 121.839 477.408 122.759L508.78 140.87C509.716 141.412 509.716 142.758 508.78 143.3L484.126 157.537C482.533 158.456 480.578 158.456 478.985 157.537Z",
    fill: "#3A4245"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M478.985 155.845L447.613 137.734C446.677 137.192 446.677 135.845 447.613 135.304L472.267 121.067C473.86 120.148 475.815 120.148 477.408 121.067L508.78 139.179C509.716 139.721 509.716 141.067 508.78 141.609L484.126 155.845C482.533 156.765 480.578 156.765 478.985 155.845Z",
    fill: "#4C5457"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M481.449 154.532L450.011 136.387L474.698 121.182L506.957 139.803L481.449 154.532Z",
    fill: "#787B79"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M480.414 148.193L453.05 132.414L476.538 118.85L503.902 134.647L480.414 148.193Z",
    fill: "#4C5457"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M480.414 148.193L453.05 132.414L450.011 136.387L481.449 154.532L480.414 148.193Z",
    fill: "#373F42"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M480.414 148.193L503.902 134.647L506.957 139.803L481.449 154.532L480.414 148.193Z",
    fill: "#424A4D"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M511.014 91.9702C503.869 87.9308 492.059 87.8159 484.602 91.7239C480.66 93.7929 478.739 96.5679 478.854 99.3101L479.97 120.492C479.856 117.898 481.679 115.271 485.391 113.317C492.421 109.622 503.59 109.737 510.324 113.547C513.691 115.451 515.317 117.931 515.235 120.377L516.188 99.1951C516.286 96.6007 514.561 93.9735 510.997 91.9538L511.014 91.9702Z",
    fill: "url(#paint59_linear_358_13776)"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M486.212 101.395C486.212 110.033 492.306 120.542 499.845 124.893C507.367 129.228 513.477 125.763 513.477 117.126C513.477 108.489 507.384 97.98 499.845 93.6286C492.322 89.2772 486.212 92.7583 486.212 101.395Z",
    fill: "#DFB152"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M508.364 126.511C513.65 123.421 513.597 113.498 508.245 104.345C502.893 95.1933 494.269 90.2784 488.983 93.3677C483.697 96.457 483.75 106.381 489.102 115.533C494.454 124.685 503.078 129.6 508.364 126.511Z",
    fill: "#B37635"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M489.628 104.844L481.153 118.965L484.192 122.479L494.392 105.763L489.628 104.844Z",
    fill: "url(#paint60_linear_358_13776)"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M493.685 104.368C492.815 103.842 491.353 103.826 490.433 104.335C489.513 104.844 489.481 105.681 490.367 106.223C491.238 106.749 492.7 106.765 493.62 106.256C494.539 105.747 494.572 104.91 493.685 104.368Z",
    fill: "url(#paint61_linear_358_13776)"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M512.426 91.1C520.327 95.8455 520.047 103.415 511.818 107.997C503.59 112.578 490.515 112.446 482.631 107.701C474.731 102.955 475.01 95.3857 483.239 90.8045C491.468 86.2232 504.542 86.3546 512.426 91.1ZM510.669 92.0852C503.705 87.8981 492.174 87.7831 484.914 91.8225C477.655 95.8619 477.408 102.545 484.389 106.732C491.353 110.919 502.883 111.034 510.143 106.995C517.403 102.955 517.649 96.2724 510.669 92.0852Z",
    fill: "#DEDEDE"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M476.965 120.328L476.883 99.458C476.883 102.43 478.804 105.402 482.631 107.701C490.532 112.446 503.59 112.578 511.818 107.997C516.056 105.632 518.175 102.479 518.175 99.343L518.257 120.213C518.257 123.366 516.138 126.519 511.901 128.867C503.672 133.448 490.597 133.317 482.713 128.571C478.886 126.272 476.981 123.3 476.965 120.328Z",
    fill: "url(#paint62_linear_358_13776)"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M484.192 129.425L476.866 133.645V130.919L484.192 120.706V129.425Z",
    fill: "#D2D2D6"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M484.192 120.706L477.638 131.051L476.883 133.645L473.86 131.904L474.616 129.31L481.17 118.965L481.777 118.358C482.073 118.046 482.549 117.98 482.927 118.193L483.206 118.358C483.732 118.653 484.077 119.195 484.126 119.803L484.208 120.722L484.192 120.706Z",
    fill: "#E4E5E6"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M461.722 84.696L458.207 82.6599C457.797 82.43 457.271 82.4465 456.696 82.7749L456.335 82.9883C455.054 83.7272 454.003 85.7141 454.003 87.4382V92.6271L457.518 94.6632L458.224 89.9341L459.521 91.4448L461.739 84.696H461.722Z",
    fill: "url(#paint63_linear_358_13776)"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M462.527 91.7731L457.501 94.6631V89.4743C457.501 87.7665 458.536 85.7633 459.833 85.0244L460.195 84.8109C461.476 84.072 462.527 84.8602 462.527 86.5679V91.7567V91.7731Z",
    fill: "#A5A7B3"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M542.993 150.771L535.405 146.502C537.754 147.816 539.232 150.706 539.347 154.959C539.593 164.22 533.253 176.436 525.188 182.249C520.819 185.385 516.845 186.026 514.085 184.466L521.673 188.735C524.449 190.295 528.424 189.671 532.777 186.518C540.841 180.706 547.181 168.489 546.935 159.228C546.82 154.975 545.342 152.085 542.993 150.771Z",
    fill: "url(#paint64_linear_358_13776)"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M528.161 158.358C528.276 162.84 525.205 168.768 521.296 171.576C517.387 174.4 514.118 173.037 514.003 168.555C513.888 164.072 516.96 158.144 520.869 155.336C524.778 152.512 528.046 153.875 528.161 158.358Z",
    fill: "#888B9B"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M539.347 154.975C539.347 154.762 539.347 154.548 539.314 154.335C538.772 145.583 532.169 143.054 524.285 148.735C523.562 149.261 522.856 149.836 522.15 150.443L519.834 156.157C520.162 155.862 520.507 155.583 520.869 155.32C524.679 152.561 527.899 153.793 528.145 158.029C528.145 158.128 528.145 158.226 528.145 158.341C528.227 161.182 527.028 164.581 525.139 167.422C524.039 169.08 522.708 170.542 521.279 171.576C519.686 172.725 518.208 173.185 516.992 173.005L516.303 185.221C518.799 185.566 521.871 184.63 525.156 182.266C528.129 180.131 530.871 177.11 533.138 173.694C537.014 167.849 539.478 160.821 539.33 154.975H539.347Z",
    fill: "#A5A7B3"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M519.752 192.151L508.106 185.615C505.331 184.055 503.59 180.656 503.458 175.632C503.163 164.712 510.636 150.312 520.162 143.448C525.303 139.737 530.001 138.998 533.253 140.837L544.898 147.372C541.63 145.533 536.949 146.272 531.808 149.983C522.298 156.831 514.824 171.248 515.103 182.167C515.235 187.175 516.992 190.591 519.752 192.151Z",
    fill: "url(#paint65_linear_358_13776)"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M549.547 157.356C549.842 168.276 542.369 182.676 532.842 189.54C523.332 196.387 515.383 193.103 515.087 182.184C514.791 171.264 522.265 156.863 531.791 150C541.301 143.152 549.251 146.437 549.547 157.356ZM546.935 159.244C546.689 149.983 539.954 147.192 531.873 153.005C523.809 158.817 517.469 171.034 517.715 180.295C517.961 189.556 524.696 192.348 532.777 186.535C540.841 180.722 547.181 168.505 546.935 159.244Z",
    fill: "#CBCFD0"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M465.779 126.798C465.434 126.584 464.974 126.584 464.465 126.88L464.153 127.06C463.069 127.684 462.199 129.359 462.199 130.788V134.581L465.829 136.683L469.376 128.883L465.763 126.798H465.779Z",
    fill: "url(#paint66_linear_358_13776)"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M474.862 128.85H465.812V136.863C465.812 137.536 466.239 138.193 467.126 138.702C468.884 139.72 471.758 139.72 473.515 138.702C474.402 138.193 474.846 137.52 474.846 136.847V128.867L474.862 128.85Z",
    fill: "url(#paint67_linear_358_13776)"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M467.143 130.706C468.9 131.724 471.774 131.724 473.532 130.706C475.306 129.688 475.306 128.029 473.548 127.011C471.791 125.993 468.917 125.993 467.159 127.011C465.385 128.029 465.385 129.688 467.143 130.706Z",
    fill: "#C2C2CA"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M467.767 129.605C469.179 130.427 471.479 130.41 472.891 129.605C474.304 128.784 474.32 127.454 472.891 126.65C471.462 125.845 469.179 125.845 467.767 126.65C466.354 127.471 466.338 128.801 467.767 129.605Z",
    fill: "#E2E2E2"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M474.205 131.674L474.156 131.789C473.811 131.461 473.384 131.494 472.891 131.773L472.579 131.954C471.495 132.577 470.625 134.252 470.625 135.681V139.474L474.255 141.576L477.802 133.776L474.189 131.691L474.205 131.674Z",
    fill: "url(#paint68_linear_358_13776)"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M476.226 134.022L476.538 133.842C477.622 133.218 478.492 133.875 478.492 135.32V139.113L474.271 141.543V137.75C474.271 136.305 475.142 134.646 476.226 134.022Z",
    fill: "#CBCFD0"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M479.543 139.868L475.766 137.75C475.618 137.668 475.519 137.487 475.519 137.208C475.519 136.617 475.914 135.829 476.423 135.451C476.702 135.254 476.965 135.205 477.129 135.303L480.907 137.422C480.726 137.323 480.48 137.356 480.2 137.569C479.691 137.947 479.281 138.719 479.297 139.326C479.297 139.606 479.396 139.786 479.543 139.868Z",
    fill: "url(#paint69_linear_358_13776)"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M480.956 137.816L482.237 138.538C482.352 138.604 482.434 138.752 482.434 138.949L481.153 138.226C481.153 138.013 481.071 137.865 480.956 137.816Z",
    fill: "#B37635"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M481.153 138.243L482.434 138.965C482.434 139.425 482.139 140.032 481.728 140.312C481.514 140.459 481.317 140.492 481.186 140.427L479.905 139.704C480.036 139.786 480.233 139.753 480.447 139.589C480.841 139.294 481.153 138.702 481.153 138.243Z",
    fill: "#B37635"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M479.33 139.671L479.297 139.458C479.297 139.458 479.297 139.376 479.297 139.326C479.297 138.735 479.691 137.947 480.2 137.569C480.283 137.504 480.365 137.471 480.447 137.438L480.644 137.356C480.562 137.389 480.463 137.438 480.365 137.52C479.773 137.947 479.297 138.85 479.33 139.523C479.33 139.573 479.33 139.638 479.33 139.688V139.671Z",
    fill: "#9C6B21"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M480.923 140.87L479.609 140.131C479.428 140.032 479.33 139.819 479.313 139.507C479.297 138.817 479.757 137.931 480.348 137.504C480.677 137.274 480.956 137.225 481.169 137.339L482.483 138.078C482.286 137.963 481.991 138.013 481.662 138.243C481.071 138.669 480.595 139.573 480.627 140.246C480.627 140.558 480.742 140.771 480.923 140.87Z",
    fill: "url(#paint70_linear_358_13776)"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M482.779 138.702C482.796 139.392 482.336 140.279 481.744 140.706C481.153 141.133 480.66 140.936 480.644 140.246C480.627 139.556 481.087 138.67 481.679 138.243C482.27 137.816 482.763 138.013 482.779 138.702ZM482.434 138.949C482.434 138.489 482.089 138.358 481.695 138.637C481.301 138.916 480.989 139.523 480.989 139.983C480.989 140.443 481.334 140.574 481.728 140.295C482.122 140.016 482.434 139.409 482.434 138.949Z",
    fill: "#D7A74D"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M493.833 104.285C494.786 104.86 494.753 105.78 493.767 106.338C492.766 106.896 491.172 106.88 490.22 106.305C489.267 105.73 489.3 104.811 490.285 104.253C491.271 103.694 492.88 103.711 493.833 104.285ZM493.62 104.4C492.766 103.891 491.369 103.875 490.482 104.368C489.595 104.86 489.563 105.665 490.417 106.174C491.271 106.683 492.667 106.699 493.554 106.207C494.441 105.714 494.474 104.909 493.62 104.4Z",
    fill: "#D0AA67"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M389.354 230.344H394.692C394.692 230.344 394.61 230.164 394.462 229.852C393.411 227.848 388.68 220.213 378.267 221.707C377.676 221.773 377.052 221.888 376.427 222.052C376.362 222.052 376.28 222.085 376.214 222.101C374.719 222.512 373.159 223.168 371.549 224.104C361.464 229.934 353.285 244.154 353.285 255.878C353.285 259.096 353.909 261.773 355.009 263.874C359.263 272.938 368.001 273.07 369.775 273.004C369.972 273.004 370.087 272.988 370.087 272.988L367.443 268.39C368.363 268.094 369.315 267.733 370.268 267.241C370.695 267.027 371.122 266.797 371.549 266.551C381.634 260.722 389.814 246.502 389.814 234.778C389.814 234.252 389.814 233.76 389.765 233.267C389.699 232.232 389.567 231.247 389.354 230.344ZM373.767 262.626C371.303 264.055 368.987 264.63 366.983 264.482C365.915 262.807 365.308 260.541 365.308 257.766C365.308 248.866 371.516 238.095 379.17 233.677C381.634 232.249 383.95 231.658 385.954 231.822C387.022 233.497 387.629 235.746 387.629 238.538C387.629 247.438 381.421 258.209 373.767 262.626Z",
    fill: "#777A85"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M394.462 229.852C391.358 225.073 385.346 224.088 378.448 228.078C368.363 233.907 360.183 248.127 360.183 259.852C360.183 267.93 364.059 272.709 369.775 273.004C372.371 273.136 375.327 272.347 378.448 270.525C388.533 264.696 396.712 250.476 396.712 238.751C396.712 235.057 395.907 232.052 394.462 229.852ZM365.291 257.75C365.291 248.85 371.5 238.078 379.154 233.661C381.618 232.233 383.934 231.641 385.938 231.806C387.005 233.481 387.613 235.73 387.613 238.522C387.613 247.421 381.404 258.193 373.75 262.61C371.286 264.039 368.971 264.613 366.967 264.466C365.899 262.791 365.291 260.525 365.291 257.75Z",
    fill: "#262626"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M393.017 241.756C393.017 250.656 386.808 261.428 379.154 265.845C376.937 267.126 374.851 267.733 372.995 267.733C372.83 267.733 372.683 267.733 372.535 267.733C372.338 267.733 372.141 267.7 371.96 267.684C371.845 267.684 371.73 267.651 371.615 267.618C371.467 267.602 371.319 267.569 371.188 267.52C371.073 267.487 370.958 267.47 370.843 267.421C370.794 267.421 370.761 267.388 370.728 267.372C370.613 267.339 370.498 267.306 370.383 267.257C370.35 267.257 370.317 267.224 370.285 267.224C370.038 267.126 369.808 267.011 369.578 266.879C369.578 266.879 369.578 266.879 369.562 266.879C369.447 266.814 369.332 266.748 369.217 266.666C369.102 266.584 368.971 266.502 368.856 266.419C368.379 266.075 367.952 265.664 367.574 265.204C367.476 265.089 367.394 264.975 367.312 264.86L367.032 264.449C369.036 264.597 371.352 264.022 373.816 262.594C381.47 258.176 387.679 247.388 387.679 238.505C387.679 235.714 387.071 233.448 386.003 231.789C386.266 231.805 386.529 231.838 386.775 231.888C386.89 231.904 387.022 231.937 387.153 231.97C387.268 232.003 387.383 232.035 387.498 232.052C387.744 232.117 387.991 232.216 388.221 232.314C388.336 232.364 388.451 232.413 388.566 232.462C388.681 232.512 388.779 232.577 388.894 232.626C389.223 232.807 389.535 233.004 389.814 233.25C390.027 233.415 390.224 233.595 390.405 233.792C390.569 233.957 390.717 234.137 390.881 234.318C390.898 234.351 390.931 234.383 390.947 234.4C391.029 234.498 391.111 234.597 391.177 234.712C391.259 234.827 391.341 234.942 391.407 235.057C391.489 235.172 391.555 235.287 391.637 235.418C391.933 235.927 392.179 236.485 392.393 237.109C392.442 237.224 392.475 237.356 392.508 237.487C392.869 238.718 393.082 240.147 393.082 241.74L393.017 241.756Z",
    fill: "#6E6C71"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M393.017 241.756C393.017 250.656 386.808 261.428 379.154 265.845C376.937 267.126 374.851 267.733 372.995 267.733C372.83 267.733 372.683 267.733 372.535 267.733C372.338 267.733 372.141 267.7 371.96 267.684C371.845 267.684 371.73 267.651 371.615 267.618C371.467 267.602 371.319 267.569 371.188 267.52C371.073 267.487 370.958 267.47 370.843 267.421C370.794 267.421 370.761 267.388 370.728 267.372C370.613 267.339 370.498 267.306 370.383 267.257C370.35 267.257 370.317 267.224 370.285 267.224C370.038 267.126 369.808 267.011 369.578 266.879C369.578 266.879 369.578 266.879 369.562 266.879C369.447 266.814 369.332 266.748 369.217 266.666C369.102 266.584 368.971 266.502 368.856 266.419C368.379 266.075 367.952 265.664 367.574 265.204C367.476 265.089 367.394 264.975 367.312 264.86L367.032 264.449C369.036 264.597 371.352 264.022 373.816 262.594C381.47 258.176 387.679 247.388 387.679 238.505C387.679 235.714 387.071 233.448 386.003 231.789C386.266 231.805 386.529 231.838 386.775 231.888C386.89 231.904 387.022 231.937 387.153 231.97C387.268 232.003 387.383 232.035 387.498 232.052C387.744 232.117 387.991 232.216 388.221 232.314C388.336 232.364 388.451 232.413 388.566 232.462C388.681 232.512 388.779 232.577 388.894 232.626C389.223 232.807 389.535 233.004 389.814 233.25C390.027 233.415 390.224 233.595 390.405 233.792C390.569 233.957 390.717 234.137 390.881 234.318C390.898 234.351 390.931 234.383 390.947 234.4C391.029 234.498 391.111 234.597 391.177 234.712C391.259 234.827 391.341 234.942 391.407 235.057C391.489 235.172 391.555 235.287 391.637 235.418C391.933 235.927 392.179 236.485 392.393 237.109C392.442 237.224 392.475 237.356 392.508 237.487C392.869 238.718 393.082 240.147 393.082 241.74L393.017 241.756Z",
    fill: "#777A85"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M381.503 244.416V232.544C380.747 232.824 379.959 233.201 379.17 233.661C377.626 234.548 376.165 235.681 374.785 237.027V248.275L365.439 259.802C365.669 261.674 366.195 263.25 367 264.482L367.279 264.892C367.361 265.007 367.459 265.122 367.542 265.237C367.657 265.385 367.788 265.533 367.919 265.648L378.136 253.053L388.598 253.973L391.982 245.352L381.536 244.433L381.503 244.416ZM372.453 257.569L369.233 261.559C368.921 261.953 368.527 262.052 368.346 261.789L367.492 260.574C367.328 260.328 367.427 259.802 367.739 259.424L370.958 255.451C371.27 255.073 371.664 254.975 371.828 255.221L372.683 256.436C372.863 256.699 372.748 257.208 372.453 257.585V257.569ZM379.647 239.211C379.647 239.622 379.351 240.114 379.006 240.311L377.282 241.296C376.92 241.51 376.641 241.346 376.641 240.935V236.666C376.641 236.255 376.937 235.746 377.282 235.549L379.006 234.564C379.351 234.367 379.647 234.531 379.647 234.942V239.211ZM387.892 250.574C387.711 251.034 387.317 251.379 387.005 251.346L383.786 251.05C383.474 251.017 383.375 250.64 383.556 250.18L384.426 247.98C384.607 247.52 385.001 247.175 385.313 247.191L388.533 247.471C388.845 247.503 388.943 247.897 388.763 248.357L387.892 250.558V250.574Z",
    fill: "#696C75"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M381.306 243.776L375.097 254.531L372.683 253.136C371.796 252.725 371.237 251.691 371.237 250.196C371.237 247.388 373.192 243.973 375.623 242.577C376.805 241.888 377.873 241.822 378.661 242.249L381.306 243.776Z",
    fill: "#777A85"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M378.119 244.022C375.705 245.418 373.734 248.833 373.734 251.641C373.734 254.449 375.688 255.599 378.119 254.203C380.534 252.807 382.505 249.392 382.505 246.584C382.505 243.776 380.55 242.627 378.119 244.022Z",
    fill: "#262626"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M376.132 199.802L396.581 226.255L391.703 224.367L374.194 212.003L376.132 199.802Z",
    fill: "#777A85"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M396.581 226.256L371.106 207.208L374.194 212.003L391.703 224.367L396.581 226.256Z",
    fill: "#262626"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M372.058 251.477L374.456 255.631L396.006 243.201C396.351 243.037 396.564 242.643 396.564 242.068C396.564 240.984 395.809 239.671 394.873 239.129C394.413 238.866 394.002 238.833 393.69 238.998L372.042 251.477H372.058Z",
    fill: "#C1C4D6"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M373.29 251.576C374.227 252.117 374.982 253.431 374.982 254.515C374.982 255.598 374.227 256.042 373.29 255.5C372.354 254.958 371.599 253.644 371.599 252.561C371.599 251.477 372.354 251.034 373.29 251.576Z",
    fill: "#262626"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M373.849 254.121C373.849 254.384 373.75 254.548 373.619 254.63C373.586 254.63 373.553 254.646 373.52 254.663L366.08 257.783L356.044 253.513L356.882 251.526L366.08 255.434L372.535 252.725C372.535 252.725 372.6 252.692 372.633 252.676C372.765 252.643 372.913 252.676 373.06 252.774C373.487 253.021 373.832 253.612 373.832 254.104L373.849 254.121Z",
    fill: "#C1C4D6"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M369.48 232.66C369.48 232.66 386.118 201.297 378.891 190.689L359.707 231.461L365.456 234.778L369.48 232.643V232.66Z",
    fill: "#FF3F3F"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M346.764 219.507L343.348 224.942C334.117 237.783 314.801 255.566 314.801 255.566C293.843 276.354 280.752 247.356 280.752 247.356L271.932 260.656C275.808 263.579 287.355 272.216 289.26 273.628C290.393 274.466 291.445 275.435 292.677 276.026L314.965 288.965L315.376 282.61L308.231 275.369L303.139 273.448C305.061 272.298 306.999 270.968 308.904 269.704L308.362 272.955L320.041 278.702L338.65 273.218L356.438 253.628L364.257 241.773L367.657 236.338L369.463 232.627L346.748 219.474L346.764 219.507Z",
    fill: "#FF3F3F"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M369.48 232.66C363.156 245.123 337.517 268.735 337.517 268.735C316.558 289.523 303.468 260.525 303.468 260.525L294.648 273.825C298.524 276.748 310.071 285.385 311.976 286.797C313.98 288.275 315.704 290.147 318.677 289.638C323.408 288.833 328.598 284.761 333.493 281.625C336.745 279.539 339.98 277.471 343.233 275.418C343.265 275.385 343.38 275.352 343.413 275.303L359.395 255.008L369.463 232.643L369.48 232.66Z",
    fill: "#FF3F3F"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M303.468 260.508L294.648 273.825L271.932 260.673L280.752 247.372L303.468 260.508Z",
    fill: "#FF3F3F"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M296.898 283.217H302.236C302.236 283.217 302.154 283.037 302.006 282.725C300.955 280.722 296.224 273.086 285.811 274.58C285.22 274.646 284.595 274.761 283.955 274.925C283.889 274.925 283.807 274.958 283.741 274.974C282.247 275.385 280.686 276.042 279.077 276.978C268.992 282.807 260.812 297.027 260.812 308.751C260.812 311.969 261.436 314.646 262.537 316.748C266.791 325.812 275.529 325.943 277.303 325.877C277.5 325.877 277.615 325.861 277.615 325.861L274.97 321.263C275.89 320.968 276.843 320.607 277.796 320.114C278.223 319.9 278.65 319.671 279.077 319.424C289.162 313.595 297.341 299.375 297.341 287.651C297.341 287.125 297.341 286.633 297.292 286.14C297.226 285.106 297.095 284.121 296.881 283.217H296.898ZM281.31 315.5C278.847 316.928 276.531 317.503 274.527 317.355C273.459 315.68 272.852 313.414 272.852 310.639C272.852 301.74 279.06 290.968 286.714 286.551C289.178 285.122 291.494 284.531 293.498 284.695C294.565 286.37 295.173 288.62 295.173 291.411C295.173 300.311 288.965 311.083 281.31 315.5Z",
    fill: "#777A85"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M301.99 282.725C298.885 277.947 292.874 276.961 285.975 280.952C275.89 286.781 267.711 301.001 267.711 312.725C267.711 320.804 271.587 325.582 277.303 325.877C279.898 326.009 282.854 325.221 285.975 323.398C296.06 317.569 304.24 303.349 304.24 291.625C304.24 287.93 303.435 284.925 301.99 282.725ZM272.819 310.623C272.819 301.723 279.027 290.951 286.681 286.534C289.145 285.106 291.461 284.515 293.465 284.679C294.533 286.354 295.14 288.603 295.14 291.395C295.14 300.295 288.932 311.066 281.278 315.483C278.814 316.912 276.498 317.487 274.494 317.339C273.426 315.664 272.819 313.398 272.819 310.623Z",
    fill: "#262626"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M300.544 294.629C300.544 303.529 294.335 314.301 286.681 318.718C284.464 319.999 282.378 320.606 280.522 320.606C280.358 320.606 280.21 320.606 280.062 320.606C279.865 320.606 279.668 320.574 279.487 320.557C279.372 320.557 279.257 320.524 279.142 320.491C278.995 320.475 278.847 320.442 278.715 320.393C278.6 320.36 278.485 320.344 278.37 320.294C278.321 320.294 278.288 320.262 278.255 320.245C278.14 320.212 278.025 320.179 277.91 320.13C277.878 320.13 277.845 320.097 277.812 320.097C277.566 319.999 277.336 319.884 277.106 319.753C277.106 319.753 277.106 319.753 277.089 319.753C276.974 319.687 276.859 319.621 276.744 319.539C276.629 319.457 276.498 319.375 276.383 319.293C275.907 318.948 275.48 318.537 275.102 318.078C275.003 317.963 274.921 317.848 274.839 317.733L274.56 317.322C276.564 317.47 278.88 316.895 281.343 315.467C288.997 311.05 295.206 300.262 295.206 291.378C295.206 288.587 294.598 286.321 293.531 284.662C293.793 284.679 294.056 284.728 294.303 284.761C294.418 284.777 294.549 284.81 294.68 284.843C294.795 284.876 294.91 284.892 295.025 284.925C295.272 284.991 295.518 285.089 295.748 285.188C295.863 285.237 295.978 285.286 296.093 285.336C296.208 285.385 296.306 285.451 296.421 285.5C296.75 285.68 297.062 285.877 297.341 286.124C297.555 286.288 297.752 286.469 297.933 286.666C298.097 286.83 298.245 287.01 298.409 287.191C298.425 287.224 298.458 287.257 298.475 287.273C298.557 287.372 298.639 287.47 298.705 287.585C298.787 287.7 298.869 287.815 298.934 287.93C299.017 288.045 299.082 288.16 299.164 288.291C299.46 288.8 299.706 289.359 299.92 289.983C299.969 290.097 300.002 290.229 300.035 290.36C300.396 291.592 300.61 293.02 300.61 294.613L300.544 294.629Z",
    fill: "#6E6C71"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M300.544 294.629C300.544 303.529 294.335 314.301 286.681 318.718C284.464 319.999 282.378 320.606 280.522 320.606C280.358 320.606 280.21 320.606 280.062 320.606C279.865 320.606 279.668 320.574 279.487 320.557C279.372 320.557 279.257 320.524 279.142 320.491C278.995 320.475 278.847 320.442 278.715 320.393C278.6 320.36 278.485 320.344 278.37 320.294C278.321 320.294 278.288 320.262 278.255 320.245C278.14 320.212 278.025 320.179 277.91 320.13C277.878 320.13 277.845 320.097 277.812 320.097C277.566 319.999 277.336 319.884 277.106 319.753C277.106 319.753 277.106 319.753 277.089 319.753C276.974 319.687 276.859 319.621 276.744 319.539C276.629 319.457 276.498 319.375 276.383 319.293C275.907 318.948 275.48 318.537 275.102 318.078C275.003 317.963 274.921 317.848 274.839 317.733L274.56 317.322C276.564 317.47 278.88 316.895 281.343 315.467C288.997 311.05 295.206 300.262 295.206 291.378C295.206 288.587 294.598 286.321 293.531 284.662C293.793 284.679 294.056 284.728 294.303 284.761C294.418 284.777 294.549 284.81 294.68 284.843C294.795 284.876 294.91 284.892 295.025 284.925C295.272 284.991 295.518 285.089 295.748 285.188C295.863 285.237 295.978 285.286 296.093 285.336C296.208 285.385 296.306 285.451 296.421 285.5C296.75 285.68 297.062 285.877 297.341 286.124C297.555 286.288 297.752 286.469 297.933 286.666C298.097 286.83 298.245 287.01 298.409 287.191C298.425 287.224 298.458 287.257 298.475 287.273C298.557 287.372 298.639 287.47 298.705 287.585C298.787 287.7 298.869 287.815 298.934 287.93C299.017 288.045 299.082 288.16 299.164 288.291C299.46 288.8 299.706 289.359 299.92 289.983C299.969 290.097 300.002 290.229 300.035 290.36C300.396 291.592 300.61 293.02 300.61 294.613L300.544 294.629Z",
    fill: "#777A85"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M289.03 297.29V285.418C288.275 285.697 287.486 286.075 286.698 286.534C285.154 287.421 283.692 288.554 282.312 289.9V301.148L272.967 312.675C273.197 314.547 273.722 316.124 274.527 317.355L274.806 317.766C274.888 317.881 274.97 317.996 275.069 318.111C275.184 318.258 275.315 318.406 275.447 318.521L285.663 305.927L296.126 306.846L299.509 298.226L289.063 297.306L289.03 297.29ZM279.98 310.442L276.761 314.432C276.449 314.826 276.054 314.925 275.874 314.662L275.02 313.447C274.839 313.201 274.954 312.675 275.266 312.298L278.485 308.324C278.797 307.946 279.192 307.848 279.356 308.094L280.21 309.309C280.391 309.572 280.276 310.081 279.98 310.459V310.442ZM287.174 292.084C287.174 292.495 286.879 292.987 286.534 293.185L284.809 294.17C284.448 294.383 284.168 294.219 284.168 293.808V289.539C284.168 289.129 284.464 288.62 284.809 288.423L286.534 287.437C286.879 287.24 287.174 287.405 287.174 287.815V292.084ZM295.42 303.447C295.239 303.907 294.845 304.252 294.533 304.219L291.313 303.923C291.001 303.891 290.903 303.513 291.083 303.053L291.954 300.853C292.135 300.393 292.529 300.048 292.841 300.065L296.06 300.344C296.372 300.377 296.471 300.771 296.29 301.23L295.42 303.431V303.447Z",
    fill: "#696C75"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M288.833 296.649L282.624 307.405L280.21 306.009C279.323 305.598 278.765 304.564 278.765 303.07C278.765 300.262 280.719 296.846 283.15 295.451C284.333 294.761 285.4 294.695 286.189 295.122L288.833 296.649Z",
    fill: "#777A85"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M285.647 296.896C283.232 298.291 281.261 301.707 281.261 304.515C281.261 307.322 283.216 308.472 285.647 307.076C288.061 305.68 290.032 302.265 290.032 299.457C290.032 296.649 288.078 295.5 285.647 296.896Z",
    fill: "#262626"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M328.171 257.043C328.516 257.241 329.009 257.339 329.698 257.323C334.215 257.273 338.404 255.073 342.329 252.823C344.957 251.329 347.585 249.769 349.95 247.881C354.237 244.466 357.818 240.557 361.103 236.19C367.574 227.569 373.668 217.618 377.002 207.323C377.709 205.139 378.251 202.906 378.596 200.656C379.088 197.405 379.86 193.513 377.758 190.673C375.935 188.21 372.913 187.389 370.005 187.044C365.258 186.485 360.15 186.847 355.453 187.635C353.679 187.93 351.905 188.341 350.18 188.866C348.587 189.359 347.01 189.95 345.516 190.673C344.826 191.001 343.988 191.313 343.413 191.822C342.888 192.282 342.411 192.873 341.984 193.431C340.079 195.861 338.946 198.784 337.632 201.543C334.79 207.471 333.016 213.924 329.337 219.441C327.284 222.528 324.426 225.5 323.966 229.342C323.72 231.379 324.59 233.021 325.691 234.663C326.643 236.091 328.056 237.7 328.532 239.342C329.534 242.823 329.124 246.518 328.532 250.016C328.237 251.723 327.892 253.431 327.629 255.155C327.481 256.124 327.629 256.715 328.154 257.027L328.171 257.043Z",
    fill: "#FF3F3F"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M324.442 235.697C324.984 236.502 325.691 237.175 326.315 237.93C327.842 239.786 328.795 242.068 329.271 244.433C329.748 246.781 329.781 249.211 329.616 251.609C330.175 249.08 330.585 246.518 330.832 243.924C331.012 242.101 331.127 240.262 330.832 238.456C330.536 236.65 329.813 234.876 328.516 233.595C327.892 232.988 327.169 232.495 326.413 232.052C326.052 231.838 325.691 231.641 325.28 231.559C324.869 231.477 324.426 231.559 324.114 231.822C323.128 232.709 323.851 234.827 324.426 235.697H324.442Z",
    fill: "#C1C4D6"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M366.868 196.847C366.063 193.021 363.485 189.753 359.625 188.719C357.457 188.144 355.633 187.848 353.383 188.177C350.87 188.554 348.406 189.326 346.074 190.361C342.756 191.822 339.767 194.022 337.336 196.715C334.593 199.737 332.54 203.349 331.193 207.191C329.83 211.034 329.633 215.172 328.22 218.998C327.185 221.789 325.543 224.318 324.508 227.109C323.588 229.589 322.439 235.09 325.625 236.42C331.637 238.916 338.486 236.469 343.003 232.167C345.072 230.196 345.91 227.224 347.52 224.81C349.474 221.888 351.872 219.26 354.648 217.077C357.391 214.909 360.906 213.316 363.14 210.558C365.193 208.012 366.687 205.008 367.098 201.74C367.312 200.131 367.246 198.456 366.901 196.847H366.868Z",
    fill: "#362C29"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M332.967 230.919C334.905 228.686 336.203 225.812 337.467 223.086C338.864 220.114 340.358 217.142 342.428 214.597C344.284 212.315 346.567 210.426 348.751 208.472C350.952 206.518 353.104 204.449 354.632 201.953C355.617 200.344 356.307 198.538 356.52 196.65C356.701 195.024 356.57 192.84 355.486 191.51C354.566 190.377 352.989 190.032 351.527 190.016C342.083 189.868 335.595 197.471 332.491 205.599C330.388 211.116 329.321 216.978 327.169 222.479C326.167 225.04 324.919 227.553 324.804 230.36C324.755 231.461 324.902 232.676 325.691 233.431C326.857 234.548 328.811 234.121 330.191 233.283C331.242 232.643 332.146 231.838 332.934 230.935L332.967 230.919Z",
    fill: "#777A85"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M287.174 269.622H290.377L288.784 300.984C288.8 301.231 288.652 301.493 288.307 301.69C287.683 302.052 286.665 302.052 286.041 301.69C285.745 301.51 285.581 301.28 285.581 301.05L287.174 269.622Z",
    fill: "#C1C4D6"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M287.634 270.311C288.258 270.673 289.277 270.673 289.901 270.311C290.525 269.95 290.525 269.359 289.901 269.014C289.277 268.653 288.258 268.653 287.634 269.014C287.01 269.375 287.01 269.966 287.634 270.311Z",
    fill: "#333333"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M289.309 206.83C290.344 206.256 291.527 206.009 292.808 206.403C295.436 207.224 298.146 209.999 300.38 211.576C301.185 212.15 310.038 217.504 309.89 218.325C308.674 224.925 307.475 231.526 306.26 238.111C305.192 243.957 304.108 249.819 303.041 255.664C302.597 258.127 302.137 260.574 301.694 263.037C301.168 265.861 301.053 268.324 298.392 269.983C293.235 273.185 288.061 276.387 282.674 279.178C279.126 281.017 275.085 281.789 273.082 277.52C271.784 274.761 271.669 271.461 271.455 268.489C271.111 263.776 271.291 259.047 271.784 254.351C272.605 246.518 274.297 238.784 276.826 231.329C279.29 224.055 282.017 216.518 286.156 209.999C286.928 208.768 288.012 207.52 289.309 206.797V206.83Z",
    fill: "#362C29"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M280.867 254.794C282.214 252.232 293.662 223.086 294.467 221.083C295.518 218.456 296.931 215.221 294.746 212.791C293.761 211.691 292.447 210.903 290.936 210.985C289.654 211.067 288.324 212.446 287.618 210.722C283.709 215.139 281.442 220.689 279.438 226.157C277.27 232.118 275.365 238.062 274.116 244.318C273.394 247.897 270.913 255.549 274.905 258.012C276.58 259.03 277.993 258.604 279.29 257.142C279.914 256.42 280.44 255.631 280.883 254.794H280.867Z",
    fill: "#FF3F3F"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M288.357 270.147C288.193 266.042 289.589 261.362 290.903 257.52C292.364 253.218 294.303 249.063 296.487 245.09C298.343 241.707 300.692 238.423 303.369 235.631C303.993 234.991 304.979 234.187 305.899 234.072C306.884 233.957 307.081 235.057 307.032 235.812C306.474 244.712 302.712 253.48 303.665 262.462C303.796 263.645 303.993 264.827 303.763 266.009C303.566 266.994 303.024 267.536 302.334 268.275C300.626 270.098 298.622 271.773 296.651 273.3C294.992 274.58 292.02 274.285 290.032 274.006C288.669 273.825 288.406 271.74 288.34 270.147H288.357Z",
    fill: "#FF3F3F"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M278.699 190.197L280.703 186.715L270.388 180.755C270.141 180.64 269.797 180.673 269.419 180.886C268.63 181.346 267.99 182.446 267.99 183.349C267.99 183.776 268.138 184.088 268.368 184.236L278.682 190.197H278.699Z",
    fill: "#575961"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M268.433 181.904L279.717 188.423L278.699 190.197L268.384 184.236C268.154 184.072 268.006 183.776 268.006 183.349C268.006 182.89 268.17 182.364 268.45 181.921L268.433 181.904Z",
    fill: "#333439"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M278.223 189.244C278.223 188.341 278.863 187.241 279.652 186.781C280.44 186.321 281.081 186.683 281.081 187.586C281.081 188.489 280.44 189.589 279.652 190.049C278.863 190.509 278.223 190.147 278.223 189.244Z",
    fill: "#333439"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M279.799 191.428L282.312 187.06L280.801 186.19C280.489 186.042 280.062 186.091 279.602 186.354C278.617 186.929 277.812 188.308 277.812 189.441C277.812 189.983 277.993 190.361 278.288 190.558L279.799 191.428Z",
    fill: "#696B75"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M279.208 190.229C279.208 189.096 280.013 187.717 280.998 187.142C281.984 186.568 282.789 187.027 282.789 188.16C282.789 189.293 281.984 190.673 280.998 191.247C280.013 191.822 279.208 191.362 279.208 190.229Z",
    fill: "#333439"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M309.873 218.325C309.496 220.361 309.134 222.397 308.74 224.449C306.441 224.515 304.125 224.416 301.825 224.187C297.44 223.727 293.071 222.725 289.211 220.64C286.879 219.375 284.76 217.717 282.937 215.763C283.906 213.792 284.957 211.871 286.123 210.032C286.911 208.817 287.995 207.553 289.293 206.847C290.328 206.256 291.51 206.026 292.792 206.42C295.403 207.241 298.13 210.016 300.347 211.592C301.168 212.167 310.021 217.503 309.857 218.341L309.873 218.325Z",
    fill: "#777A85"
  }))), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M279.06 204.039C280.949 209.934 285.187 215.024 290.623 217.963C294.483 220.049 298.869 221.05 303.238 221.51C309.348 222.15 315.573 221.74 321.552 220.311C324.196 219.687 326.873 218.817 328.976 217.077C331.817 214.712 331.242 210.18 330.24 207.044C329.074 203.398 326.939 200.098 324.295 197.356C320.829 193.743 316.509 191.05 311.992 188.883C307.475 186.715 302.696 185.057 297.735 184.417C293.678 183.891 289.589 184.039 285.663 185.123C282.624 185.96 279.356 187.323 278.272 190.558C276.843 194.843 277.697 199.852 279.044 204.055L279.06 204.039Z",
    fill: "#362C29"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M330.98 213.267C330.454 213.382 329.928 213.448 329.403 213.513C323.539 214.121 317.593 213.842 311.779 212.873C306.359 211.953 301.004 210.394 296.159 207.799C291.445 205.27 286.796 202.364 283.068 198.456C282.756 198.128 282.46 197.799 282.165 197.471C281.163 196.321 280.243 195.073 279.619 193.727C279.142 192.692 278.6 191.543 278.37 190.361C279.52 187.257 282.707 185.944 285.696 185.123C289.622 184.039 293.728 183.891 297.768 184.417C302.729 185.057 307.508 186.732 312.025 188.883C316.542 191.05 320.862 193.76 324.327 197.372C326.972 200.114 329.107 203.415 330.273 207.06C330.865 208.899 331.308 211.215 330.996 213.283L330.98 213.267Z",
    fill: "#FF3F3F"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M297.818 214.301C303.008 210.82 307.492 206.288 311.795 201.691C313.668 199.687 315.507 197.668 317.33 195.632C317.823 195.073 318.332 194.499 318.612 193.809C318.874 193.168 318.924 192.462 318.907 191.773C318.907 191.001 318.792 190.229 318.628 189.474C318.546 189.096 318.431 188.719 318.316 188.357C317.675 186.469 316.657 184.696 315.097 183.464C313.602 182.282 311.894 181.395 310.087 180.853C306.474 179.737 302.532 179.95 298.984 181.182C297.801 181.592 296.914 182.118 296.241 183.185C293.744 187.175 291.937 191.559 290.689 196.075C289.162 201.576 288.439 207.487 288.652 213.218C288.718 214.827 289.079 216.748 290.591 217.306C291.658 217.7 292.824 217.224 293.826 216.699C295.222 215.976 296.553 215.172 297.85 214.318L297.818 214.301Z",
    fill: "#362C29"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M297.456 202.479C300.331 200.393 302.811 197.799 305.258 195.205C306.933 193.431 308.625 191.641 310.103 189.687C311.237 188.193 313.799 185.796 312.584 183.71C312.337 183.3 311.943 183.004 311.549 182.758C308.067 180.508 303.583 180.18 299.641 181.215C298.491 181.527 297.423 182.282 296.586 183.119C294.845 184.909 293.793 187.257 292.742 189.474C291.198 192.774 290.18 196.338 289.769 199.967C289.638 201.165 289.129 203.776 290.262 204.581C291.198 205.254 292.594 204.909 293.596 204.581C294.992 204.121 296.274 203.333 297.456 202.462V202.479Z",
    fill: "#FF3F3F"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M328.319 217.323L330.832 212.955L329.321 212.085C329.009 211.937 328.582 211.986 328.122 212.249C327.136 212.824 326.331 214.203 326.331 215.336C326.331 215.878 326.512 216.255 326.808 216.453L328.319 217.323Z",
    fill: "#696B75"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M327.727 216.141C327.727 215.008 328.532 213.628 329.518 213.053C330.503 212.479 331.308 212.939 331.308 214.072C331.308 215.205 330.503 216.584 329.518 217.159C328.532 217.733 327.727 217.274 327.727 216.141Z",
    fill: "#333439"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M338.962 222.857L340.966 219.375L330.651 213.415C330.405 213.3 330.06 213.333 329.682 213.546C328.894 214.006 328.253 215.106 328.253 216.009C328.253 216.436 328.401 216.748 328.631 216.896L338.946 222.857H338.962Z",
    fill: "#575961"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M339.948 221.165L338.962 222.857L328.647 216.896C328.417 216.732 328.269 216.436 328.269 216.009C328.269 215.582 328.417 215.073 328.664 214.646L339.948 221.165Z",
    fill: "#44464D"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M338.486 221.904C338.486 221.001 339.126 219.901 339.915 219.441C340.703 218.981 341.344 219.343 341.344 220.246C341.344 221.149 340.703 222.249 339.915 222.709C339.126 223.169 338.486 222.807 338.486 221.904Z",
    fill: "#333439"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M308.33 209.178C311.762 207.799 315.507 207.142 319.17 207.044C321.223 206.978 326.282 207.323 324.623 210.591C323.391 213.021 321.683 214.728 319.433 216.239C317.675 217.421 315.491 217.98 313.421 218.374C311.188 218.801 308.872 218.866 306.605 218.554C305.291 218.374 303.944 218.029 302.844 217.274C302.252 216.863 301.612 216.338 301.349 215.648C301.053 214.86 301.579 214.187 302.039 213.563C303.008 212.233 304.322 211.182 305.767 210.394C306.589 209.934 307.459 209.54 308.33 209.178Z",
    fill: "#FFE76B"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M320.238 215.599C318.48 216.781 316.296 217.339 314.226 217.733C311.992 218.16 309.676 218.226 307.41 217.914C306.096 217.733 304.749 217.388 303.648 216.633C303.057 216.223 302.417 215.697 302.154 215.008C301.858 214.219 302.384 213.546 302.844 212.922C303.271 212.331 303.78 211.806 304.322 211.329C303.451 211.97 302.663 212.692 302.039 213.563C301.579 214.186 301.053 214.86 301.349 215.648C301.612 216.338 302.252 216.863 302.844 217.274C303.944 218.029 305.291 218.374 306.605 218.554C308.872 218.866 311.171 218.801 313.421 218.374C315.491 217.98 317.692 217.421 319.433 216.239C320.041 215.829 320.615 215.402 321.141 214.958C320.845 215.172 320.55 215.385 320.238 215.599Z",
    fill: "#FF8C00"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M281.458 203.71C281.967 204.318 282.526 204.876 283.101 205.402C283.922 206.141 286.353 208.423 287.503 207.307C287.798 207.011 287.897 206.584 287.963 206.174C288.833 200.837 287.191 191.888 280.834 190.509C279.454 190.213 278.995 191.445 278.748 192.643C278.272 195.057 278.453 197.75 279.29 200.065C279.767 201.395 280.522 202.627 281.442 203.727L281.458 203.71Z",
    fill: "#FFE76B"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M279.586 197.848C279.865 198.735 280.21 199.605 280.571 200.508C281.294 202.298 282.657 203.907 284.333 204.893C284.513 205.008 284.727 205.106 284.94 205.09C285.318 205.057 285.548 204.646 285.679 204.269C286.369 202.233 285.86 200.114 285.137 198.16C284.267 195.796 283.002 193.398 280.834 192.134C279.405 191.313 278.912 192.873 278.929 194.072C278.962 195.418 279.208 196.65 279.602 197.848H279.586Z",
    fill: "#FDFFAB"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M283.561 204.499C282.969 203.973 282.427 203.415 281.918 202.807C280.998 201.724 280.243 200.492 279.767 199.146C278.945 196.83 278.765 194.137 279.225 191.724C279.274 191.461 279.339 191.215 279.422 190.952C279.077 191.379 278.896 192.003 278.781 192.61C278.305 195.024 278.485 197.717 279.323 200.032C279.799 201.362 280.555 202.594 281.475 203.694C281.984 204.302 282.542 204.86 283.117 205.385C283.938 206.124 286.369 208.407 287.519 207.29C287.749 207.06 287.864 206.748 287.93 206.42C286.764 207.454 284.382 205.221 283.577 204.499H283.561Z",
    fill: "#FF8C00"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M315.803 208.193C315.442 208.21 315.113 208.259 314.834 208.275C313.372 208.39 311.927 208.719 310.514 209.113C308.395 209.687 306.588 210.541 304.798 211.822C303.878 212.479 302.104 214.203 303.287 215.385C303.878 215.96 305.061 216.108 305.849 216.19C307.229 216.338 308.789 216.37 310.12 216.009C312.6 215.352 315.031 214.548 317.051 212.889C318.086 212.035 319.482 210.443 318.628 209.031C318.102 208.177 316.871 208.127 315.803 208.21V208.193Z",
    fill: "#FDFFAB"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M287.716 161.658C286.747 159.491 285.515 157.422 284.053 155.533C283.495 154.811 282.92 154.121 282.181 153.579C280.144 152.069 277.089 152.118 275.085 153.678C274.625 154.039 274.182 154.614 274.396 155.156C274.494 155.418 274.74 155.599 274.954 155.78C277.763 157.996 279.947 160.903 281.738 164.006C283.183 166.502 284.464 169.277 286.879 170.87C286.944 170.903 287.026 170.952 287.076 170.886L288.882 171.773C289.999 168.472 289.129 164.827 287.7 161.642L287.716 161.658Z",
    fill: "#C1C4D6"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M284.694 161.395C286.78 164.236 288.702 167.717 288.997 170.755C289.03 171.05 289.03 171.362 288.932 171.576C288.784 171.888 288.439 171.921 288.127 171.937C285.006 172.036 281.36 170.623 277.878 168.013C277.336 167.602 276.794 167.175 276.301 166.617C275.71 165.96 275.217 165.188 274.773 164.384C273.377 161.806 272.687 158.899 273.065 156.765C273.328 155.27 274.1 154.17 275.266 153.825C276.547 153.464 278.387 154.778 279.832 156.059C281.048 157.126 282.23 158.341 283.331 159.671C283.774 160.213 284.234 160.788 284.678 161.395H284.694Z",
    fill: "#262626"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M291.116 188.045C290.722 188.045 290.393 187.717 290.393 187.323V181.576L287.486 170.821L288.866 170.443L291.822 181.477V187.323C291.822 187.717 291.494 188.045 291.1 188.045H291.116Z",
    fill: "#262626"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 200.049C342.083 199.31 342.28 198.292 342.346 197.323C342.543 194.384 341.787 191.28 339.767 189.146C338.601 187.914 337.057 187.06 335.431 186.584C331.916 185.55 327.842 186.157 325.231 188.932C325.116 189.047 325.001 189.195 324.952 189.343C324.869 189.655 325.083 190.131 325.231 190.41C325.428 190.804 325.691 190.853 326.118 191.083C326.923 191.51 327.678 191.986 328.434 192.463C330.782 193.94 333.197 195.484 334.692 197.799C335.398 198.899 335.973 201.132 337.336 201.609C338.551 202.036 340.67 200.952 341.442 200.049H341.459Z",
    fill: "#C1C4D6"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M328.746 186.798C326.66 187.224 324.738 188.489 324.442 191.198C324.41 191.461 324.41 191.756 324.508 192.085C324.656 192.561 325.001 192.988 325.313 193.382C328.434 197.077 332.08 199.885 335.562 201.28C336.104 201.494 336.646 201.674 337.139 201.707C337.73 201.74 338.223 201.543 338.666 201.231C340.063 200.262 340.752 198.144 340.375 195.582C340.112 193.776 339.34 191.806 338.174 190.114C336.893 188.275 335.053 187.471 333.608 187.077C332.392 186.748 331.21 186.584 330.109 186.65C329.666 186.666 329.206 186.732 328.762 186.814L328.746 186.798Z",
    fill: "#262626"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M318.907 200.771C318.513 200.771 318.185 200.443 318.185 200.049V196.748L324.919 190.164L325.921 191.198L319.63 197.356V200.049C319.63 200.443 319.301 200.771 318.907 200.771Z",
    fill: "#262626"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M289.786 301.756L287.388 305.91L284.661 304.4C284.316 304.235 284.103 303.841 284.103 303.267C284.103 302.183 284.858 300.869 285.794 300.327C286.254 300.065 286.665 300.032 286.977 300.196L289.786 301.772V301.756Z",
    fill: "#C1C4D6"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M288.554 301.855C287.618 302.396 286.862 303.71 286.862 304.794C286.862 305.878 287.618 306.321 288.554 305.779C289.49 305.237 290.246 303.924 290.246 302.84C290.246 301.756 289.49 301.313 288.554 301.855Z",
    fill: "#262626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_358_13776",
    x1: 396.318,
    y1: 448.176,
    x2: 413.196,
    y2: 418.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_358_13776",
    x1: 391.341,
    y1: 445.286,
    x2: 408.203,
    y2: 416.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_358_13776",
    x1: 402.79,
    y1: 451.904,
    x2: 419.667,
    y2: 422.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_358_13776",
    x1: 399.39,
    y1: 449.933,
    x2: 416.267,
    y2: 420.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_358_13776",
    x1: 394.051,
    y1: 449.211,
    x2: 411.963,
    y2: 418.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_358_13776",
    x1: 399.127,
    y1: 449.785,
    x2: 416.004,
    y2: 420.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_358_13776",
    x1: 387.547,
    y1: 378.028,
    x2: 426.589,
    y2: 378.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_358_13776",
    x1: 387.629,
    y1: 349.26,
    x2: 426.655,
    y2: 349.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_358_13776",
    x1: 400.26,
    y1: 350.918,
    x2: 414.051,
    y2: 327.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFD0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_358_13776",
    x1: 394.249,
    y1: 339.605,
    x2: 420.052,
    y2: 339.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_358_13776",
    x1: 403.611,
    y1: 341.986,
    x2: 410.703,
    y2: 329.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFD0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_358_13776",
    x1: 418.508,
    y1: 387.372,
    x2: 425.486,
    y2: 375.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_358_13776",
    x1: 304.503,
    y1: 253.875,
    x2: 301.482,
    y2: 248.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_358_13776",
    x1: 304.273,
    y1: 294.58,
    x2: 301.252,
    y2: 289.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_358_13776",
    x1: 303.813,
    y1: 303.102,
    x2: 265.723,
    y2: 237.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_358_13776",
    x1: 266.506,
    y1: 296.228,
    x2: 293.513,
    y2: 249.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADDE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_358_13776",
    x1: 283.166,
    y1: 293.53,
    x2: 263.678,
    y2: 259.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_358_13776",
    x1: 289.162,
    y1: 305.516,
    x2: 284.22,
    y2: 296.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_358_13776",
    x1: 293.908,
    y1: 262.232,
    x2: 288.95,
    y2: 253.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_358_13776",
    x1: 286.156,
    y1: 310.393,
    x2: 254.715,
    y2: 255.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_358_13776",
    x1: 250.793,
    y1: 302.396,
    x2: 273.647,
    y2: 262.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_358_13776",
    x1: 269.386,
    y1: 301.477,
    x2: 249.914,
    y2: 267.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_358_13776",
    x1: 253.519,
    y1: 303.283,
    x2: 240.401,
    y2: 280.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_358_13776",
    x1: 175.057,
    y1: 402.938,
    x2: 204.823,
    y2: 351.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#7B7D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#848697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9EA0AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B4BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_358_13776",
    x1: 222.263,
    y1: 407.109,
    x2: 180.183,
    y2: 334.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_358_13776",
    x1: 164.315,
    y1: 409.145,
    x2: 194.065,
    y2: 357.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_358_13776",
    x1: 211.521,
    y1: 413.316,
    x2: 169.441,
    y2: 340.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_358_13776",
    x1: 178.737,
    y1: 393.069,
    x2: 170.577,
    y2: 378.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_358_13776",
    x1: 190.152,
    y1: 398.307,
    x2: 171.764,
    y2: 366.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_358_13776",
    x1: 167.305,
    y1: 397.766,
    x2: 180.308,
    y2: 375.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_358_13776",
    x1: 226.697,
    y1: 476.271,
    x2: 232.214,
    y2: 466.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#262F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A4245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_358_13776",
    x1: 236.142,
    y1: 481.427,
    x2: 241.363,
    y2: 472.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#262F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A4245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_358_13776",
    x1: 243.599,
    y1: 489.67,
    x2: 252.366,
    y2: 474.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_358_13776",
    x1: 253.651,
    y1: 495.499,
    x2: 262.402,
    y2: 480.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_358_13776",
    x1: 260.763,
    y1: 499.621,
    x2: 269.514,
    y2: 484.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_358_13776",
    x1: 273.624,
    y1: 507.125,
    x2: 282.391,
    y2: 491.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_358_13776",
    x1: 276.941,
    y1: 516.501,
    x2: 292.227,
    y2: 490.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_358_13776",
    x1: 287.798,
    y1: 520.688,
    x2: 301.245,
    y2: 497.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_358_13776",
    x1: 318.792,
    y1: 526.353,
    x2: 321.567,
    y2: 521.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#262F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A4245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_358_13776",
    x1: 319.909,
    y1: 527.01,
    x2: 322.684,
    y2: 522.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#262F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A4245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_358_13776",
    x1: 303.731,
    y1: 524.678,
    x2: 312.629,
    y2: 509.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_358_13776",
    x1: 491.386,
    y1: 327.536,
    x2: 516.473,
    y2: 284.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#DBDBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#CDCDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C5C5CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_358_13776",
    x1: 488.824,
    y1: 326.042,
    x2: 513.894,
    y2: 282.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B8B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AAAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#A2A2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_358_13776",
    x1: 511.589,
    y1: 301.148,
    x2: 515.693,
    y2: 294.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_358_13776",
    x1: 500.584,
    y1: 297.782,
    x2: 510.369,
    y2: 280.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B8B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AAAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#A2A2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_358_13776",
    x1: 493.948,
    y1: 324.925,
    x2: 500.006,
    y2: 314.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B8B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AAAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#A2A2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_358_13776",
    x1: 515.383,
    y1: 306.452,
    x2: 515.465,
    y2: 306.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B8B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AAAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#A2A2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_358_13776",
    x1: 482.451,
    y1: 321.329,
    x2: 494.337,
    y2: 300.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B8B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AAAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#A2A2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_358_13776",
    x1: 477.063,
    y1: 319.277,
    x2: 502.15,
    y2: 275.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_358_13776",
    x1: 512.229,
    y1: 315.138,
    x2: 490.653,
    y2: 293.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_358_13776",
    x1: 503.146,
    y1: 307.339,
    x2: 499.764,
    y2: 301.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B8B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AAAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#A2A2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_358_13776",
    x1: 502.128,
    y1: 306.173,
    x2: 499.731,
    y2: 302.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_358_13776",
    x1: 468.128,
    y1: 316.616,
    x2: 495.415,
    y2: 269.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_358_13776",
    x1: 484.175,
    y1: 325.943,
    x2: 511.462,
    y2: 278.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_358_13776",
    x1: 443.277,
    y1: 117.537,
    x2: 460.68,
    y2: 87.4011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_358_13776",
    x1: 456.532,
    y1: 122.2,
    x2: 471.308,
    y2: 96.5971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_358_13776",
    x1: 480.069,
    y1: 132.183,
    x2: 491.66,
    y2: 112.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_358_13776",
    x1: 481.892,
    y1: 149.556,
    x2: 515.103,
    y2: 149.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_358_13776",
    x1: 500.255,
    y1: 168.193,
    x2: 514.621,
    y2: 143.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_358_13776",
    x1: 478.854,
    y1: 104.663,
    x2: 516.204,
    y2: 104.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_358_13776",
    x1: 489.497,
    y1: 114.236,
    x2: 485.293,
    y2: 111.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B37635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BE843D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CA9645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3B655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EBCA6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F1D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F5E28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F7E68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6E48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3E084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EDDA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6D162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2CB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#DFBD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9A350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_358_13776",
    x1: 490.236,
    y1: 104.22,
    x2: 493.8,
    y2: 106.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B37635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B47736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B97E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#BE843D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA9645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F7E68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F5E38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F2DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBCD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#E2B964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9A350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_358_13776",
    x1: 476.883,
    y1: 115.78,
    x2: 518.257,
    y2: 115.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_358_13776",
    x1: 454.38,
    y1: 92.8569,
    x2: 459.749,
    y2: 83.5617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_358_13776",
    x1: 522.462,
    y1: 189.326,
    x2: 544.298,
    y2: 151.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_358_13776",
    x1: 507.909,
    y1: 185.5,
    x2: 533.653,
    y2: 140.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_358_13776",
    x1: 462.938,
    y1: 135.008,
    x2: 467.206,
    y2: 127.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_358_13776",
    x1: 465.829,
    y1: 134.154,
    x2: 474.862,
    y2: 134.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_358_13776",
    x1: 471.38,
    y1: 139.885,
    x2: 475.649,
    y2: 132.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_358_13776",
    x1: 477.31,
    y1: 138.637,
    x2: 478.738,
    y2: 136.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B37635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BE843D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CA9645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3B655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EBCA6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F1D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F5E28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F7E68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6E48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3E084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EDDA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6D162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2CB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#DFBD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9A350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_358_13776",
    x1: 479.888,
    y1: 140.295,
    x2: 481.497,
    y2: 137.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B37635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BE843D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CA9645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3B655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EBCA6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F1D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F5E28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F7E68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6E48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3E084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EDDA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6D162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2CB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#DFBD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9A350"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdred);
export default __webpack_public_path__ + "static/media/prodred.23bf3fb33ea52bcb2824affd1c5c2b35.svg";
export { ForwardRef as ReactComponent };